// Generated by KlangScriptProcessor, DO NOT EDIT
@file:Suppress("UnusedImport")

package io.peekandpoke.klang.script.generated

import io.peekandpoke.klang.script.annotations.KlangScope
import io.peekandpoke.klang.script.types.*

private val kt0 = KlangType(simpleName = "Math", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptMath")
private val kt1 = KlangType(simpleName = "Number", fqcn = "io.peekandpoke.klang.script.runtime.NumberValue")
private val kt2 = KlangType(simpleName = "IgnitorDsl", fqcn = "io.peekandpoke.klang.audio_bridge.IgnitorDsl")
private val kt3 = KlangType(simpleName = "KatalystBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystBuilder")
private val kt4 = KlangType(simpleName = "KatalystKnobDsl", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystKnobDsl")
private val kt5 = KlangType(simpleName = "IgnitorDslLike", fqcn = "io.peekandpoke.klang.script.stdlib.IgnitorDslLike", isTypeAlias = true)
private val kt6 = KlangType(simpleName = "Array", fqcn = "io.peekandpoke.klang.script.runtime.ArrayValue")
private val kt7 = KlangType(simpleName = "Any", fqcn = "kotlin.Any")
private val kt8 = KlangType(simpleName = "AdsrBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.AdsrBuilder")
private val kt9 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt8), functionReturn = kt8)
private val kt10 = KlangType(simpleName = "FilterBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.FilterBuilder")
private val kt11 = KlangType(simpleName = "ModAdsrBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.ModAdsrBuilder")
private val kt12 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt11), functionReturn = kt11)
private val kt13 = KlangType(simpleName = "BandFilterBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.BandFilterBuilder")
private val kt14 = KlangType(simpleName = "PitchEnvelopeBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.PitchEnvelopeBuilder")
private val kt15 = KlangType(simpleName = "FmBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.FmBuilder")
private val kt16 = KlangType(simpleName = "OscSineBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSineBuilder")
private val kt17 = KlangType(simpleName = "OscTriBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscTriBuilder")
private val kt18 = KlangType(simpleName = "OscZawtoothBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscZawtoothBuilder")
private val kt19 = KlangType(simpleName = "OscZampBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscZampBuilder")
private val kt20 = KlangType(simpleName = "OscImpulseBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscImpulseBuilder")
private val kt21 = KlangType(simpleName = "OscPulzeBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscPulzeBuilder")
private val kt22 = KlangType(simpleName = "OscSquareBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSquareBuilder")
private val kt23 = KlangType(simpleName = "OscSawBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSawBuilder")
private val kt24 = KlangType(simpleName = "OscRampBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscRampBuilder")
private val kt25 = KlangType(simpleName = "OscSuperSawBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperSawBuilder")
private val kt26 = KlangType(simpleName = "OscSuperSineBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperSineBuilder")
private val kt27 = KlangType(simpleName = "OscSuperSquareBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperSquareBuilder")
private val kt28 = KlangType(simpleName = "OscSuperTriBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperTriBuilder")
private val kt29 = KlangType(simpleName = "OscSuperRampBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperRampBuilder")
private val kt30 = KlangType(simpleName = "OscPluckBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscPluckBuilder")
private val kt31 = KlangType(simpleName = "OscSuperPluckBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.OscSuperPluckBuilder")
private val kt32 = KlangType(simpleName = "IgnitorBandsBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.IgnitorBandsBuilder")
private val kt33 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", functionParams = listOf(kt2), functionReturn = kt2)
private val kt34 = KlangType(simpleName = "KatalystBandsBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystBandsBuilder")
private val kt35 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", functionParams = listOf(kt3), functionReturn = kt3)
private val kt36 = KlangType(simpleName = "EqBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.EqBuilder")
private val kt37 = KlangType(simpleName = "KatalystEqBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystEqBuilder")
private val kt38 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt13), functionReturn = kt13)
private val kt39 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt32), functionReturn = kt32)
private val kt40 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt34), functionReturn = kt34)
private val kt41 = KlangType(simpleName = "Ignitor", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitor")
private val kt42 = KlangType(simpleName = "Katalyst", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalyst")
private val kt43 = KlangType(simpleName = "IgnitorDslLike", fqcn = "io.peekandpoke.klang.script.stdlib.IgnitorDslLike", isTypeAlias = true, isNullable = true)
private val kt44 = KlangType(simpleName = "KatalystBodyBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystBodyBuilder")
private val kt45 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt44), functionReturn = kt44)
private val kt46 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt3), functionReturn = kt3)
private val kt47 = KlangType(simpleName = "KatalystDsl", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystDsl")
private val kt48 = KlangType(simpleName = "KatalystDelayBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystDelayBuilder")
private val kt49 = KlangType(simpleName = "String", fqcn = "io.peekandpoke.klang.script.runtime.StringValue")
private val kt50 = KlangType(simpleName = "RuntimeValue", fqcn = "io.peekandpoke.klang.script.runtime.RuntimeValue")
private val kt51 = KlangType(simpleName = "String", fqcn = "io.peekandpoke.klang.script.runtime.StringValue", supertypes = listOf(kt50))
private val kt52 = KlangType(simpleName = "Number", fqcn = "io.peekandpoke.klang.script.runtime.NumberValue", isNullable = true)
private val kt53 = KlangType(simpleName = "Boolean", fqcn = "io.peekandpoke.klang.script.runtime.BooleanValue", supertypes = listOf(kt50))
private val kt54 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt48), functionReturn = kt48)
private val kt55 = KlangType(simpleName = "Array", fqcn = "io.peekandpoke.klang.script.runtime.ArrayValue", supertypes = listOf(kt50))
private val kt56 = KlangType(simpleName = "KatalystSquareBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystSquareBuilder")
private val kt57 = KlangType(simpleName = "Object", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptObjectUtility")
private val kt58 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt36), functionReturn = kt36)
private val kt59 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt37), functionReturn = kt37)
private val kt60 = KlangType(simpleName = "PhaserBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.PhaserBuilder")
private val kt61 = KlangType(simpleName = "ShimmerBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.ShimmerBuilder")
private val kt62 = KlangType(simpleName = "KatalystVowelBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystVowelBuilder")
private val kt63 = KlangType(simpleName = "KatalystPhaserBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystPhaserBuilder")
private val kt64 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt15), functionReturn = kt15)
private val kt65 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt10), functionReturn = kt10)
private val kt66 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt20), functionReturn = kt20)
private val kt67 = KlangType(simpleName = "Number", fqcn = "io.peekandpoke.klang.script.runtime.NumberValue", supertypes = listOf(kt50))
private val kt68 = KlangType(simpleName = "VibratoBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.VibratoBuilder")
private val kt69 = KlangType(simpleName = "KatalystSineBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystSineBuilder")
private val kt70 = KlangType(simpleName = "KatalystSawBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystSawBuilder")
private val kt71 = KlangType(simpleName = "KatalystRampBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystRampBuilder")
private val kt72 = KlangType(simpleName = "KatalystTriBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.KatalystTriBuilder")
private val kt73 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt60), functionReturn = kt60)
private val kt74 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt63), functionReturn = kt63)
private val kt75 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt14), functionReturn = kt14)
private val kt76 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt30), functionReturn = kt30)
private val kt77 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt21), functionReturn = kt21)
private val kt78 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt24), functionReturn = kt24)
private val kt79 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt71), functionReturn = kt71)
private val kt80 = KlangType(simpleName = "TremoloBuilder", fqcn = "io.peekandpoke.klang.audio_bridge.TremoloBuilder")
private val kt81 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt23), functionReturn = kt23)
private val kt82 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt70), functionReturn = kt70)
private val kt83 = KlangType(simpleName = "Any", fqcn = "kotlin.Any", isNullable = true)
private val kt84 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt61), functionReturn = kt61)
private val kt85 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt16), functionReturn = kt16)
private val kt86 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt69), functionReturn = kt69)
private val kt87 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt22), functionReturn = kt22)
private val kt88 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt56), functionReturn = kt56)
private val kt89 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt31), functionReturn = kt31)
private val kt90 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt29), functionReturn = kt29)
private val kt91 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt25), functionReturn = kt25)
private val kt92 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt26), functionReturn = kt26)
private val kt93 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt27), functionReturn = kt27)
private val kt94 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt28), functionReturn = kt28)
private val kt95 = KlangType(simpleName = "Boolean", fqcn = "io.peekandpoke.klang.script.runtime.BooleanValue")
private val kt96 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt80), functionReturn = kt80)
private val kt97 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt17), functionReturn = kt17)
private val kt98 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt72), functionReturn = kt72)
private val kt99 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt68), functionReturn = kt68)
private val kt100 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt62), functionReturn = kt62)
private val kt101 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt19), functionReturn = kt19)
private val kt102 = KlangType(simpleName = "Function1", fqcn = "kotlin.Function1", isNullable = true, functionParams = listOf(kt18), functionReturn = kt18)
private val kt103 = KlangType(simpleName = "KlangScriptIgnitorSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorSlots")
private val kt104 = KlangType(simpleName = "KlangScriptIgnitorAdsrSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrSlots")
private val kt105 = KlangType(simpleName = "KlangScriptIgnitorAdsrCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorAdsrCurvesSlots")
private val kt106 = KlangType(simpleName = "KlangScriptIgnitorDistortSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorDistortSlots")
private val kt107 = KlangType(simpleName = "KlangScriptIgnitorFmSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorFmSlots")
private val kt108 = KlangType(simpleName = "KlangScriptIgnitorPenvSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvSlots")
private val kt109 = KlangType(simpleName = "KlangScriptIgnitorPenvCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorPenvCurvesSlots")
private val kt110 = KlangType(simpleName = "KlangScriptIgnitorHpfSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfSlots")
private val kt111 = KlangType(simpleName = "KlangScriptIgnitorBpfSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfSlots")
private val kt112 = KlangType(simpleName = "KlangScriptIgnitorNotchSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchSlots")
private val kt113 = KlangType(simpleName = "KlangScriptIgnitorLpfSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfSlots")
private val kt114 = KlangType(simpleName = "KlangScriptIgnitorHpfCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorHpfCurvesSlots")
private val kt115 = KlangType(simpleName = "KlangScriptIgnitorBpfCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorBpfCurvesSlots")
private val kt116 = KlangType(simpleName = "KlangScriptIgnitorNotchCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorNotchCurvesSlots")
private val kt117 = KlangType(simpleName = "KlangScriptIgnitorLpfCurvesSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorLpfCurvesSlots")
private val kt118 = KlangType(simpleName = "KlangScriptKatalystCompressorSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystCompressorSlots")
private val kt119 = KlangType(simpleName = "KlangScriptKatalystDuckSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDuckSlots")
private val kt120 = KlangType(simpleName = "KlangScriptIgnitorCrushSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCrushSlots")
private val kt121 = KlangType(simpleName = "KlangScriptKatalystSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystSlots")
private val kt122 = KlangType(simpleName = "KlangScriptKatalystBodySlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystBodySlots")
private val kt123 = KlangType(simpleName = "KlangScriptKatalystDelaySlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystDelaySlots")
private val kt124 = KlangType(simpleName = "KlangScriptKatalystPhaserSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystPhaserSlots")
private val kt125 = KlangType(simpleName = "KlangScriptIgnitorCoarseSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorCoarseSlots")
private val kt126 = KlangType(simpleName = "KlangScriptIgnitorTremoloSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorTremoloSlots")
private val kt127 = KlangType(simpleName = "KlangScriptKatalystVowelSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystVowelSlots")
private val kt128 = KlangType(simpleName = "KlangScriptKatalystGainSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystGainSlots")
private val kt129 = KlangType(simpleName = "KlangScriptKatalystReverbSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptKatalystReverbSlots")
private val kt130 = KlangType(simpleName = "KlangScriptIgnitorVibratoSlots", fqcn = "io.peekandpoke.klang.script.stdlib.KlangScriptIgnitorVibratoSlots")

private fun generatedStdlibDocsChunk0() = mapOf(

    "abs" to KlangSymbol(
        name = "abs",
        category = "math",
        tags = listOf("arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "abs",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The number"""),
                ),
                returnType = kt1,
                description = """Returns the absolute value of a number.""",
                returnDoc = """The absolute value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.abs(-5)  // 5.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Absolute value of this signal (full-wave rectification).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the absolute value of the number.""",
                returnDoc = """The absolute value""",
                samples = listOf(
                    KlangCodeSample(code = """(-8).abs()  // 8""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt3,
                params = emptyList(),
                returnType = kt3,
                description = """The absolute value of every sample: full-wave rectification. On a tone it sounds an octave up, with a DC offset that
 the output removes.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Katalyst(k => k.abs().distort(0.4))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "abs",
                receiver = kt4,
                params = emptyList(),
                returnType = kt4,
                description = """The absolute value of this knob.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "accelerate" to KlangSymbol(
        name = "accelerate",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "accelerate",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "semitones", type = kt5),
                ),
                returnType = kt2,
                description = """Applies a pitch glide of [semitones] from the onset to the gate close, held through the release.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "add" to KlangSymbol(
        name = "add",
        category = "array",
        tags = listOf("mutating"),
        aliases = listOf("plus"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "add",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "item", type = kt7, description = """The element to add"""),
                ),
                returnType = kt1,
                description = """Adds an element to the end of the array. Returns the new size.""",
                returnDoc = """The new size of the array""",
                samples = listOf(
                    KlangCodeSample(code = """let a = [1, 2]
a.add(3)
a.joinToString(", ")  // "1, 2, 3"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "add",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Adds two ignitor signals together (summing). Alias for [plus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "add",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Adds [other] to every sample of the bus. Alias for [plus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "add",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob plus [other]. Alias for [plus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "adsr" to KlangSymbol(
        name = "adsr",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "adsr",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "attack", type = kt5),
                    KlangParam(name = "decay", type = kt5),
                    KlangParam(name = "sustain", type = kt5),
                    KlangParam(name = "release", type = kt5),
                    KlangParam(name = "configure", type = kt9, isOptional = true, defaultDoc = """null""", description = """receives the [AdsrBuilder] (knobs: `curves`, `declick`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies an ADSR amplitude envelope: attack, decay and release in seconds, the sustain as a
 level 0 to 1. All four accept a Number or an IgnitorDsl. The lambda receives an [AdsrBuilder]
 whose knobs shape the stages and de-click the gain:


 Unshaped stages are exponential, every amplitude envelope's default, and every exponential
 stage bends at the engine's one curvature.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().adsr(0.01, 0.3, 0.5, 0.2)
Ignitor.saw().adsr(0.005, 1.0, 0.0, 0.03, e => e.curves("linear", "linear", "linear"))
Ignitor.sine().adsr(0.001, 0.4, 0.0, 0.1, e => e.declick(0.0005))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt10,
                params = listOf(
                    KlangParam(name = "attack", type = kt5),
                    KlangParam(name = "decay", type = kt5),
                    KlangParam(name = "sustain", type = kt5),
                    KlangParam(name = "release", type = kt5),
                    KlangParam(name = "configure", type = kt12, isOptional = true, defaultDoc = """null""", description = """receives the [ModAdsrBuilder] (knob: `curves`) and returns it."""),
                ),
                returnType = kt10,
                description = """The cutoff envelope, ONE call, the chain `adsr`'s shape: attack, decay, sustain (a share of
 `env`, 0 to 1) and release in seconds, and a lambda on a [ModAdsrBuilder] that shapes the stages
 with `curves` (unshaped stages are `"exp"`, decision D3):
 `.lowpass(800, 1.2, x => x.env(24).adsr(0.01, 0.3, 0.2, 0.5, e => e.curves("lin", "exp", "exp")))`.
 Switches the envelope on; without `env` the depth fills from the constants. A later `adsr` call
 replaces an earlier one completely, curves included. The release does NOT extend the voice's life.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt13,
                params = listOf(
                    KlangParam(name = "attack", type = kt5),
                    KlangParam(name = "decay", type = kt5),
                    KlangParam(name = "sustain", type = kt5),
                    KlangParam(name = "release", type = kt5),
                    KlangParam(name = "configure", type = kt12, isOptional = true, defaultDoc = """null""", description = """receives the [ModAdsrBuilder] (knob: `curves`) and returns it."""),
                ),
                returnType = kt13,
                description = """The cutoff envelope, one call with its `curves` lambda; see `FilterBuilder.adsr`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt14,
                params = listOf(
                    KlangParam(name = "attack", type = kt5),
                    KlangParam(name = "decay", type = kt5),
                    KlangParam(name = "sustain", type = kt5),
                    KlangParam(name = "release", type = kt5),
                    KlangParam(name = "configure", type = kt12, isOptional = true, defaultDoc = """null""", description = """receives the [ModAdsrBuilder] (knob: `curves`) and returns it."""),
                ),
                returnType = kt14,
                description = """The pitch envelope, ONE call, the chain `adsr`'s shape: the pitch rises to `semitones` over the
 attack, falls to the sustain (a share of `semitones`, default 0 = the note) over the decay, holds,
 and from the gate's end returns to the note over the release. The lambda shapes the stages with
 `curves`, the filters' rules (unshaped stages are `"exp"`, decision D3):
 `.pitchEnvelope(24, x => x.adsr(0.001, 0.04, 0, 0, e => e.curves("lin", "exp", "exp")))`.
 Defaults without this call: `adsr(0.01, 0.1, 0, 0)`, exponential. A later `adsr` call replaces an
 earlier one completely, curves included. The release does NOT extend the voice's life.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "adsr",
                receiver = kt15,
                params = listOf(
                    KlangParam(name = "attack", type = kt5),
                    KlangParam(name = "decay", type = kt5),
                    KlangParam(name = "sustain", type = kt5),
                    KlangParam(name = "release", type = kt5),
                ),
                returnType = kt15,
                description = """The modulation INDEX envelope: the depth rises over the attack, falls to the sustain (a share of
 `depth`) over the decay, holds, and releases from the gate's end. Without this call the depth is
 constant, which is `adsr(0, 0, 1, 0)`. The built-in `sgbell` is `adsr(0.001, 0.5, 0, 0.05)`. Its
 stages are exponential (decision D3), and it takes no lambda yet: the FM index envelope has no curve
 support (a filed follow-up adds `curves` when it has), and a knob that does nothing is not offered.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "analog" to KlangSymbol(
        name = "analog",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "analog",
                receiver = kt10,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt10,
                description = """Analog character, 0..10. `0` (the default) is the clean linear filter; higher values engage
 OB-X-style state-dependent damping that compresses the resonance peak, 1 to 3 is Diva-default
 warmth. It also scales [humanize]. Every cascade stage gets the full drive.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt13,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt13,
                description = """The analog SATURATION is not implemented for this tap and the value does not reach it. The value
 is NOT inert, though: it scales [humanize]'s per-voice tolerance and drift lane (as it did on the
 retired voice strip's band filter), so `analog = 0` on a humanized band filter switches the lane off and stops
 its four build-time rng draws, which shifts every later noise source on that voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt16,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on. With partial banks, the depth of every partial.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt17,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt17,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt18,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt18,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt19,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt19,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt20,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt20,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt21,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt21,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt22,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt23,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt23,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt24,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt24,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt25,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt26,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt27,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt28,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt29,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt30,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt30,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analog",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "character", type = kt5),
                ),
                returnType = kt31,
                description = """How analog the oscillator is, a unitless character scale: 0 ideal (perfectly stable), 1 to 8 usual, 10 strong; its tell is the pitch drift, about one cent of peak per unit. Latches at note-on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "analogSpread" to KlangSymbol(
        name = "analogSpread",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "analogSpread",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt16,
                description = """How much the partials drift against each other under `analog`, 0 to 1. `1` (default): every partial walks on
 its own lane, the slow beating of a hand-stacked set of sines. `0`: one shared walk, the bank wobbles as a
 single physical oscillator and its ratios stay exact. Between is a blend. Nothing happens while
 `analog` is 0. Named apart from the supersaw's `spread`, which is static unison detune.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.harmonics(7).analog(3).analogSpread(0))   // one drifting oscillator with seven harmonics""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt25,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt26,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt27,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt28,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt29,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "analogSpread",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt31,
                description = """How much the voices drift against each other under `analog`, 0 to 1. `1` (default): every voice walks
  on its own lane, the organic unison of separate oscillators. `0`: one shared walk, the stack wobbles as
  a single oscillator and its unison detune stays static. Between is a blend. Nothing happens while
  `analog` is 0. Same knob as on `Ignitor.sine`; named apart from `spread`, which is the static unison detune.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "band" to KlangSymbol(
        name = "band",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "band",
                receiver = kt32,
                params = listOf(
                    KlangParam(name = "processor", type = kt33, description = """a function from the band's signal to a signal."""),
                ),
                returnType = kt32,
                description = """Adds [processor] to the band being written. Two `band()` calls on one band SUM their processors, as `parallel` does;
 a band with no `band()` passes untouched.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "band",
                receiver = kt34,
                params = listOf(
                    KlangParam(name = "processor", type = kt35, description = """a function from a builder to a builder."""),
                ),
                returnType = kt34,
                description = """Adds [processor] to the band being written: a function of stages that receives an empty builder, the band at this
 point, as a `parallel` branch does. Two `band()` calls on one band SUM their processors; a band with no `band()`
 passes untouched.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "band",
                receiver = kt36,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "db", type = kt5, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt36,
                description = """Adds a peaking band: [db] decibels of gain at [freq], [q] the width. Bands apply one after
 another, so two overlapping bands compound.

 `db = 0` is exactly transparent, negative [db] cuts, and a cut mirrors the same boost exactly,
 so a `+6` and a `-6` band at the same [freq] and [q] cancel out. The width does NOT move as
 [db] changes (that is the point of this parameterization): at the default [q] it holds at
 1.90 octaves all the way from -6 to -34 dB. Past that the internal width hits its floor and
 deeper cuts DO start narrowing (1.39 octaves at -40 dB, about 0.45 at -60).

 The second positional argument is [q], NOT gain: `band(1200, 6)` sets a width of 6 and leaves
 gain at 0, which is silent. Write `band(freq = 1200, db = 6)` when you mean gain: KlangScript
 forbids mixing positional and named args, so name them all.

 All three values are read once per block and shape the filter coefficients, [db] included,
 so an LFO on [db] zippers just like an LFO on a cutoff. For a smooth gain ride use a VCA
 instead. See [tap] for the parallel alternative.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "band",
                receiver = kt37,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "db", type = kt5, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt37,
                description = """Adds a peaking band to the chain's equalizer: the voice eq's `band`, the same section and the same defaults
 ([db] decibels at [freq], [q] the width; `db = 0` is transparent, a cut mirrors the same boost, the second positional
 argument is [q], not gain). Each value is a number or a Katalyst param (`Katalyst.param`, `Katalyst.slot.*`), which
 listens to `katp`; a Katalyst expression (`Kat.sine(0.1).range(200, 400)`) is a script error: a section reads a
 number or a slot, once per block, never a moving knob.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "bandpass" to KlangSymbol(
        name = "bandpass",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "bandpass",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "configure", type = kt38, isOptional = true, defaultDoc = """null""", description = """receives the [BandFilterBuilder] (knobs: `analog`, `humanize`, `env`, `adsr`) and returns it."""),
                ),
                returnType = kt2,
                description = """SVF bandpass filter. Passes frequencies near the cutoff, attenuates others. The knobs are
 [lowpass]'s without `passes`, on a [BandFilterBuilder]; its `analog` scales `humanize` only
 (the saturation is not implemented for this tap).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk1() = mapOf(

    "bands" to KlangSymbol(
        name = "bands",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "bands",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "configure", type = kt39, isOptional = true, defaultDoc = """null""", description = """receives the bands builder and returns it."""),
                ),
                returnType = kt2,
                description = """Splits this signal into frequency BANDS, processes each band on its own and sums them again: multiband
 distortion, a saturated mid range over a clean low end, an exciter on the highs. Read from the bottom up:


 `band(f)` adds a processor to the band being written (two on one band are summed), `cut(freq)` closes it and
 starts the next one up; a band with no `band()` passes untouched, and a cut below the one before it is moved up
 to it. The crossover is Linkwitz-Riley: with nothing processed the bands sum to flat level, with the phase
 turned around each cut (the waveform changes, the balance does not). Every band reads the same signal, built
 once; a late band (an oversampling region) is matched by delaying the others, as in `parallel`. With no
 `configure`, or no `cut`, it is the one band.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the lows clean, the mids crunchy, the highs untouched
Ignitor.saw().bands(b => b.cut(250).band(mid => mid.distort(0.4)).cut(3000))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "bands",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "configure", type = kt40, isOptional = true, defaultDoc = """null""", description = """receives the bands builder and returns it."""),
                ),
                returnType = kt3,
                description = """Splits the bus into frequency BANDS from this position, processes each band on its own and sums them again: the
 master's distortion on the mids only, a compressor on the lows. Read from the bottom up:


 `band(f)` adds a processor to the band being written, a function of stages from an empty builder, as a `parallel`
 branch (two on one band are summed); `cut(freq)` closes the band and starts the next one up; a band with no
 `band()` passes untouched, and a cut below the one before it is moved up to it. The crossover is Linkwitz-Riley: with
 nothing processed the bands sum to flat level, with the phase turned around each cut. A late band is matched by
 delaying the others. With no `configure`, or no `cut`, it is the one band, its stages in place.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// glue the mids, leave the kick and the hats alone
Katalyst(k => k.bands(b => b.cut(150).band(mid => mid.distort(0.15)).cut(5000)).limiter())""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "berlin" to KlangSymbol(
        name = "berlin",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "berlin",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "rate", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """walk speed (default 1.0)."""),
                    KlangParam(name = "octaves", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """fBm octaves: 1 = plain (default), higher = more detail (capped at 8)."""),
                    KlangParam(name = "persistence", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """fBm amplitude falloff per octave (default 0.5)."""),
                ),
                returnType = kt2,
                description = """Creates a Berlin noise source (piecewise-linear interpolated noise).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "berlin",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "rate", type = kt5, description = """the walk's speed, required, in [perlin]'s unit."""),
                    KlangParam(name = "octaves", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """fBm octaves: 1 = plain (default), higher = more detail (capped at 8)."""),
                    KlangParam(name = "persistence", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """fBm amplitude falloff per octave (default 0.5)."""),
                ),
                returnType = kt4,
                description = """A Berlin noise walk for a chain knob: piecewise-linear drift in about `-1..1`, the Ignitor's `berlin`, seeded by
 its position in the chain as [perlin] is.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the delay's wet wanders between 0.1 and 0.4
Katalyst(k => k.delay(Kat.berlin(0.002).range(0.1, 0.4), 0.25, 0.4))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "blend" to KlangSymbol(
        name = "blend",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "blend",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "wet", type = kt5, description = """the share of the branch, 0 to 1."""),
                    KlangParam(name = "branch", type = kt33, description = """a function from the signal to a signal."""),
                ),
                returnType = kt2,
                description = """A dry/wet blend, the linear law: `x.blend(wet, f)` is `x.parallel(d => d.mul(1 - wet), w => f(w).mul(wet))`, so 0 is
 the dry signal and 1 is the branch alone. `wet` comes first, as on every door with one.


 Linear is right for a branch that stays correlated with the dry (distortion, filters). [wet] may be a number, a
 slot or a signal (an LFO moves the blend); a number that is not finite reads as 0. The branch is checked as a
 `parallel` branch is, and a late branch is aligned the same way.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// a quarter of a hard distortion under the clean string
let edge = x => x.blend(0.25, y => y.distort(0.6, "hard"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "blend",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt5, description = """the share of the branch, 0 to 1."""),
                    KlangParam(name = "branch", type = kt35, description = """a function from a builder to a builder, given an empty one."""),
                ),
                returnType = kt3,
                description = """A dry/wet blend of the bus, the linear law: `k.blend(wet, f)` sums the bus times `1 - wet` with [branch]'s stages
 times `wet` (a `parallel` of two). The branch receives an empty builder, the bus at this position, as a `parallel`
 branch does. `wet` comes first, as on every door with one.


 Linear is right for a branch correlated with the dry (distortion, compression, filters). A `reverb` or `delay` in the
 branch carries the dry as well (it adds its return on top), so `blend(w, b => b.reverb(1, 7))` is the dry plus `w`
 of the room. [wet] is a plain number here, where the Ignitor's may be a slot or a signal (recorded asymmetry):
 `1 - wet` needed arithmetic a Katalyst param did not have until step 4 of
 KLANG-00302 (katalyst knob expressions), and taking a `Kat.param` or a Kat expression here is its
 follow-up Q14 (KLANG-00303 (katalyst knob followups) section 4). A number that is not finite reads as 0. Any
 Ignitor node
 is refused, `Ignitor.constant(...)` included (it was accepted until step 3 of
 KLANG-00302 (katalyst knob expressions),
 2026-10-12, when the Katalyst knobs stopped taking Ignitor nodes).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// a third of a crushed copy of the bus under the clean one
Katalyst(k => k.blend(0.3, b => b.distort(0.6, "hard")))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "body" to KlangSymbol(
        name = "body",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "body",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt43, isOptional = true, defaultDoc = """null""", description = """how much of the orbit runs through the body, 0 to 1 (default 0.5). Orbit twin: `body(wet = ...)`."""),
                    KlangParam(name = "material", type = kt43, isOptional = true, defaultDoc = """null""", description = """a material name (`"wood"`, `"glass"`, `"tube"`, ...), an index into the catalogue, or a `Katalyst.param` slot carrying one; omitted leaves the stage off. Orbit twin: `body(material = "wood")`, or `katp("body.material", n)` for the number."""),
                    KlangParam(name = "configure", type = kt45, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystBodyBuilder] (knob: `floor`) and returns it."""),
                ),
                returnType = kt3,
                description = """Appends a resonant body: a bank of narrow modes over a broadband floor, the box a sound sits in.

 A material NAME is converted to the stage's `material` INDEX here, through the one shared
 `BodyMaterials.indexOf`, so a chain and a pattern mean the same box by the same word. An unknown
 name is `none`, and so is no material at all: the stage is declared and off.

 **Why [material] takes more than a name.** The material is an index slot (Katalyst step 5a-2,
 2026-09-18), so a chain that wants it to MOVE writes `k.body(material = Katalyst.param("mat", 3))`
 and listens to `katp("mat", n)`, and a plain number picks a fixed box by its index. The door
 therefore accepts a name, a number or a slot; anything else is a script-level type error.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "brightness" to KlangSymbol(
        name = "brightness",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "brightness",
                receiver = kt30,
                params = listOf(
                    KlangParam(name = "brightness", type = kt5),
                ),
                returnType = kt30,
                description = """Initial-burst brightness / pick hardness (default 0.5). 0 = mellow, 1 = bright.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "brightness",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "brightness", type = kt5),
                ),
                returnType = kt31,
                description = """Initial-burst brightness / pick hardness (default 0.5). 0 = mellow, 1 = bright.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "brownnoise" to KlangSymbol(
        name = "brownnoise",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "brownnoise",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "leak", type = kt5, isOptional = true, defaultDoc = """0.02""", description = """per-sample white-leak (default 0.02): lower = deeper/slower brown, higher = brighter."""),
                ),
                returnType = kt2,
                description = """Creates a brown noise source (1/f^2 spectrum, deeper). Each call yields a fresh DSL instance.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "build" to KlangSymbol(
        name = "build",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "build",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "configure", type = kt46, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystBuilder] and returns it."""),
                ),
                returnType = kt47,
                description = """Builds a chain (for an orbit or the output): the lambda receives a [KatalystBuilder] and appends stages in order
 (`body`, `vowel`, `delay`, `reverb`, `phaser`, `compressor`, `limiter`, `duck`, `distort`, `eq`, `gain`, and
 `classic` for the whole familiar block at once, at most once per builder). No lambda, or an
 empty one, is the empty chain.

 ```
 katalyst(Katalyst.build(k => k.reverb(0.2).gain(1.4)))
 ```""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "cap" to KlangSymbol(
        name = "cap",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "cap",
                receiver = kt48,
                params = listOf(
                    KlangParam(name = "cap", type = kt5),
                ),
                returnType = kt48,
                description = """Level the recirculating signal saturates toward (default 1.0): how loud the echoes settle once the
 feedback is above 1.0. Up to 95% of it the echoes pass untouched, so at a feedback of 1.0 or less it
 acts only on echoes loud enough to reach it. Orbit twin: `delay(cap = ...)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk2() = mapOf(

    "ceil" to KlangSymbol(
        name = "ceil",
        category = "math",
        tags = listOf("rounding"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "ceil",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The number to ceil"""),
                ),
                returnType = kt1,
                description = """Rounds a number up to the nearest integer.""",
                returnDoc = """The ceiling value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.ceil(3.2)  // 4.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "ceil",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample ceiling.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "ceil",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Rounds the number up to the nearest integer.""",
                returnDoc = """The ceiling value""",
                samples = listOf(
                    KlangCodeSample(code = """3.2.ceil()  // 4""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "centerJitter" to KlangSymbol(
        name = "centerJitter",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "centerJitter",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "centerJitter", type = kt1),
                ),
                returnType = kt25,
                description = """Fraction of `gainJitter` the on-pitch center voice gets: 0 = stable center, 1 = jittered like the sides.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "centerJitter",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "centerJitter", type = kt1),
                ),
                returnType = kt26,
                description = """Fraction of `gainJitter` the on-pitch center voice gets: 0 = stable center, 1 = jittered like the sides.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "centerJitter",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "centerJitter", type = kt1),
                ),
                returnType = kt27,
                description = """Fraction of `gainJitter` the on-pitch center voice gets: 0 = stable center, 1 = jittered like the sides.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "centerJitter",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "centerJitter", type = kt1),
                ),
                returnType = kt28,
                description = """Fraction of `gainJitter` the on-pitch center voice gets: 0 = stable center, 1 = jittered like the sides.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "centerJitter",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "centerJitter", type = kt1),
                ),
                returnType = kt29,
                description = """Fraction of `gainJitter` the on-pitch center voice gets: 0 = stable center, 1 = jittered like the sides.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "cents" to KlangSymbol(
        name = "cents",
        category = "number",
        tags = listOf("music", "pitch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "cents",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the number as cents and returns the frequency ratio: 2^(self / 1200).

 A cent is a hundredth of a semitone, the unit for fine detuning.""",
                returnDoc = """The frequency ratio""",
                samples = listOf(
                    KlangCodeSample(code = """50.cents()  // 1.0293, a quarter tone up""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "charAt" to KlangSymbol(
        name = "charAt",
        category = "string",
        tags = listOf("access"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "charAt",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "index", type = kt1, description = """The zero-based index"""),
                ),
                returnType = kt51,
                description = """Returns the character at the given index, or an empty string if out of bounds.""",
                returnDoc = """The character at the index""",
                samples = listOf(
                    KlangCodeSample(code = """"hello".charAt(1)  // "e"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "clamp" to KlangSymbol(
        name = "clamp",
        category = "number",
        tags = listOf("comparison", "range"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "clamp",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "lo", type = kt5),
                    KlangParam(name = "hi", type = kt5),
                ),
                returnType = kt2,
                description = """Bounds this signal to the range `[lo, hi]` per sample.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "clamp",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "lo", type = kt1, description = """The lower bound"""),
                    KlangParam(name = "hi", type = kt1, description = """The upper bound"""),
                ),
                returnType = kt1,
                description = """Clamps the number into the range from lo to hi, both inclusive.""",
                returnDoc = """The number, moved into the range""",
                samples = listOf(
                    KlangCodeSample(code = """5.clamp(0, 3)  // 3""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "classic" to KlangSymbol(
        name = "classic",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "classic",
                receiver = kt42,
                params = emptyList(),
                returnType = kt47,
                description = """The chain every orbit has always run: body, vowel, delay, reverb, phaser, compressor and the
 duck, in that order, plus the group fader at unity (`gain.gain`) between the compressor and
 the duck, which is bit-transparent and is there so a pattern can reach a group fader. Every
 knob is a named slot the bus doors and `katp` write.

 Write it to say "the familiar orbit", or use it as the base of a chain that adds to it:

 ```
 katalyst(Katalyst.classic())
 katalyst(Katalyst(k => k.classic().eq(e => e.band(freq = 160, q = 1.0, db = -3.0))))
 katalyst(Katalyst(k => k.classic().duck(orbit = 1, depth = 0.8)))
 ```

 Its duck names no source, so nothing ducks until one is written. The third line above is how:
 a cylinder runs exactly one ducking effect, so the LAST duck in the chain wins and appending
 one replaces the unset duck `classic` brought.

 **Writing it is not the same as writing nothing** (decided 2026-09-18). An orbit that declares
 no chain runs the historical one from the voice's own effect fields; declaring THIS one names
 the same stages as slots, so `katp` and the bus doors drive them, which is what makes
 `Katalyst(k => k.classic())` the one line to add before automating a classic knob. The sound
 is the same either way; what changes is who the knobs listen to. Its `body` material and its
 `vowel` are slots as well, carrying the INDEX of a name in the shared catalogues, so a
 pattern's `body(material = "wood")` still reaches it.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "classic",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Wraps this sound in the classic synth voice: the FM, the pitch envelope, the accelerate and the vibrato on the source, then the
 pattern's one-pole lowpass, crush, coarse, distort, highpass, bandpass, notch, lowpass, tremolo and the amplitude envelope, in that
 order, every one of them driven by a slot the pattern's doors fill (`Ignitor.slot.fm.depth`, `Ignitor.slot.penv.semitones`,
 `Ignitor.slot.accelerate`, `Ignitor.slot.vibrato.semitones`,
 `Ignitor.slot.onepole`, `Ignitor.slot.lpf.freq`, `Ignitor.slot.adsr.attack`, ...). A stage the note does not write is not built, so an untouched
 `classic()` costs one envelope and nothing else.

 Make it the LAST call (an `.optimizer(...)` hint after it is fine, it is not a stage). An instrument that ends
 in `classic()` is the whole voice: the voice doors (`onepole(...)`, `lpf(...)`, `adsr(...)`, ...) reach its
 slots, and nothing runs after it but the channel (`gain`, `pan`). Every built-in sound (`sound("saw")`) IS a
 source with this tail. Every instrument is played as its tree. Around it the engine adds only
 the teardown fade when the tree does not end in its own envelope (`BuiltIgnitor.endsInEnvelope`), and the
 channel after (`gain`, `pan`); so without `classic()` the doors of `classic()` reach only the slots the tree
 places itself. The pattern's FM (`fm`), pitch envelope (`penv`), `accelerate` and vibrato (`vib`) are `classic()`
 stages: an instrument without `classic()` ignores them, as it ignores `lpf` or `adsr`. A pattern also reaches the slots by name:
 `ignp("lpf.freq", 1800)`.

 Want another order? Write your own tail from the same `Ignitor.slot` slots, as far as a door takes them: every
 filter's `freq`, `q`, `passes`, `env` and envelope stages, `crush`, `coarse`, the tremolo's knobs, the pitch envelope's
 `penv.*` and `penvCurves.*` (`pitchEnvelope(Ignitor.slot.penv.semitones, ...)`), the flat `accelerate`
 (`accelerate(Ignitor.slot.accelerate)`), the vibrato's `vibrato.*`
 (`vibrato(Ignitor.slot.vibrato.rate, Ignitor.slot.vibrato.semitones, v => v.range(Ignitor.slot.vibrato.rangeFrom,
 Ignitor.slot.vibrato.rangeTo).phase(Ignitor.slot.vibrato.phase))`), the FM's `fm.*`
 (`fm(Ignitor.sine(x => x.analog(0)), Ignitor.slot.fm.ratio, Ignitor.slot.fm.depth, ...)`) and the envelope's stages and curves. The pattern's `onepole` is a slot too (`Ignitor.slot.onepole`): the engine no longer hangs one
 around the instrument. Two groups only `classic()` can place: `adsr.on` (no door has the switch) and `distort.*` (the `distort` door
 builds a drive into a shaper that always runs and caps its output; `classic()` uses the one distort node that
 switches off as a whole, so a slot on the door's distort would shape every note, written or not).


 No arguments: everything it does is a slot. It is the same function as the Kotlin
 `IgnitorDsl.classic()`, which is the one place the order is written.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """let guitar = Ignitor.saw().distort(0.4).classic()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "classic",
                receiver = kt3,
                params = emptyList(),
                returnType = kt3,
                description = """Appends the familiar block at once: body, vowel, delay, reverb, phaser, compressor, the group
 fader at unity and the duck, in that order, with every knob a named slot.

 `Katalyst(k => k.classic().eq(...))` therefore reads as "the chain an orbit has always run, plus
 an EQ at the end". The fader is the one stage that is not history: it is bit-transparent at
 unity, and it is there so `katp("gain.gain", x)` reaches a group fader on every orbit (the
 signal-flow plan, section 6, spot C). `k.classic().gain(0.8)` is legal and is what it looks
 like, two faders in series: the unity slot, then 0.8.

 **At most once per builder** (decided with the maintainer, 2026-09-18): a second `classic()` in
 the same builder returns the builder unchanged, because duplicated stages read the same
 slot names and one `reverb(0.3)` would run reverb into reverb. Writing a stage out twice
 (`k.reverb(...).reverb(...)`) is a different thing and still stacks, in written order: that is an
 author asking for two rooms, not for the familiar chain twice.

 The duck it brings is an unset one (no source orbit, so no ducking). Appending a `duck(...)`
 after it is how you set one: the cylinder runs exactly one ducking effect, so the LAST duck in
 the chain wins.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "coarse" to KlangSymbol(
        name = "coarse",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "coarse",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "factor", type = kt5),
                ),
                returnType = kt2,
                description = """Applies sample-rate reduction: [factor] is the sample-hold factor; at 1 or less nothing is held.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "compressor" to KlangSymbol(
        name = "compressor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "compressor",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt43, isOptional = true, defaultDoc = """null""", description = """ceiling in dBFS where gain reduction starts (default -20). Orbit twin: `compressor(threshold = ...)`."""),
                    KlangParam(name = "ratio", type = kt43, isOptional = true, defaultDoc = """null""", description = """compression ratio above the threshold (default 4, i.e. 4:1). Orbit twin: `compressor(ratio = ...)`."""),
                    KlangParam(name = "knee", type = kt43, isOptional = true, defaultDoc = """null""", description = """soft-knee width in dB (default 6). A hard corner injects harmonics on every crossing. Orbit twin: `compressor(knee = ...)`."""),
                    KlangParam(name = "attack", type = kt43, isOptional = true, defaultDoc = """null""", description = """how fast the gain closes, in seconds (default 0.003). Orbit twin: `compressor(attack = ...)`."""),
                    KlangParam(name = "release", type = kt43, isOptional = true, defaultDoc = """null""", description = """how fast the gain opens again, in seconds (default 0.1). Orbit twin: `compressor(release = ...)`."""),
                    KlangParam(name = "lookahead", type = kt52, isOptional = true, defaultDoc = """null""", description = """how far ahead it sees, in seconds (default 0, off). The gain starts closing BEFORE a transient arrives, and `attack` becomes the gain-smoothing length (widen both together). The cost is latency: this orbit (at the output, this whole playback) runs late by `floor(lookahead * sampleRate)` frames (none below 8 frames, about 0.2 ms), and nothing compensates. A plain number fixed with the chain, at most 0.05. No orbit twin: declare it here."""),
                ),
                returnType = kt3,
                description = """Appends the orbit compressor: the group dynamics. Flat, like every dynamics stage: each knob is
 a musical input.

 Put it after the EQ so the detector sees the corrected spectrum and a low cut turns into
 headroom.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk3() = mapOf(

    "concat" to KlangSymbol(
        name = "concat",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "concat",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "other", type = kt49, description = """The string to append"""),
                ),
                returnType = kt51,
                description = """Concatenates another string to this string.""",
                returnDoc = """The concatenated string""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "constant" to KlangSymbol(
        name = "constant",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "constant",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "value", type = kt1, description = """the constant value"""),
                ),
                returnType = kt2,
                description = """Creates a fixed constant value that cannot be overridden by ignitorParams.

 Use when you want an explicit, locked value in the signal graph.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "contains" to KlangSymbol(
        name = "contains",
        category = "array",
        tags = listOf("search"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "contains",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "item", type = kt7, description = """The item to check for"""),
                ),
                returnType = kt53,
                description = """Returns true if the array contains the given item.""",
                returnDoc = """True if the array contains the item""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "cos" to KlangSymbol(
        name = "cos",
        category = "math",
        tags = listOf("trigonometry"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "cos",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The angle in radians"""),
                ),
                returnType = kt1,
                description = """Returns the cosine of an angle in radians.""",
                returnDoc = """The cosine value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.cos(0)  // 1.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "crackle" to KlangSymbol(
        name = "crackle",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "crackle",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "chaos", type = kt5, isOptional = true, defaultDoc = """1.5""", description = """drives the chaotic map: ~1.0 sparse, 1.5 = clear crackle (default), ~2.0 dense/noisy."""),
                ),
                returnType = kt2,
                description = """Creates a crackle source (chaotic recurrence → bipolar pops).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "crush" to KlangSymbol(
        name = "crush",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "crush",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "bits", type = kt5),
                ),
                returnType = kt2,
                description = """Applies bit-depth reduction (bitcrusher): [bits] is the bit depth, `2^bits` levels; below 1 it passes through.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "curves" to KlangSymbol(
        name = "curves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "curves",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "attack", type = kt43, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt43, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt43, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt8,
                description = """Shapes the amplitude envelope's stages: `"exp"` (the default, every amplitude envelope's),
 `"linear"` (`lin`), `"square"` (`sq`/`quad`), `"cube"` (`cb`), `"scurve"` (`s`/`smooth`/`sigmoid`)
 or `"invsquare"` (`inv`/`concave`). An omitted argument and an unknown name both mean `"exp"`, so
 every call sets all three stages. Each argument may also be the curve's index in that list, or a
 slot carrying it; it is chosen once per note. Every exponential stage bends at the engine's one
 curvature (`ADSR_EXP_K`).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "curves",
                receiver = kt11,
                params = listOf(
                    KlangParam(name = "attack", type = kt43, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "decay", type = kt43, isOptional = true, defaultDoc = """null"""),
                    KlangParam(name = "release", type = kt43, isOptional = true, defaultDoc = """null"""),
                ),
                returnType = kt11,
                description = """Shapes a modulation envelope's stages (a filter's cutoff envelope, the pitch envelope), with the
 chain's six curves and their short names. Unshaped stages are `"exp"`, the house curve (decision
 D3; they were linear before); an omitted argument and an unknown name both mean it, so every
 call sets all three stages. A number or a slot is the curve's index, chosen once per note.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "cut" to KlangSymbol(
        name = "cut",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "cut",
                receiver = kt32,
                params = listOf(
                    KlangParam(name = "freq", type = kt1, description = """the crossover frequency in Hz."""),
                ),
                returnType = kt32,
                description = """Closes the band being written at [freq] and starts the next one up. A cut below the one before it is moved up to it.
 A plain number: the crossover does not move.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "cut",
                receiver = kt34,
                params = listOf(
                    KlangParam(name = "freq", type = kt1, description = """the crossover frequency in Hz."""),
                ),
                returnType = kt34,
                description = """Closes the band being written at [freq] and starts the next one up. A cut below the one before it is moved up to it.
 A plain number: the crossover does not move.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk4() = mapOf(

    "db" to KlangSymbol(
        name = "db",
        category = "number",
        tags = listOf("music", "gain"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "db",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the number as decibels and returns the linear gain: 10^(self / 20).

 Every mixing knob speaks dB and every engine gain is linear, so this is the conversion between
 the two. The inverse is `toDb`.""",
                returnDoc = """The linear gain""",
                samples = listOf(
                    KlangCodeSample(code = """(-6).db()  // 0.5012, half the amplitude""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "declick" to KlangSymbol(
        name = "declick",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "declick",
                receiver = kt8,
                params = listOf(
                    KlangParam(name = "seconds", type = kt5),
                ),
                returnType = kt8,
                description = """De-clicks the envelope's gain by [seconds]: a one-pole low-pass that rounds the corners at the
 segment joins (the attack peak, the gate's end, the cutoff), removing the low-note "plop". `0` is
 off, which is this envelope's default; a gentle value is about 0.0005 to 0.001.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "delay" to KlangSymbol(
        name = "delay",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "delay",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt43, isOptional = true, defaultDoc = """null""", description = """how much of the orbit goes into the delay (default 0.25; 0.0 = off). Orbit twin: `delay(wet = ...)`."""),
                    KlangParam(name = "time", type = kt43, isOptional = true, defaultDoc = """null""", description = """delay time in seconds (default 0.25). Orbit twin: `delay(time = ...)`."""),
                    KlangParam(name = "feedback", type = kt43, isOptional = true, defaultDoc = """null""", description = """feedback amount (default 0.3), allowed above 1.0. At exactly 1.0 the echoes neither fade nor grow: each keeps the level it went in at (a delay time that falls between two samples dulls its highs a little on every repeat), unless that level reaches `cap`. Above 1.0 they grow on every repeat until `cap` holds them, just under it. Orbit twin: `delay(feedback = ...)`."""),
                    KlangParam(name = "configure", type = kt54, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystDelayBuilder] (knob: `cap`) and returns it."""),
                ),
                returnType = kt3,
                description = """Appends an orbit delay (the shared delay line).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "detune" to KlangSymbol(
        name = "detune",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "detune",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "semitones", type = kt5),
                ),
                returnType = kt2,
                description = """Shifts pitch by semitones.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "distort" to KlangSymbol(
        name = "distort",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "distort",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                    KlangParam(name = "shape", type = kt5, isOptional = true, defaultDoc = """"soft""""),
                ),
                returnType = kt2,
                description = """Waveshaping distortion. Convenience for drive(amount) + shape(shape).

 Shapes:
  - **Symmetric soft:** "soft" (tanh), "gentle", "softsat", "cubic", "exp", "sineshaper".
  - **Symmetric hard / wavefolding:** "hard", "zerosquare", "chebyshev", "fold", "linearfold".
  - **Asymmetric (even harmonics):** "diode", "tube", "asym", "stompbox", "rectify".

 [shape] takes what [shape]'s does: a name, a number or a slot. It distorts at the rate it is in; for less
 aliasing, write it inside a region: `x.oversampleAtLeast(4, y => y.distort(0.5, "tube"))`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "distort",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "amount", type = kt43, isOptional = true, defaultDoc = """null""", description = """the drive into the shape, `10^(amount * 1.2)`: 0.1 is about +2.4 dB, 0.25 about +6 dB, 0.5 (the default) about +12 dB. At or below 0 the stage is off. A number, or a `Katalyst.param` slot that a pattern moves with `katp` (the change glides). No orbit twin: sprudel's `distort(...)` is the voice's door."""),
                    KlangParam(name = "shape", type = kt49, isOptional = true, defaultDoc = """"soft"""", description = """the waveshaper by name, from the voice's list (`soft`, `hard`, `tube`, `softsat`, `gentle`, ...); an unknown name is `soft`. Fixed with the chain. It distorts at the rate of the bus it is in. A bus bends the whole mix, so its aliasing lands on every note: for less, write it inside a region, `k.oversampleAtLeast(2, r => r.distort(0.15))`."""),
                ),
                returnType = kt3,
                description = """Appends a distortion of the bus mix: the voice's `distort` at the bus position, same knobs, same
 scales, same shapes. A clipper before the master limiter is this stage with `soft` (or `hard`) and
 a small [amount]; saturation is a gentle shape (`tube`, `softsat`) at a moderate one. Flat, as the
 voice's door is.

 It bends the SUM: every note of the bus goes through one curve, so they intermodulate. That is
 the glue a master saturator gives and the growl of an amp fed by a whole chord; pushed hard, chords
 turn to mush.

 ```
 master(Katalyst(k => k.gain(1.1).distort(0.15).limiter(threshold = -3.0)))   // clip, then limit
 katalyst(Katalyst(k => k.distort(0.6, "tube").eq(e => e.band(freq = 2700, q = 2.0, db = 3.0))))
 ```""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "div" to KlangSymbol(
        name = "div",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "div",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Divides the signal by a divisor (IgnitorDsl or Number).

 Zero divisors are substituted with `1e-30` to keep the engine `NaN`-free.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "div",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Divides every sample of the bus by [other]. A divisor of exactly zero gives silence, as on the Ignitor. A moving
 divisor glides as a level (`1 / other`), so a move through zero passes through silence instead of a huge gain.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "div",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob divided by [other]. The Ignitor's `div` law: a divisor of exactly zero gives zero.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// a quarter of the beat a pattern writes, in seconds
Katalyst(k => k.delay(0.3, Kat.param("beat", 0.5).div(4)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "drive" to KlangSymbol(
        name = "drive",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "drive",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "amount", type = kt5),
                ),
                returnType = kt2,
                description = """Pre-amplification stage. Boosts signal level before clipping: gain without a curve, every
 colour belongs to `shape`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "drop" to KlangSymbol(
        name = "drop",
        category = "array",
        tags = listOf("slicing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "drop",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "n", type = kt1, description = """Number of elements to drop"""),
                ),
                returnType = kt55,
                description = """Returns a new array with the first n elements removed.""",
                returnDoc = """A new array without the first n elements""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk5() = mapOf(

    "duck" to KlangSymbol(
        name = "duck",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "duck",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "orbit", type = kt43, isOptional = true, defaultDoc = """null""", description = """the orbit to listen to. Omitted means no ducking: the stage carries the wire's non-finite "never set" marker, and the runtime tests `isFinite()` rather than comparing, so a finite negative is an orbit REQUEST like any other and not an off switch. Orbit twin: `duck(orbit = ...)`."""),
                    KlangParam(name = "depth", type = kt43, isOptional = true, defaultDoc = """null""", description = """how far this orbit is pulled down, 0 to 1 (default 0, no ducking). Orbit twin: `duck(depth = ...)`."""),
                    KlangParam(name = "attack", type = kt43, isOptional = true, defaultDoc = """null""", description = """how fast the duck closes, in seconds (default 0.1). Orbit twin: `duck(attack = ...)`."""),
                ),
                returnType = kt3,
                description = """Appends a sidechain duck: this orbit is pulled down whenever the orbit it listens to sounds.
 Flat, like every dynamics stage.

 Declared in the chain, but run after every orbit has been processed, so where it sits in the
 list makes no difference.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "dust" to KlangSymbol(
        name = "dust",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "dust",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "density", type = kt5, isOptional = true, defaultDoc = """0.2""", description = """impulse rate 0..1."""),
                    KlangParam(name = "tail", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """heavy-tailed amplitude exponent: 1 = uniform (default), >1 = mostly-tiny / rare-loud (vinyl pops)."""),
                    KlangParam(name = "bipolar", type = kt5, isOptional = true, defaultDoc = """0.0""", description = """random ±sign when > 0.5; default 0 = unipolar."""),
                ),
                returnType = kt2,
                description = """Creates a dust source (sparse random impulses).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "duty" to KlangSymbol(
        name = "duty",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "duty",
                receiver = kt21,
                params = listOf(
                    KlangParam(name = "width", type = kt5),
                ),
                returnType = kt21,
                description = """Pulse width / duty cycle: `width` is the share of each cycle the wave is high, 0 to 1 (default 0.5, a square). Accepts an `Ignitor.*` graph for PWM.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "duty",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "width", type = kt5),
                ),
                returnType = kt22,
                description = """Pulse width / duty cycle: `width` is the share of each cycle the wave is high, 0 to 1 (default 0.5, a square). Accepts an `Ignitor.*` graph for PWM.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "duty",
                receiver = kt56,
                params = listOf(
                    KlangParam(name = "width", type = kt5),
                ),
                returnType = kt56,
                description = """`width` is the share of each cycle the square spends high, 0 to 1 (default 0.5, a square). A Kat expression moves
 it, which is a pulse-width modulation of the LFO.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Katalyst(k => k.gain(Kat.square(1, x => x.duty(0.25)).range(0.4, 1)))   // full level a quarter of each second""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "endsWith" to KlangSymbol(
        name = "endsWith",
        category = "string",
        tags = listOf("search"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "endsWith",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "suffix", type = kt49, description = """The suffix to check"""),
                ),
                returnType = kt53,
                description = """Returns true if the string ends with the given suffix.""",
                returnDoc = """True if the string ends with the suffix""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "entries" to KlangSymbol(
        name = "entries",
        category = "object",
        tags = listOf("properties"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "entries",
                receiver = kt57,
                params = emptyList(),
                returnType = kt50,
                description = """Returns an array of the object's own [key, value] pairs.""",
                returnDoc = """An array of [key, value] arrays""",
                samples = listOf(
                    KlangCodeSample(code = """let obj = { x: 10, y: 20 }
Object.entries(obj).size()""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "env" to KlangSymbol(
        name = "env",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "env",
                receiver = kt10,
                params = listOf(
                    KlangParam(name = "semitones", type = kt5),
                ),
                returnType = kt10,
                description = """Cutoff-envelope DEPTH in semitones: `cutoff = freq * 2^(env/12 * envelope)`. `env` and `adsr` are
 a compound pair: naming either switches the envelope on and the other fills from
 `audio_bridge/constants/FilterEnvelopeDefaults.kt` (the fill runs after the lambda, once). A
 non-leaf EXPRESSION here is unreadable at build and switches the envelope OFF; write a number or
 a slot (`Ignitor.slot.lpf.env`).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "env",
                receiver = kt13,
                params = listOf(
                    KlangParam(name = "semitones", type = kt5),
                ),
                returnType = kt13,
                description = """Cutoff-envelope depth in semitones, compound with `adsr`; see `FilterBuilder.env`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "eq" to KlangSymbol(
        name = "eq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "eq",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "configure", type = kt58, isOptional = true, defaultDoc = """null""", description = """receives the [EqBuilder] (knobs: `band`, `tap`) and returns it."""),
                ),
                returnType = kt2,
                description = """Opens an equalizer on [self] and configures its sections in the lambda. Everything in one
 equalizer runs in ONE pass instead of one node each, which drops the scratch buffer, the
 extra buffer traffic and the virtual call for every section after the first (the per-sample
 filter loop per section stays, by design). The saving grows with the section count and is
 much larger in the browser than on desktop JVM.

 Two kinds of section on the [EqBuilder], and the difference is audible:
 - `band(freq, q, db)` is an ordinary EQ band. Bands apply one after another, so two
   overlapping boosts compound.
 - `tap(freq, q, gain)` takes the sound going INTO the equalizer, filters that, and mixes
   it back in. Taps mix with the original rather than stacking on each other.

 Plain filters written after it (`.lowpass()`, `.notch()`, ...) are folded into the same
 single pass automatically, so you do not have to write them as bands to get the saving,
 but only NEIGHBOURING filters merge: anything else in between (`.distort()`, `.mul()`,
 `.tremolo()`, ...) is a wall and starts a new pass. Use `.optimizer(0)` to render a sound
 exactly as written and compare by ear.

 An `.eq()` directly on an equalizer continues it (the lambda appends to its sections); an
 `.eq()` written after other filters opens a SECOND equalizer. Careful when adding a `tap`
 onto a sound someone ELSE built: if that sound already ends in an equalizer, your `.eq()`
 continues theirs, and your tap then reads THEIR input rather than their output. Bands are
 unaffected.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().eq(e => e.band(300, 1.0, -4).tap(850, 0.707, 1.7)).lowpass(5000)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "eq",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "configure", type = kt59, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystEqBuilder] (knobs: `band`, `tap`) and returns it."""),
                ),
                returnType = kt3,
                description = """Appends the mix equalizer: one stage whose sections apply left to right.

 The voice eq's words, defaults and sections on a [KatalystEqBuilder], so a section means the same thing on a
 voice and on an orbit; its knobs take a number or a Katalyst param.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "exp" to KlangSymbol(
        name = "exp",
        category = "number",
        tags = listOf("logarithm", "exponent"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "exp",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """`e^x` per sample.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "exp",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns e raised to the power of the number, the inverse of `ln`.""",
                returnDoc = """e raised to self""",
                samples = listOf(
                    KlangCodeSample(code = """1.exp()  // 2.7183, the number e""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk6() = mapOf(

    "fallFlank" to KlangSymbol(
        name = "fallFlank",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "fallFlank",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "fallFlank", type = kt1),
                ),
                returnType = kt22,
                description = """Falling-edge flank fraction of the plateau: 0 = sharpest (the floor), 1 = full ramp (default 0.0).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "feedback" to KlangSymbol(
        name = "feedback",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "feedback",
                receiver = kt30,
                params = listOf(
                    KlangParam(name = "feedback", type = kt5),
                ),
                returnType = kt30,
                description = """Loop feedback per pass, 0.9 to 0.999 (default 0.996); higher rings longer. A coefficient, not a time.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "feedback",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "feedback", type = kt5),
                ),
                returnType = kt31,
                description = """Loop feedback per pass, 0.9 to 0.999 (default 0.996); higher rings longer. A coefficient, not a time.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "first" to KlangSymbol(
        name = "first",
        category = "array",
        tags = listOf("access"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "first",
                receiver = kt6,
                params = emptyList(),
                returnType = kt50,
                description = """Returns the first element, or null if the array is empty.""",
                returnDoc = """The first element or null""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "flankSamples" to KlangSymbol(
        name = "flankSamples",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "flankSamples",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "flankSamples", type = kt1),
                ),
                returnType = kt22,
                description = """Minimum flank length in samples, a floor on every edge that softens with pitch (default 2.0).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "floor" to KlangSymbol(
        name = "floor",
        category = "math",
        tags = listOf("rounding"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "floor",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The number to floor"""),
                ),
                returnType = kt1,
                description = """Rounds a number down to the nearest integer.""",
                returnDoc = """The floored value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.floor(3.7)  // 3.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample floor.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Rounds the number down to the nearest integer.""",
                returnDoc = """The floored value""",
                samples = listOf(
                    KlangCodeSample(code = """3.7.floor()  // 3""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt60,
                params = listOf(
                    KlangParam(name = "floor", type = kt5),
                ),
                returnType = kt60,
                description = """Minimum dry coefficient of the phaser (default 0): the dry signal never drops below this share.
 A knob on effect builders only, where it cannot meet the round-down `floor()` of a signal.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt61,
                params = listOf(
                    KlangParam(name = "floor", type = kt5),
                ),
                returnType = kt61,
                description = """Minimum dry coefficient of the shimmer (default 0); see `PhaserBuilder.floor`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt44,
                params = listOf(
                    KlangParam(name = "floor", type = kt5),
                ),
                returnType = kt44,
                description = """Minimum dry share kept in the mix, 0 to 1 (default 0.4). Lower makes the body MORE audible: its
 modes sit over less dry. Orbit twin: `body(floor = ...)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt62,
                params = listOf(
                    KlangParam(name = "floor", type = kt5),
                ),
                returnType = kt62,
                description = """Minimum dry share kept between the formants, 0 to 1 (default 0.2). Much lower than the body's: a
 vowel is a source strongly shaped by its formants. Orbit twin: `vowel(floor = ...)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "floor",
                receiver = kt63,
                params = listOf(
                    KlangParam(name = "floor", type = kt5),
                ),
                returnType = kt63,
                description = """Minimum dry coefficient of the wet/dry law (default 1.0, purely additive). Orbit twin: `phaser(floor = ...)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "fm" to KlangSymbol(
        name = "fm",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "fm",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "modulator", type = kt5),
                    KlangParam(name = "ratio", type = kt5),
                    KlangParam(name = "depth", type = kt5),
                    KlangParam(name = "configure", type = kt64, isOptional = true, defaultDoc = """null""", description = """receives the [FmBuilder] (knob: `adsr`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies FM synthesis with a modulator ignitor. The modulation index envelope is a knob on the
 [FmBuilder]: `.fm(Ignitor.sine(), 1.4, 300, x => x.adsr(0.001, 0.5, 0, 0.05))`, the built-in `sgbell`.

 A pitch node means what it wraps. Above the fm it moves the whole operator, the note's pitch
 (`Ignitor.sine().fm(Ignitor.sine(), 3.5, 400).vibrato(6, 0.5)`; a modulator with an absolute frequency,
 `Ignitor.sine(330)`, stays at it); on the modulator, the modulator alone
 (`Ignitor.sine().fm(Ignitor.sine().vibrato(6, 0.5), 3.5, 400)`); on the carrier, the carrier alone
 (`Ignitor.sine().vibrato(6, 0.5).fm(Ignitor.sine(), 3.5, 400)`). One fm serves one pitch: over
 `x + x.detune(7)`, give each layer its own fm, inside its detune, and sum them,
 `x.fm(m1, ...) + x.fm(m2, ...).detune(7)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "fn" to KlangSymbol(
        name = "fn",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "fn",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "f", type = kt33, description = """the function, from an Ignitor to an Ignitor"""),
                ),
                returnType = kt33,
                description = """Returns [f] as it is: a function from a signal to a signal, typed. Written as `let stage = x => x...`, the editor
 cannot know what `x` is; written as `Ign.fn(x => x...)`, `x` is an Ignitor, so the Quick help and the completion
 show the Ignitor's own doors (the maintainer, 2026-10-28). The stage plays the same either way.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """let pickupNeck = Ign.fn(x => x.lowpass(3500, 1.4).mul(1.2))
let rig = x => x.serial(pickupNeck)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "frac" to KlangSymbol(
        name = "frac",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "frac",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample fractional part: `x − floor(x)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk7() = mapOf(

    "freq" to KlangSymbol(
        name = "freq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "freq",
                receiver = kt41,
                params = emptyList(),
                returnType = kt2,
                description = """Returns the voice's note frequency (e.g. 440 Hz for A4). Usable anywhere a frequency value is needed.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "fundamental" to KlangSymbol(
        name = "fundamental",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "fundamental",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "gain", type = kt5),
                ),
                returnType = kt16,
                description = """Gain of the sine's own partial (default 1). `0` leaves only the partial banks, so
 `harmonics(7).fundamental(0)` puts the overtones on their own fader next to a separate sub. A signal
 like every knob (an `Ignitor.param`, an LFO), read once per block.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.harmonics(7).fundamental(0))    // overtones only, 2f .. 8f""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "gain" to KlangSymbol(
        name = "gain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "gain",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "gain", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """linear gain factor (1.0 = unity, 2.0 is about +6 dB)."""),
                ),
                returnType = kt3,
                description = """Appends make-up gain on the orbit: the group fader, after the inserts.

 **It APPENDS**, and `classic()` already brought one (its `gain.gain` slot at unity), so
 `k.classic().gain(0.8)` is two faders in series and the engine multiplies them: `katp` at 0.5
 makes 0.4. That is not a special case and nothing collapses them, which is the point of a stage
 list. Writing `Katalyst.param("gain.gain", ...)` as the knob of a SECOND stage is the sharp
 edge: both stages then read the same key, so one `katp("gain.gain", 0.5)` applies twice and the
 orbit lands at 0.25. Give a second fader its own slot name if it should move on its own.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "gainJitter" to KlangSymbol(
        name = "gainJitter",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "gainJitter",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "gainJitter", type = kt1),
                ),
                returnType = kt25,
                description = """Per-voice random amplitude offset (a fraction, plus or minus); 0 = off.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "gainJitter",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "gainJitter", type = kt1),
                ),
                returnType = kt26,
                description = """Per-voice random amplitude offset (a fraction, plus or minus); 0 = off.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "gainJitter",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "gainJitter", type = kt1),
                ),
                returnType = kt27,
                description = """Per-voice random amplitude offset (a fraction, plus or minus); 0 = off.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "gainJitter",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "gainJitter", type = kt1),
                ),
                returnType = kt28,
                description = """Per-voice random amplitude offset (a fraction, plus or minus); 0 = off.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "gainJitter",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "gainJitter", type = kt1),
                ),
                returnType = kt29,
                description = """Per-voice random amplitude offset (a fraction, plus or minus); 0 = off.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "harmonics" to KlangSymbol(
        name = "harmonics",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "harmonics",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "count", type = kt5),
                    KlangParam(name = "rolloff", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt16,
                description = """Adds `count` sine partials at `2f, 3f, 4f ...` of THIS sine's frequency, its harmonic series, rendered in
 one pass with the sine. A partial at multiple `m` has gain `m ^ -rolloff`: `rolloff` 1 (default) is the
 sawtooth law, 2 is triangle-soft, 0 is flat and buzzy. `count` 0 is off, at most 64. The multiples are of the sine, not of
 the note: `Ignitor.sine(Ignitor.freq().mul(2), x => x.harmonics(3))` is `2f, 4f, 6f, 8f`, the even series. Partials
 at or above Nyquist stay silent. Both arguments are signals read once per block, so
 `harmonics(12, Ignitor.param("rolloff", 1))` puts brightness on the pattern; a moving `count` steps on every
 removal (and, with a `phase` other than 0 or 0.5, on every addition too), a moving `rolloff` does not. Banks sum: `harmonics(7)` plus
 `octaves(3)` doubles the shared partials, as two written sines would.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.harmonics(7))                   // a bass: f plus 2f .. 8f, the ear rebuilds the fundamental on small speakers
Ignitor.sine(x => x.harmonics(8, Ignitor.sine(0.2).range(0.7, 2)))   // breathing brightness""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "highpass" to KlangSymbol(
        name = "highpass",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "highpass",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "configure", type = kt65, isOptional = true, defaultDoc = """null""", description = """receives the [FilterBuilder] and returns it."""),
                ),
                returnType = kt2,
                description = """Applies a resonant highpass filter. The knobs are [lowpass]'s, on the same [FilterBuilder].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "humanize" to KlangSymbol(
        name = "humanize",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "humanize",
                receiver = kt10,
                params = listOf(
                    KlangParam(name = "on", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt10,
                description = """Per-voice analog character, scaled by `analog`: a cutoff tolerance drawn once per note plus a
 slow drift lane. Off by default; at `analog = 0` it changes nothing. Accepts `true`/`false` or a
 number (`1` on, `0` off); anything else reads as ON (coerced, never thrown).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "humanize",
                receiver = kt13,
                params = listOf(
                    KlangParam(name = "on", type = kt7, isOptional = true, defaultDoc = """true"""),
                ),
                returnType = kt13,
                description = """Per-voice cutoff tolerance and drift lane, scaled by `analog`; see `FilterBuilder.humanize`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "impulse" to KlangSymbol(
        name = "impulse",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "impulse",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt66, isOptional = true, defaultDoc = """null""", description = """receives the [OscImpulseBuilder] (knobs: `analog`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates an impulse (click) oscillator.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.impulse(x => x.analog(3))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk8() = mapOf(

    "indexOf" to KlangSymbol(
        name = "indexOf",
        category = "array",
        tags = listOf("search"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "indexOf",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "item", type = kt7, description = """The item to search for"""),
                ),
                returnType = kt67,
                description = """Returns the index of the first occurrence of an item, or -1 if not found.""",
                returnDoc = """The index, or -1""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "indexOf",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "searchStr", type = kt49, description = """The string to search for"""),
                ),
                returnType = kt1,
                description = """Returns the index of the first occurrence of a search string, or -1 if not found.""",
                returnDoc = """The index, or -1""",
                samples = listOf(
                    KlangCodeSample(code = """"hello".indexOf("ll")  // 2.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "isEmpty" to KlangSymbol(
        name = "isEmpty",
        category = "array",
        tags = listOf("property"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "isEmpty",
                receiver = kt6,
                params = emptyList(),
                returnType = kt53,
                description = """Returns true if the array has no elements.""",
                returnDoc = """True if empty""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "isNotEmpty" to KlangSymbol(
        name = "isNotEmpty",
        category = "array",
        tags = listOf("property"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "isNotEmpty",
                receiver = kt6,
                params = emptyList(),
                returnType = kt53,
                description = """Returns true if the array has at least one element.""",
                returnDoc = """True if not empty""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "joinToString" to KlangSymbol(
        name = "joinToString",
        category = "array",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "joinToString",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "separator", type = kt49, description = """The separator string"""),
                ),
                returnType = kt51,
                description = """Joins all elements into a string with the given separator.""",
                returnDoc = """The joined string""",
                samples = listOf(
                    KlangCodeSample(code = """[1, 2, 3].joinToString(" - ")  // "1 - 2 - 3"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "keys" to KlangSymbol(
        name = "keys",
        category = "object",
        tags = listOf("properties"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "keys",
                receiver = kt57,
                params = emptyList(),
                returnType = kt50,
                description = """Returns an array of the object's own property names.""",
                returnDoc = """An array of property name strings""",
                samples = listOf(
                    KlangCodeSample(code = """let obj = { name: "klang", version: 1 }
Object.keys(obj).joinToString(", ")""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "last" to KlangSymbol(
        name = "last",
        category = "array",
        tags = listOf("access"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "last",
                receiver = kt6,
                params = emptyList(),
                returnType = kt50,
                description = """Returns the last element, or null if the array is empty.""",
                returnDoc = """The last element or null""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "length" to KlangSymbol(
        name = "length",
        category = "string",
        tags = listOf("property"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "length",
                receiver = kt49,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the length of the string.""",
                returnDoc = """The number of characters""",
                samples = listOf(
                    KlangCodeSample(code = """"hello".length()""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "lerp" to KlangSymbol(
        name = "lerp",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("mix"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "lerp",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                    KlangParam(name = "t", type = kt5),
                ),
                returnType = kt2,
                description = """Linear interpolation: `this·(1−t) + other·t`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk9() = mapOf(

    "limiter" to KlangSymbol(
        name = "limiter",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "limiter",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "threshold", type = kt43, isOptional = true, defaultDoc = """null""", description = """ceiling in dBFS (default -1). Orbit twin: `compressor(threshold = ...)`."""),
                    KlangParam(name = "ratio", type = kt43, isOptional = true, defaultDoc = """null""", description = """compression ratio (default 20, about a brick wall). Orbit twin: `compressor(ratio = ...)`."""),
                    KlangParam(name = "knee", type = kt43, isOptional = true, defaultDoc = """null""", description = """soft-knee width in dB (default 2). A hard corner injects harmonics on every crossing. Orbit twin: `compressor(knee = ...)`."""),
                    KlangParam(name = "attack", type = kt43, isOptional = true, defaultDoc = """null""", description = """how fast the gain closes, in seconds (default 0.001). With no lookahead a one-pole attack: short keeps transient punch. With a lookahead the gain-smoothing length; widen both together. Orbit twin: `compressor(attack = ...)`."""),
                    KlangParam(name = "release", type = kt43, isOptional = true, defaultDoc = """null""", description = """how fast the gain opens again, in seconds (default 0.1). Orbit twin: `compressor(release = ...)`."""),
                    KlangParam(name = "lookahead", type = kt52, isOptional = true, defaultDoc = """null""", description = """how far ahead it sees, in seconds (default 0, off). Lets the limiter close the gain before a transient arrives instead of chasing it, which is what stops loud hits punching through. The cost is latency: this orbit (at the output, this whole playback) runs late by `floor(lookahead * sampleRate)` frames (none below 8 frames, about 0.2 ms), and nothing compensates. A plain number fixed with the chain, at most 0.05. No orbit twin: declare it here."""),
                ),
                returnType = kt3,
                description = """Appends a limiter: the compressor stage with limiter numbers, a ceiling rather than a squeeze.
 Flat, like every dynamics stage, and in the compressor's parameter order. It is a preset, not a
 stage of its own: what it appends IS a `compressor`, so a limiter and a compressor are one DSP
 and one wire word.

 The limiter numbers live on the DOOR, and the stage does not know it was a limiter: a knob the
 engine cannot read (a slot whose value is unset or non-finite) falls back to the
 COMPRESSOR's shared constant (threshold -20, ratio 4, knee 6, attack 0.003, release 0.1), not to
 the limiter's. Write a slot's default as the number you want.

 ```
 master(Katalyst(k => k.gain(1.5).limiter()))
 katalyst(Katalyst(k => k.gain(1.5).limiter(lookahead = 0.005)))
 ```""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "ln" to KlangSymbol(
        name = "ln",
        category = "number",
        tags = listOf("logarithm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "ln",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the natural logarithm of the number.""",
                returnDoc = """The natural logarithm""",
                samples = listOf(
                    KlangCodeSample(code = """1.ln()  // 0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "log" to KlangSymbol(
        name = "log",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "log",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Natural logarithm per sample. Signed-magnitude; `log(0) = 0` (no `-Inf`).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "log10" to KlangSymbol(
        name = "log10",
        category = "number",
        tags = listOf("logarithm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "log10",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the base 10 logarithm of the number.""",
                returnDoc = """The base 10 logarithm""",
                samples = listOf(
                    KlangCodeSample(code = """1000.log10()  // 3""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "log2" to KlangSymbol(
        name = "log2",
        category = "number",
        tags = listOf("logarithm"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "log2",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the base 2 logarithm of the number.""",
                returnDoc = """The base 2 logarithm""",
                samples = listOf(
                    KlangCodeSample(code = """8.log2()  // 3""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "lowpass" to KlangSymbol(
        name = "lowpass",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "lowpass",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "configure", type = kt65, isOptional = true, defaultDoc = """null""", description = """receives the [FilterBuilder] (knobs: `passes`, `analog`, `humanize`, `env`, `adsr`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies a resonant lowpass filter. Cutoff and Q accept Number or IgnitorDsl.

 The door carries the filter's musical inputs, [freq] and [q]; everything else is a knob on
 the [FilterBuilder] the lambda receives: `passes`, `analog`, `humanize`, and the cutoff
 envelope as `env(semitones)` plus ONE `adsr(attack, decay, sustain, release,
 configure)` call, the chain `adsr`'s shape, whose own lambda shapes the stages with `curves`.
 `env` and `adsr` are a compound pair: naming either switches the envelope on and the other
 fills from the constants (`fillFilterEnvelope`, after the lambda).


 The cutoff envelope runs the law, the sampling and the default curve (exponential) of
 sprudel's `lpf(env = ...)`: see [IgnitorDsl.Lowpass.env] and decision D3.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().lowpass(800, 1.2, x => x.passes(2).analog(3))
Ignitor.saw().lowpass(800, x => x.env(24).adsr(0.005, 0.3, 0.2, 0.2))   // a pluck; q stays 0.707
Ignitor.saw().lowpass(800, 1.2, x => x.env(24).adsr(0.01, 0.3, 0.2, 0.5, e => e.curves("lin", "exp", "exp")))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "max" to KlangSymbol(
        name = "max",
        category = "math",
        tags = listOf("comparison", "clamp", "cap"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "max",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "a", type = kt1, description = """First number"""),
                    KlangParam(name = "b", type = kt1, description = """Second number"""),
                ),
                returnType = kt1,
                description = """Returns the larger of two numbers.""",
                returnDoc = """The larger value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.max(3, 7)  // 7.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "max",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Enforces a maximum allowed value per sample: this signal, but at most [other].

 Reads as "take self, at a maximum other", the same meaning `max` carries on a number
 and on a pattern. Anything above [other] is lowered to it.

 The node crossing is deliberate: a cap is the per-sample *minimum* of the two
 signals, so the `max` door builds [IgnitorDsl.Min]. Do not "correct" it.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(0, 2).max(0.8)   // cap the signal at 0.8""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "max",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "other", type = kt1, description = """The maximum allowed value (cap)"""),
                ),
                returnType = kt1,
                description = """Enforces a maximum allowed value: this number, but at most [other].

 Reads as "take self, at a maximum other". Anything above [other] is lowered to it;
 values at or below [other] pass through unchanged. Same meaning as `max` on a
 pattern and on a signal. For the larger *of* two numbers use `Math.max(a, b)`.""",
                returnDoc = """The number, lowered to [other] when it was above""",
                samples = listOf(
                    KlangCodeSample(code = """7.max(3)  // 3""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "max",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """The bus, but at most [other] per sample: anything above it is lowered to it, a hard cap on the positive half. A cap
 is the per-sample MINIMUM, so this door builds the `Min` stage. Do not "correct" the crossing. A cap below zero
 turns silence into DC and keeps its orbit running.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Katalyst(k => k.max(0.5).min(-0.5))   // hard clip at half scale""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "max",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob, but at most [other]: a cap, the same meaning `max` carries on a number, a pattern, a signal and a stage.
 A cap is the MINIMUM of the two, so this door builds [KatalystKnobDsl.Min]. Do not "correct" the crossing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the pattern's feedback, but never above 0.9
Katalyst(k => k.delay(0.3, 0.25, Kat.param("fb", 0.5).max(0.9)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "min" to KlangSymbol(
        name = "min",
        category = "math",
        tags = listOf("comparison", "clamp", "floor"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "min",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "a", type = kt1, description = """First number"""),
                    KlangParam(name = "b", type = kt1, description = """Second number"""),
                ),
                returnType = kt1,
                description = """Returns the smaller of two numbers.""",
                returnDoc = """The smaller value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.min(3, 7)  // 3.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "min",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Enforces a minimum allowed value per sample: this signal, but at least [other].

 Reads as "take self, at a minimum other", the same meaning `min` carries on a number
 and on a pattern. Anything below [other] is raised to it.

 The node crossing is deliberate: a floor is the per-sample *maximum* of the two
 signals, so the `min` door builds [IgnitorDsl.Max]. Do not "correct" it.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """sine.range(-1, 1).min(0)   // half-wave rectify""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "min",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "other", type = kt1, description = """The minimum allowed value (floor)"""),
                ),
                returnType = kt1,
                description = """Enforces a minimum allowed value: this number, but at least [other].

 Reads as "take self, at a minimum other". Anything below [other] is raised to it;
 values at or above [other] pass through unchanged. Same meaning as `min` on a
 pattern and on a signal. For the smaller *of* two numbers use `Math.min(a, b)`.""",
                returnDoc = """The number, raised to [other] when it was below""",
                samples = listOf(
                    KlangCodeSample(code = """7.min(3)  // 7""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "min",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """The bus, but at least [other] per sample: anything below it is raised to it, the same meaning `min` carries on a
 number, a pattern and a signal. A floor is the per-sample MAXIMUM, so this door builds the `Max` stage. Do not
 "correct" the crossing. A floor above zero turns silence into DC and keeps its orbit running.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "min",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob, but at least [other]: a floor, the same meaning `min` carries on a number, a pattern, a signal and a
 stage. A floor is the MAXIMUM of the two, so this door builds [KatalystKnobDsl.Max]. Do not "correct" the crossing.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk10() = mapOf(

    "minus" to KlangSymbol(
        name = "minus",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("sub"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "minus",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Subtracts another signal from this one.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "minus",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Subtracts [other] from every sample of the bus. A constant is a DC offset, as with [plus], and keeps its orbit
 running.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "minus",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob minus [other]. The Ignitor's `minus` law, unclamped.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "mix" to KlangSymbol(
        name = "mix",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("lerp"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "mix",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                    KlangParam(name = "t", type = kt5),
                ),
                returnType = kt2,
                description = """Crossfade: `this·(1−t) + other·t`. Alias for [lerp].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "mod" to KlangSymbol(
        name = "mod",
        category = "number",
        tags = listOf("arithmetic", "remainder"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "mod",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Per-sample modulo. Zero divisors substituted with `1e-30` to avoid `NaN`.

 On a signal `mod` and `rem` are the same operation, the engine's `%`: the sign follows the LEFT
 operand, so a negative value stays negative. This differs from `mod` on a number, which is the
 floor modulo (`(-1).mod(12)` is 11); to wrap a negative signal into a range, add the range and
 take `mod` again.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "mod",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "n", type = kt1, description = """The divisor"""),
                ),
                returnType = kt1,
                description = """Returns the remainder of the division by n, with the sign of the divisor (floor modulo).

 Only on numbers: `mod` on a SIGNAL (an oscillator chain) is the engine's `%`, the same as `rem`,
 and keeps a negative value negative.

 This is the one no operator can express: a negative offset wraps back into the range, which is
 what pitch classes and cycle wrapping want. Its twin is `rem`, the method form of `%`, which
 takes the sign of the dividend: `-1.mod(12)` is 11 while `-1.rem(12)` is -1.""",
                returnDoc = """The remainder, with the sign of n""",
                samples = listOf(
                    KlangCodeSample(code = """(-1).mod(12)  // 11""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "mul" to KlangSymbol(
        name = "mul",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("times"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "mul",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Scales the signal by a factor (IgnitorDsl or Number). Alias for [times].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "mul",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Multiplies every sample of the bus by [other]. Alias for [times].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "mul",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob times [other]. Alias for [times].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "neg" to KlangSymbol(
        name = "neg",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("negate"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "neg",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Negates this signal (flips polarity).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "neg",
                receiver = kt3,
                params = emptyList(),
                returnType = kt3,
                description = """Flips the polarity of the bus: a multiply by -1, as the Ignitor's `neg`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "neg",
                receiver = kt4,
                params = emptyList(),
                returnType = kt4,
                description = """This knob with its sign flipped: a multiply by -1, clamped like `times`, as the Ignitor's `neg`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "negate" to KlangSymbol(
        name = "negate",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("neg"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "negate",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Negates this signal (flips polarity). Alias for [neg].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "negate",
                receiver = kt3,
                params = emptyList(),
                returnType = kt3,
                description = """Flips the polarity of the bus. Alias for [neg].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "negate",
                receiver = kt4,
                params = emptyList(),
                returnType = kt4,
                description = """This knob with its sign flipped. Alias for [neg].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "notch" to KlangSymbol(
        name = "notch",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "notch",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "configure", type = kt38, isOptional = true, defaultDoc = """null""", description = """receives the [BandFilterBuilder] and returns it."""),
                ),
                returnType = kt2,
                description = """SVF notch (band-reject) filter. The knobs are [bandpass]'s, on a [BandFilterBuilder].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "octaveDown" to KlangSymbol(
        name = "octaveDown",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "octaveDown",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Shifts pitch down one octave (-12 semitones).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk11() = mapOf(

    "octaveUp" to KlangSymbol(
        name = "octaveUp",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "octaveUp",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Shifts pitch up one octave (+12 semitones).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "octaves" to KlangSymbol(
        name = "octaves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "octaves",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "count", type = kt5),
                    KlangParam(name = "rolloff", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt16,
                description = """Adds `count` sine partials at `2f, 4f, 8f ...` of THIS sine's frequency, one per octave. A partial at multiple
 `m` has gain `m ^ -rolloff` (default 1, the sawtooth law sampled at the octaves). `count` 0 is off, at most 64. Climbs fast:
 five octaves reach `32f`, a brightness and grind device rather than fundamental reconstruction. Partials at or
 above Nyquist stay silent. Signals read once per block.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(Ignitor.freq().mul(2), x => x.octaves(5)).mul(1/2)   // 2f .. 64f at 1/2 .. 1/64, an octave stack over a saw""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "onepole" to KlangSymbol(
        name = "onepole",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "onepole",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                ),
                returnType = kt2,
                description = """Applies a one-pole lowpass at [freq] Hz — the gentlest filter there is (6 dB/oct, no
 resonance); musically a warmth/tone control. ONE name on every door (formerly
 `warmth` / `onePoleLowpass`).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "optimizer" to KlangSymbol(
        name = "optimizer",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "optimizer",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1"""),
                ),
                returnType = kt2,
                description = """Turns the graph optimizer off for this sound (`optimizer(0)`), so it renders exactly as
 written instead of having its filter chain fused.

 Fusing is meant to be inaudible, so this is a listening tool: put `.optimizer(0)` on a
 sound, compare by ear, and take it off again. Anything but 0 leaves the optimizer on.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "oversampleAtLeast" to KlangSymbol(
        name = "oversampleAtLeast",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "oversampleAtLeast",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "factor", type = kt5, description = """the lowest rate the body runs at, times the normal rate: 2, 4, 8 or 16."""),
                    KlangParam(name = "body", type = kt33, description = """a function from the signal to a signal, the stages that run at the higher rate."""),
                ),
                returnType = kt2,
                description = """Runs the stages in the body at [factor] times the normal sample rate AT LEAST: only what is missing is added, and
 when the rate is already there (inside an `oversampleBy(8)`, say) nothing is converted at all. The door for a
 reusable piece that needs a minimum rate:


 The factor and the body as in `oversampleBy`: read once per note, a power of two, at most 16x.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the preamp needs 4x; inside an 8x region it simply runs at 8x
let crunch = x => x.oversampleAtLeast(4, y => y.distort(0.3, "tube").highpass(90).distort(0.3, "tube"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "oversampleAtLeast",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt1, description = """the lowest rate the body runs at, times the normal rate: 2, 4, 8 or 16."""),
                    KlangParam(name = "body", type = kt35, description = """a function from a builder to a builder, given an empty one: the stages that run at the higher rate."""),
                ),
                returnType = kt3,
                description = """Runs the stages in the body at [factor] times the normal sample rate AT LEAST: only what is missing is added, and when
 the rate is already there (inside an `oversampleBy(8)`, say) nothing is converted at all. The door for a reusable
 piece that needs a minimum rate, and for an orbit that should run at a rate:


 The factor and the body as in `oversampleBy`: fixed with the chain, a power of two, at most 16x.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// a 4x orbit: everything on it is converted up once, distorted, and converted down once
let crunchBus = k => k.oversampleAtLeast(4, r => r.distort(0.4, "tube").distort(0.3, "soft"))
Katalyst(k => crunchBus(k).reverb(0.15, 4))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "oversampleBy" to KlangSymbol(
        name = "oversampleBy",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "oversampleBy",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "factor", type = kt5, description = """how many times the incoming rate: 2, 4, 8 or 16."""),
                    KlangParam(name = "body", type = kt33, description = """a function from the signal to a signal, the stages that run at the higher rate."""),
                ),
                returnType = kt2,
                description = """Runs the stages in the body at a HIGHER sample rate, the incoming rate times [factor], and comes back down once
 at the end: several distortion stages in a row share one trip up and one trip down instead of one each.


 The body is a function from the signal to a signal; the signal enters it converted up. Inside, every stage reads
 the region's rate, so a filter keeps its cutoff and an envelope its times. The factor is read once per note and
 rounded down to a power of two (3 is 2, 6 is 4); 1 or less runs the body at the rate it is in, and the rate stops
 at 16x. Nested, it steps on from the rate it is in: `oversampleBy(2)` inside `oversampleBy(2)` is 4x. Oscillators
 and noise stay at the normal rate and are converted up where they enter. For a piece that only needs a minimum
 rate, `oversampleAtLeast` adds nothing when the rate is already there.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// a three-stage preamp at 8x: the clippers alias less, and only one conversion up and one down
let preamp = x => x.oversampleBy(8, y => y
  .distort(0.30, "tube").highpass(100)
  .distort(0.45, "softsat").highpass(90)
  .distort(0.70, "soft"))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "oversampleBy",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "factor", type = kt1, description = """how many times the incoming rate: 2, 4, 8 or 16."""),
                    KlangParam(name = "body", type = kt35, description = """a function from a builder to a builder, given an empty one: the stages that run at the higher rate."""),
                ),
                returnType = kt3,
                description = """Runs the stages in the body at a HIGHER sample rate, the incoming rate times [factor], and comes back down once at
 the end: the bus is converted up once where it enters, whatever the voices on it are, and the stages inside alias
 less. At the head of a chain the whole orbit runs at that rate.


 The body is a function from a builder to a builder and receives an EMPTY one, the bus at this position, as a
 `parallel` branch does. Inside, every stage keeps its sound: a delay its time, a reverb its room, a filter its
 cutoff. The factor is fixed with the chain and rounded down to a power of two (3 is 2, 6 is 4); 1 or less runs the
 body at the rate it is in, and the rate stops at 16x. Nested, it steps on from the rate it is in. For a piece that only needs a
 minimum rate, `oversampleAtLeast` adds nothing when the rate is already there. A `duck` inside the body is the
 orbit's duck, as anywhere in the chain.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the orbit's distortion and its tone at 4x: one trip up and one down for the whole bus
Katalyst(k => k.oversampleBy(4, r => r.distort(0.5, "tube").eq(e => e.band(freq = 2500, q = 1.0, db = -3.0))).reverb(0.2, 5))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "parallel" to KlangSymbol(
        name = "parallel",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "parallel",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "branches", type = kt33, isVararg = true, description = """functions from a signal to a signal, each given this signal."""),
                ),
                returnType = kt2,
                description = """Runs this signal through the branches side by side and SUMS them, the twin of `serial`: `x.parallel(a, b)` is
 `a(x) + b(x)`, and every branch reads the same `x`, built once (a pitch node in a branch, a `vibrato` or a
 `detune`, forks it into a second instance, as it forks any shared signal).


 The sum is plain (two identical branches are twice the level); a branch's own `mul` sets the blend. A branch
 that delays the signal (an oversampling region) is matched in phase by the others, so the sum does
 not comb; a plain `plus` does not do that. With no branch, `parallel()` returns the signal as it is; with one,
 that branch's output. It builds what the Kotlin `IgnitorDsl.parallel(...)` builds, and checks every branch as
 `serial` checks a stage.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// parallel distortion: the clean signal and a screaming copy of its highs, a little under it
let screamer = x => x.parallel(clean => clean, dirt => dirt.highpass(720).distort(0.35).mul(0.6))
let guitar = Ignitor.saw().serial(screamer).adsr(0.005, 0.8, 0.0, 0.05).classic()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "parallel",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "branches", type = kt35, isVararg = true, description = """functions from a builder to a builder, each given an empty one."""),
                ),
                returnType = kt3,
                description = """Runs the bus through [branches] side by side, from this position, and SUMS them: the twin of [serial]. Each branch
 is a function from a builder to a builder and receives an EMPTY one, the bus at this point, so a branch is the chain
 of stages it appends; a branch that appends nothing is the dry bus.


 The sum is plain (two identical branches are twice the level, +6 dB); a branch's own `gain` sets the blend. A `reverb`
 or `delay` adds its return on top of the dry it is fed, so a branch with one carries the dry as well. A branch
 that delays the bus (a compressor's lookahead, an oversampling region) is matched in phase by the others, so the sum
 does not comb. With no branch, `parallel()` returns the chain as it is; with one, it appends that branch's stages in
 place, as written: a `classic()` in a branch is that branch's classic block, even next to one outside it (the
 at-most-once rule of [classic] holds per builder, and a branch is a builder of its own). A `duck` inside a branch is
 the orbit's duck, as anywhere in the chain. Every branch is checked like a stage of
 [serial]: one that is null, returns nothing or returns something other than the builder is a script error naming
 it.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// parallel distortion: the dry bus and a distorted copy, a quarter of its level
Katalyst(k => k.parallel(dry => dry, wet => wet.distort(0.5).gain(0.25)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "param" to KlangSymbol(
        name = "param",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "param",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "name", type = kt49, description = """parameter name — used for `ignitorParam` overrides and UI discovery"""),
                    KlangParam(name = "default", type = kt1, description = """constant value when no override is provided"""),
                    KlangParam(name = "description", type = kt49, isOptional = true, defaultDoc = """""""", description = """human-readable description for documentation"""),
                ),
                returnType = kt2,
                description = """Creates a named parameter slot with a default value.

 Param slots are the leaf nodes of the ignitor tree — they produce a constant signal
 at [default] unless the pattern writes the slot with `ignitorParam` at play time.

 `Ignitor.slot` holds the engine's open slots, most of them written by a sprudel door, so placing
 one of those wires that door into your instrument. The one to know is `pregain`: how hard the
 pattern plays INTO the instrument, written by `pregain(x)`, with the default 1.0 and no meaning of
 its own beyond where you place it. The sources' knobs are the others (`analog`, `voices`, `spread`,
 `duty`, `density`, `feedback`, `color`, `leak`, ...), and `declick`, the envelope's de-click, which
 no sprudel door writes. Reach for
 `Ignitor.slot.<name>` rather than retyping the name and the default here, so one default serves
 every instrument; a name of your own is what this door is for.

 A non-finite value written into a slot reads as UNSET: the leaf falls back to [default].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "param",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "name", type = kt49, description = """slot name, `<stage>.<knob>` for a classic knob or any word for an authored one"""),
                    KlangParam(name = "default", type = kt1, description = """the value the knob has while nothing writes the name"""),
                    KlangParam(name = "description", type = kt49, isOptional = true, defaultDoc = """""""", description = """human-readable description for documentation"""),
                ),
                returnType = kt4,
                description = """Creates a named **chain slot** with a default value: the knob a pattern can then move with
 `.katp("<name>", value)`, or with `.katp(slot, value)` when the slot is held in a variable.

 A slot is read per block from the orbit's owner, the newest note that is still held on it (its gate open; a release tail does not own), so it is orbit state and
 not a per-note snapshot. When nothing has written the name, the knob is [default]. Write a
 plain number instead of a slot where the chain should stay fixed.

 ```
 let bus = Katalyst(k => k.reverb(0.5, Katalyst.param("room", 5.0)))
 note("c3 e3 g3").s("supersaw").katalyst(bus).katp("room", "<2 9>")
 ```

 It returns a Katalyst knob (a [KatalystKnobDsl.Param], the wire node the chain carries), not a sound. It has the
 Ignitor's arithmetic words and `range` (step 4 of KLANG-00302 (katalyst knob expressions)):
 `Katalyst.param("fader", 1).times(0.5)` is a knob too, which the chain evaluates whenever the pattern writes the
 slot. `katp` writes the param, never an expression over it. An Ignitor node on a chain knob is a script error at
 the stage call.

 The twin of `Ignitor.param` on the other host: that one fills the voice's own instrument from
 `ignp`, this one the orbit's chain from `katp`. The two namespaces never cross, and the two kinds of param do
 not either: an `Ignitor.param` on a chain knob, or this one handed to `ignp` or placed in an Ignitor tree, is a
 script error at the call.

 Typed as the [KatalystKnobDsl] root on this door, as `Ignitor.param` is typed `IgnitorDsl`: the editor names the
 knob language rather than its leaf, and the Kotlin door's [KatalystDsl.Slots] carry the leaf type.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk12() = mapOf(

    "partial" to KlangSymbol(
        name = "partial",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "partial",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "ratio", type = kt5),
                    KlangParam(name = "gain", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                    KlangParam(name = "phase", type = kt5, isOptional = true, defaultDoc = """0.0"""),
                ),
                returnType = kt16,
                description = """Adds ONE sine partial at `ratio` times THIS sine's frequency, at `gain`, starting `phase` into its cycle; every call
 adds one more, kept in the order written. Any ratio, no integer rule, so a cluster of inharmonic partials is one
 sine (a drum's thud, a bell, a metal plate). `gain` is linear and raw (default 1), and a negative gain is the same
 partial at `phase + 0.5`. `phase` is a fraction of one cycle like the oscillators' `phase` (default 0, the upward zero
 crossing; 0.5 is the inverted partial, 0.25 starts on its peak); in a cluster the start phases decide how peaky the
 onset is. The partials sum raw with the sine's own partial and the other banks: a ratio of 1 doubles the
 fundamental, so a pure cluster writes `fundamental(0)`. A partial at or above Nyquist stays silent. Every argument is
 a number or a signal: a signal `gain` plays every sample, so each mode of a bell can have its own envelope
 (`partial(2.76, Ignitor.constant(0.5).adsr(0.001, 0.8, 0, 0.1))`, the same as that partial as its own sine under the
 same `adsr`); the ratio and the phase are read once per block (a moving ratio steps, a moving phase glides across the
 block). `analog` drifts every partial, `analogSpread` says whether they drift as one or each on its own. At most
 256 per sine; a song that adds more plays the first 256.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.fundamental(0).partial(0.6571, 0.52).partial(0.8714, 0.652, 0.5))   // two partials of a thud
Ignitor.sine(x => x.partial(ratio = 2.76, gain = 0.5, phase = 0.25))   // the sine and a bell-like overtone
Ignitor.sine(x => x.fundamental(0).partial(1, Ignitor.constant(1).adsr(0.001, 0.8, 0, 0.1))
  .partial(2.76, Ignitor.constant(0.5).adsr(0.001, 0.3, 0, 0.1)))    // a bell: each mode with its own decay""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "passes" to KlangSymbol(
        name = "passes",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "passes",
                receiver = kt10,
                params = listOf(
                    KlangParam(name = "n", type = kt5),
                ),
                returnType = kt10,
                description = """Cascade count: `2` = 24 dB/oct, `3` = 36. Rounded, coerced to 1..16. A number or a slot
 (`Ignitor.slot.lpf.passes`), read once at voice build; a moving signal reads as one pass. The per-stage q is
 STAGGERED (Butterworth ladder scaled by `q/0.707`), so at the default q the cascade stays -3 dB at
 the cutoff; a resonant q COMPOUNDS across stages (`q = 1.0, passes = 2` sits +3 dB there).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "perlin" to KlangSymbol(
        name = "perlin",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "perlin",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "rate", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """walk speed (default 1.0)."""),
                    KlangParam(name = "octaves", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """fractal-Brownian-motion octaves: 1 = plain (default), higher = more detail (capped at 8)."""),
                    KlangParam(name = "persistence", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """fBm amplitude falloff per octave (default 0.5; lower = quieter upper octaves)."""),
                ),
                returnType = kt2,
                description = """Creates a Perlin noise source (smooth organic noise).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "perlin",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "rate", type = kt5, description = """the walk's speed, required: the Ignitor's unit, 0.003 noise cells per sample at rate 1 (about 144 cells a second at 48 kHz, so an LFO-like drift wants a rate around 0.0005 to 0.01)."""),
                    KlangParam(name = "octaves", type = kt5, isOptional = true, defaultDoc = """1.0""", description = """fractal-Brownian-motion octaves: 1 = plain (default), higher = more detail (capped at 8)."""),
                    KlangParam(name = "persistence", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """fBm amplitude falloff per octave (default 0.5; lower = quieter upper octaves)."""),
                ),
                returnType = kt4,
                description = """A Perlin noise walk for a chain knob: smooth, organic drift in about `-1..1`, the Ignitor's `perlin`. Every
 build of a chain walks the same noise, and two noises in one chain walk different ones (the n-th noise of a
 chain is seeded by its position).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the room drifts slowly between size 3 and 7
Katalyst(k => k.reverb(0.3, Kat.perlin(0.0005).range(3, 7)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "phase" to KlangSymbol(
        name = "phase",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "phase",
                receiver = kt68,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt68,
                description = """Where in its cycle the vibrato's LFO runs: a fraction of one cycle added to its phase every sample (default 0), the
 oscillators' `phase` knob. Phase 0 starts the wobble in the middle of its swing, rising (on the note for the default
 `range(-1, 1)`; a quarter of the depth sharp for `range(0, 1)`); 0.25 starts it at its top, 0.5 in the middle,
 falling, 0.75 at its bottom (the note for `range(0, 1)`). It wraps: 1 is 0, 1.25 is 0.25, -0.25 is 0.75. A number is
 the start phase; a signal moves the phase while the note plays (a jump is a jump in pitch).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().vibrato(5, 0.5, v => v.phase(0.25))   // every note starts at the top of its wobble""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt16,
                description = """Where in its cycle the sine runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0 is
 `sin(0)`, the upward zero crossing. 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is 0.25, -0.25 is 0.75. A
 number is the start phase; a signal moves the phase while the note plays, which is phase modulation (a jump clicks).
 With partial banks every partial moves by the same fraction of its OWN cycle (the fundamental by `phase`): 0.5
 inverts the whole wave, other values change how the partials line up (0.25 starts every partial on its peak, the
 peakiest alignment, which matters ahead of a `distort` or `shape`). A partial that joins the bank mid-note (a moving
 count) starts at the phase applied so far, so at a phase other than 0 or 0.5 it enters with a step of up to its own
 gain (0.25 and 0.75 the largest), a click (raw); at 0 or 0.5 it enters on a zero crossing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(4, x => x.phase(0.25))   // an LFO that starts at its peak""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt17,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt17,
                description = """Where in its cycle the triangle runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0
 is -1, its lowest point, rising to +1 at 0.5. 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is 0.25, -0.25 is
 0.75. A number is the start phase; a signal moves the phase while the note plays, which is phase modulation (a jump
 clicks).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.tri(2, x => x.phase(0.5))   // starts at its top""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt18,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt18,
                description = """Where in its cycle the zawtooth runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0
 is -1, the bottom of its rise (the reset ends the cycle). 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is
 0.25, -0.25 is 0.75. A number is the start phase; a signal moves the phase while the note plays, which is phase
 modulation (a jump clicks).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.zawtooth(x => x.phase(0.5))   // starts mid-rise, at 0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt19,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt19,
                description = """Where in its cycle the zamp runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0 is
 +1, the top of its fall (the reset ends the cycle). 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is 0.25,
 -0.25 is 0.75. A number is the start phase; a signal moves the phase while the note plays, which is phase modulation
 (a jump clicks).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.zamp(x => x.phase(0.5))   // starts mid-fall, at 0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt20,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt20,
                description = """Where in its cycle the impulse runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0 is
 the spike: the note starts on it. 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is 0.25, -0.25 is 0.75. A
 number is the start phase; a signal moves the phase while the note plays, which is phase modulation (a jump clicks).
 The spike sits where the shifted phase passes 0 going forward, so a start phase of 0.25 spikes first after three
 quarters of a cycle, and a step back (within half a cycle) spikes nothing.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.impulse(2, x => x.phase(0.5))   // the first spike half a cycle in""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt21,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt21,
                description = """Where in its cycle the raw pulse runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0
 is +1, the start of its high plateau: the instant rising edge sits at the wrap (high until `duty`, then low). So
 `pulze` starts high where the rounded `square` starts low, on the other side of its rising edge. 0.5 is half a cycle
 on, and it wraps, no clamp: 1.25 is 0.25, -0.25 is 0.75. A number is the start phase; a signal moves the phase while
 the note plays, which is phase modulation (a jump clicks).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.pulze(2, x => x.phase(0.5))   // a gate LFO that starts closed (low), then opens""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt22,
                description = """Where in its cycle the square runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0 is
 -1, the foot of its rising edge (rise, high until `duty`, fall, low), where the raw `pulze` starts high. 0.5 is half
 a cycle on, and it wraps, no clamp: 1.25 is 0.25, -0.25 is 0.75. A number is the start phase; a signal moves the
 phase while the note plays, which is phase modulation (a jump clicks). A fast-moving phase also squeezes the soft
 edges (sized from the note's own pitch), which then alias as the raw twin's do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.square(2, x => x.phase(0.5))   // an LFO that starts on its falling edge""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt23,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt23,
                description = """Where in its cycle the sawtooth runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0
 is -1, the bottom of its rise (the flyback ends the cycle). 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is
 0.25, -0.25 is 0.75. A number is the start phase; a signal moves the phase while the note plays, which is phase
 modulation (a jump clicks). A fast-moving phase also squeezes the soft edges (sized from the note's own pitch),
 which then alias as the raw twin's do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw(x => x.phase(0.5))   // starts mid-rise, at 0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt24,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt24,
                description = """Where in its cycle the ramp runs: a fraction of one cycle added to its phase every sample (default 0). Phase 0 is
 +1, the top of its fall (the flyback ends the cycle). 0.5 is half a cycle on, and it wraps, no clamp: 1.25 is 0.25,
 -0.25 is 0.75. A number is the start phase; a signal moves the phase while the note plays, which is phase modulation
 (a jump clicks). A fast-moving phase also squeezes the soft edges (sized from the note's own pitch), which then
 alias as the raw twin's do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.ramp(x => x.phase(0.5))   // starts mid-fall, at 0""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt25,
                description = """Shifts the whole stack in its cycle: a fraction of one cycle added to every voice's phase every sample (default 0),
 every voice by the same fraction of its own cycle, so the spread of start phases stays as drawn. Each voice starts
 at its own random phase (or the phase pool's), measured from the saw's phase 0, which is -1, the bottom of its rise.
 Because those start phases are drawn anew for every note, a constant shift on its own is not audible: the stack's
 use is a MOVING phase, phase modulation of the whole stack. It wraps, no clamp (1.25 is 0.25); a jump clicks. A
 fast-moving phase also squeezes the soft edges (sized from the note's own pitch), which then alias as the raw twin's
 do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersaw(x => x.voices(5).phase(Ignitor.sine(5).mul(0.2)))   // phase modulation: a 5 Hz wobble on every voice""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt26,
                description = """Shifts the whole stack in its cycle: a fraction of one cycle added to every voice's phase every sample (default 0),
 every voice by the same fraction of its own cycle, so the spread of start phases stays as drawn. Each voice starts
 at its own random phase (or the phase pool's), measured from the sine's phase 0, which is `sin(0)`, the upward zero
 crossing. Because those start phases are drawn anew for every note, a constant shift on its own is not audible: the
 stack's use is a MOVING phase, phase modulation of the whole stack. It wraps, no clamp (1.25 is 0.25); a jump
 clicks.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersine(x => x.voices(5).phase(Ignitor.sine(5).mul(0.2)))   // phase modulation: a 5 Hz wobble on every voice""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt27,
                description = """Shifts the whole stack in its cycle: a fraction of one cycle added to every voice's phase every sample (default 0),
 every voice by the same fraction of its own cycle, so the spread of start phases stays as drawn. Each voice starts
 at its own random phase (or the phase pool's), measured from the square's phase 0, which is -1, the foot of its
 rising edge. Because those start phases are drawn anew for every note, a constant shift on its own is not audible:
 the stack's use is a MOVING phase, phase modulation of the whole stack. It wraps, no clamp (1.25 is 0.25); a jump
 clicks. A fast-moving phase also squeezes the soft edges (sized from the note's own pitch), which then alias as the
 raw twin's do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersquare(x => x.voices(5).phase(Ignitor.sine(5).mul(0.2)))   // phase modulation: a 5 Hz wobble on every voice""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt28,
                description = """Shifts the whole stack in its cycle: a fraction of one cycle added to every voice's phase every sample (default 0),
 every voice by the same fraction of its own cycle, so the spread of start phases stays as drawn. Each voice starts
 at its own random phase (or the phase pool's), measured from the triangle's phase 0, which is -1, its lowest point.
 Because those start phases are drawn anew for every note, a constant shift on its own is not audible: the stack's
 use is a MOVING phase, phase modulation of the whole stack. It wraps, no clamp (1.25 is 0.25); a jump clicks.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supertri(x => x.voices(5).phase(Ignitor.sine(5).mul(0.2)))   // phase modulation: a 5 Hz wobble on every voice""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt29,
                description = """Shifts the whole stack in its cycle: a fraction of one cycle added to every voice's phase every sample (default 0),
 every voice by the same fraction of its own cycle, so the spread of start phases stays as drawn. Each voice starts
 at its own random phase (or the phase pool's), measured from the ramp's phase 0, which is +1, the top of its fall.
 Because those start phases are drawn anew for every note, a constant shift on its own is not audible: the stack's
 use is a MOVING phase, phase modulation of the whole stack. It wraps, no clamp (1.25 is 0.25); a jump clicks. A
 fast-moving phase also squeezes the soft edges (sized from the note's own pitch), which then alias as the raw twin's
 do.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.superramp(x => x.voices(5).phase(Ignitor.sine(5).mul(0.2)))   // phase modulation: a 5 Hz wobble on every voice""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt69,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt69,
                description = """Where in its cycle the sine is read, in cycles (default 0, the upward zero crossing): 0.25 starts it on its peak,
 and it wraps, no clamp. A constant is the start phase; a moving one shifts the reading point every block.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Katalyst(k => k.gain(Kat.sine(0.5, x => x.phase(0.25)).range(0.5, 1)))   // starts at full level, then dips""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt70,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt70,
                description = """Where in its cycle the saw is read, in cycles (default 0, the bottom of its rise): 0.5 starts it at 0, mid-rise, and
 it wraps, no clamp.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt71,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt71,
                description = """Where in its cycle the ramp is read, in cycles (default 0, the top of its fall): 0.5 starts it at 0, mid-fall, and it
 wraps, no clamp.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt72,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt72,
                description = """Where in its cycle the triangle is read, in cycles (default 0, its lowest point): 0.5 starts it at its top, and it
 wraps, no clamp.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phase",
                receiver = kt56,
                params = listOf(
                    KlangParam(name = "phase", type = kt5),
                ),
                returnType = kt56,
                description = """Where in its cycle the square is read, in cycles (default 0, the foot of its rising edge): 0.5 starts it on its
 falling edge, and it wraps, no clamp.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "phasePool" to KlangSymbol(
        name = "phasePool",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "phasePool",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1.0""", description = """1 = banded start-phase selection on, 0 = off (the engine default)."""),
                    KlangParam(name = "kMin", type = kt1, isOptional = true, defaultDoc = """0.30""", description = """accepted coherence band, lower edge (0 = cancelled, 1 = phase-aligned)."""),
                    KlangParam(name = "kMax", type = kt1, isOptional = true, defaultDoc = """0.55""", description = """accepted coherence band, upper edge. The band is also a timbre control."""),
                    KlangParam(name = "drawTries", type = kt1, isOptional = true, defaultDoc = """5.0""", description = """candidate phase sets scored per draw (engine caps at 64)."""),
                    KlangParam(name = "poolSize", type = kt1, isOptional = true, defaultDoc = """256.0""", description = """vocabulary size per pool key (engine caps at 1024)."""),
                    KlangParam(name = "refreshEvery", type = kt1, isOptional = true, defaultDoc = """10.0""", description = """notes between fresh pool draws; 0 = frozen pool."""),
                    KlangParam(name = "selection", type = kt49, isOptional = true, defaultDoc = """"normal"""", description = """serving mode, `"name[:width[:outliers]]"`, see **Selection modes** above."""),
                    KlangParam(name = "warmup", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """entries seeded eagerly at pool creation (work-capped; 0 = fully lazy)."""),
                ),
                returnType = kt25,
                description = """Configure the banded start-phase pool in ONE call. Every param is an optional plain
 literal, so named-arg subsets work: `.phasePool()` (on, family defaults),
 `.phasePool(kMin = 0.2)`, `.phasePool(refreshEvery = 0)` (all-named or all-positional,
 KlangScript forbids mixing). Defaults mirror this family's engine constants.

 **Selection modes** (`selection`, value-colon form `"name[:width[:outliers]]"`):
 - `"normal"` (default): normal-distribution serving over the pool's vocabulary, centered on
   the median (most typical) take. `width` sets the spread: `0` = always the median take,
   `0.1` = tight, `0.5` = default, `1` and above is near uniform (`"normal:1.5"` is random
   with a slight center edge). `outliers` (0..1, default 0) is the probability of serving an
   EXTREME take instead, the vocabulary's lowest- or highest-K entry (coin-flip side).
   `"normal:0.1:0.05"` = tight, 5% wild plucks.
 - `"random"`: a uniformly random vocabulary entry each note (still band-accepted takes).
 - `"roundrobin"` (opt-in): cycle the vocabulary; can gargle audibly.

 Unrecognized names or coefficients coerce to their defaults.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phasePool",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1.0""", description = """1 = banded start-phase selection on, 0 = off (the engine default)."""),
                    KlangParam(name = "kMin", type = kt1, isOptional = true, defaultDoc = """0.50""", description = """accepted coherence band, lower edge (0 = cancelled, 1 = phase-aligned)."""),
                    KlangParam(name = "kMax", type = kt1, isOptional = true, defaultDoc = """0.80""", description = """accepted coherence band, upper edge. The band is also a timbre control."""),
                    KlangParam(name = "drawTries", type = kt1, isOptional = true, defaultDoc = """40.0""", description = """candidate phase sets scored per draw (engine caps at 64)."""),
                    KlangParam(name = "poolSize", type = kt1, isOptional = true, defaultDoc = """256.0""", description = """vocabulary size per pool key (engine caps at 1024)."""),
                    KlangParam(name = "refreshEvery", type = kt1, isOptional = true, defaultDoc = """10.0""", description = """notes between fresh pool draws; 0 = frozen pool."""),
                    KlangParam(name = "selection", type = kt49, isOptional = true, defaultDoc = """"normal"""", description = """serving mode, `"name[:width[:outliers]]"`, see **Selection modes** above."""),
                    KlangParam(name = "warmup", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """entries seeded eagerly at pool creation (work-capped; 0 = fully lazy)."""),
                ),
                returnType = kt26,
                description = """Configure the banded start-phase pool in ONE call. Every param is an optional plain
 literal, so named-arg subsets work: `.phasePool()` (on, family defaults),
 `.phasePool(kMin = 0.2)`, `.phasePool(refreshEvery = 0)` (all-named or all-positional,
 KlangScript forbids mixing). Defaults mirror this family's engine constants.

 **Selection modes** (`selection`, value-colon form `"name[:width[:outliers]]"`):
 - `"normal"` (default): normal-distribution serving over the pool's vocabulary, centered on
   the median (most typical) take. `width` sets the spread: `0` = always the median take,
   `0.1` = tight, `0.5` = default, `1` and above is near uniform (`"normal:1.5"` is random
   with a slight center edge). `outliers` (0..1, default 0) is the probability of serving an
   EXTREME take instead, the vocabulary's lowest- or highest-K entry (coin-flip side).
   `"normal:0.1:0.05"` = tight, 5% wild plucks.
 - `"random"`: a uniformly random vocabulary entry each note (still band-accepted takes).
 - `"roundrobin"` (opt-in): cycle the vocabulary; can gargle audibly.

 Unrecognized names or coefficients coerce to their defaults.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phasePool",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1.0""", description = """1 = banded start-phase selection on, 0 = off (the engine default)."""),
                    KlangParam(name = "kMin", type = kt1, isOptional = true, defaultDoc = """0.30""", description = """accepted coherence band, lower edge (0 = cancelled, 1 = phase-aligned)."""),
                    KlangParam(name = "kMax", type = kt1, isOptional = true, defaultDoc = """0.55""", description = """accepted coherence band, upper edge. The band is also a timbre control."""),
                    KlangParam(name = "drawTries", type = kt1, isOptional = true, defaultDoc = """5.0""", description = """candidate phase sets scored per draw (engine caps at 64)."""),
                    KlangParam(name = "poolSize", type = kt1, isOptional = true, defaultDoc = """256.0""", description = """vocabulary size per pool key (engine caps at 1024)."""),
                    KlangParam(name = "refreshEvery", type = kt1, isOptional = true, defaultDoc = """10.0""", description = """notes between fresh pool draws; 0 = frozen pool."""),
                    KlangParam(name = "selection", type = kt49, isOptional = true, defaultDoc = """"normal"""", description = """serving mode, `"name[:width[:outliers]]"`, see **Selection modes** above."""),
                    KlangParam(name = "warmup", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """entries seeded eagerly at pool creation (work-capped; 0 = fully lazy)."""),
                ),
                returnType = kt27,
                description = """Configure the banded start-phase pool in ONE call. Every param is an optional plain
 literal, so named-arg subsets work: `.phasePool()` (on, family defaults),
 `.phasePool(kMin = 0.2)`, `.phasePool(refreshEvery = 0)` (all-named or all-positional,
 KlangScript forbids mixing). Defaults mirror this family's engine constants.

 **Selection modes** (`selection`, value-colon form `"name[:width[:outliers]]"`):
 - `"normal"` (default): normal-distribution serving over the pool's vocabulary, centered on
   the median (most typical) take. `width` sets the spread: `0` = always the median take,
   `0.1` = tight, `0.5` = default, `1` and above is near uniform (`"normal:1.5"` is random
   with a slight center edge). `outliers` (0..1, default 0) is the probability of serving an
   EXTREME take instead, the vocabulary's lowest- or highest-K entry (coin-flip side).
   `"normal:0.1:0.05"` = tight, 5% wild plucks.
 - `"random"`: a uniformly random vocabulary entry each note (still band-accepted takes).
 - `"roundrobin"` (opt-in): cycle the vocabulary; can gargle audibly.

 Unrecognized names or coefficients coerce to their defaults.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phasePool",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1.0""", description = """1 = banded start-phase selection on, 0 = off (the engine default)."""),
                    KlangParam(name = "kMin", type = kt1, isOptional = true, defaultDoc = """0.40""", description = """accepted coherence band, lower edge (0 = cancelled, 1 = phase-aligned)."""),
                    KlangParam(name = "kMax", type = kt1, isOptional = true, defaultDoc = """0.65""", description = """accepted coherence band, upper edge. The band is also a timbre control."""),
                    KlangParam(name = "drawTries", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """candidate phase sets scored per draw (engine caps at 64)."""),
                    KlangParam(name = "poolSize", type = kt1, isOptional = true, defaultDoc = """256.0""", description = """vocabulary size per pool key (engine caps at 1024)."""),
                    KlangParam(name = "refreshEvery", type = kt1, isOptional = true, defaultDoc = """10.0""", description = """notes between fresh pool draws; 0 = frozen pool."""),
                    KlangParam(name = "selection", type = kt49, isOptional = true, defaultDoc = """"normal"""", description = """serving mode, `"name[:width[:outliers]]"`, see **Selection modes** above."""),
                    KlangParam(name = "warmup", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """entries seeded eagerly at pool creation (work-capped; 0 = fully lazy)."""),
                ),
                returnType = kt28,
                description = """Configure the banded start-phase pool in ONE call. Every param is an optional plain
 literal, so named-arg subsets work: `.phasePool()` (on, family defaults),
 `.phasePool(kMin = 0.2)`, `.phasePool(refreshEvery = 0)` (all-named or all-positional,
 KlangScript forbids mixing). Defaults mirror this family's engine constants.

 **Selection modes** (`selection`, value-colon form `"name[:width[:outliers]]"`):
 - `"normal"` (default): normal-distribution serving over the pool's vocabulary, centered on
   the median (most typical) take. `width` sets the spread: `0` = always the median take,
   `0.1` = tight, `0.5` = default, `1` and above is near uniform (`"normal:1.5"` is random
   with a slight center edge). `outliers` (0..1, default 0) is the probability of serving an
   EXTREME take instead, the vocabulary's lowest- or highest-K entry (coin-flip side).
   `"normal:0.1:0.05"` = tight, 5% wild plucks.
 - `"random"`: a uniformly random vocabulary entry each note (still band-accepted takes).
 - `"roundrobin"` (opt-in): cycle the vocabulary; can gargle audibly.

 Unrecognized names or coefficients coerce to their defaults.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phasePool",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "on", type = kt1, isOptional = true, defaultDoc = """1.0""", description = """1 = banded start-phase selection on, 0 = off (the engine default)."""),
                    KlangParam(name = "kMin", type = kt1, isOptional = true, defaultDoc = """0.30""", description = """accepted coherence band, lower edge (0 = cancelled, 1 = phase-aligned)."""),
                    KlangParam(name = "kMax", type = kt1, isOptional = true, defaultDoc = """0.55""", description = """accepted coherence band, upper edge. The band is also a timbre control."""),
                    KlangParam(name = "drawTries", type = kt1, isOptional = true, defaultDoc = """5.0""", description = """candidate phase sets scored per draw (engine caps at 64)."""),
                    KlangParam(name = "poolSize", type = kt1, isOptional = true, defaultDoc = """256.0""", description = """vocabulary size per pool key (engine caps at 1024)."""),
                    KlangParam(name = "refreshEvery", type = kt1, isOptional = true, defaultDoc = """10.0""", description = """notes between fresh pool draws; 0 = frozen pool."""),
                    KlangParam(name = "selection", type = kt49, isOptional = true, defaultDoc = """"normal"""", description = """serving mode, `"name[:width[:outliers]]"`, see **Selection modes** above."""),
                    KlangParam(name = "warmup", type = kt1, isOptional = true, defaultDoc = """16.0""", description = """entries seeded eagerly at pool creation (work-capped; 0 = fully lazy)."""),
                ),
                returnType = kt29,
                description = """Configure the banded start-phase pool in ONE call. Every param is an optional plain
 literal, so named-arg subsets work: `.phasePool()` (on, family defaults),
 `.phasePool(kMin = 0.2)`, `.phasePool(refreshEvery = 0)` (all-named or all-positional,
 KlangScript forbids mixing). Defaults mirror this family's engine constants.

 **Selection modes** (`selection`, value-colon form `"name[:width[:outliers]]"`):
 - `"normal"` (default): normal-distribution serving over the pool's vocabulary, centered on
   the median (most typical) take. `width` sets the spread: `0` = always the median take,
   `0.1` = tight, `0.5` = default, `1` and above is near uniform (`"normal:1.5"` is random
   with a slight center edge). `outliers` (0..1, default 0) is the probability of serving an
   EXTREME take instead, the vocabulary's lowest- or highest-K entry (coin-flip side).
   `"normal:0.1:0.05"` = tight, 5% wild plucks.
 - `"random"`: a uniformly random vocabulary entry each note (still band-accepted takes).
 - `"roundrobin"` (opt-in): cycle the vocabulary; can gargle audibly.

 Unrecognized names or coefficients coerce to their defaults.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "phaser" to KlangSymbol(
        name = "phaser",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "phaser",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "wet", type = kt5, description = """wet/dry balance, 0..1 (0 is a bit-exact bypass)."""),
                    KlangParam(name = "rate", type = kt5, description = """sweep rate in Hz."""),
                    KlangParam(name = "center", type = kt5, isOptional = true, defaultDoc = """1000.0""", description = """sweep center frequency in Hz (default 1000)."""),
                    KlangParam(name = "sweep", type = kt5, isOptional = true, defaultDoc = """1000.0""", description = """sweep width in Hz (default 1000)."""),
                    KlangParam(name = "configure", type = kt73, isOptional = true, defaultDoc = """null""", description = """receives the [PhaserBuilder] (knob: `floor`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies a multi-stage phaser effect. [wet] comes FIRST, as on every door that has one, and
 both [wet] and [rate] are required, because a positional rate follows the wet. The dry floor
 is a knob on the [PhaserBuilder]: `.phaser(0.3, 0.5, x => x.floor(0.2))`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "phaser",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt43, isOptional = true, defaultDoc = """null""", description = """wet amount, 0 to 1 (default 0, off). Orbit twin: `phaser(wet = ...)`."""),
                    KlangParam(name = "rate", type = kt43, isOptional = true, defaultDoc = """null""", description = """sweep rate in Hz (default 0, standing still). Orbit twin: `phaser(rate = ...)`."""),
                    KlangParam(name = "center", type = kt43, isOptional = true, defaultDoc = """null""", description = """center frequency of the sweep in Hz (default 1000). Orbit twin: `phaser(center = ...)`."""),
                    KlangParam(name = "sweep", type = kt43, isOptional = true, defaultDoc = """null""", description = """width of the sweep around the center, in Hz (default 1000). Orbit twin: `phaser(sweep = ...)`."""),
                    KlangParam(name = "configure", type = kt74, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystPhaserBuilder] (knob: `floor`) and returns it."""),
                ),
                returnType = kt3,
                description = """Appends an orbit phaser: a sweeping all-pass notch comb.

 A bare `k.phaser()` is declared and silent, because its default wet is 0; give it a `wet`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pickPosition" to KlangSymbol(
        name = "pickPosition",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pickPosition",
                receiver = kt30,
                params = listOf(
                    KlangParam(name = "pickPosition", type = kt5),
                ),
                returnType = kt30,
                description = """Relative pick position along the string (default 0.5). 0 = bridge, 1 = nut.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "pickPosition",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "pickPosition", type = kt5),
                ),
                returnType = kt31,
                description = """Relative pick position along the string (default 0.5). 0 = bridge, 1 = nut.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pinknoise" to KlangSymbol(
        name = "pinknoise",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pinknoise",
                receiver = kt41,
                params = emptyList(),
                returnType = kt2,
                description = """Creates a pink noise source (1/f spectrum). Each call yields a fresh DSL instance.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk13() = mapOf(

    "pitchEnvelope" to KlangSymbol(
        name = "pitchEnvelope",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pitchEnvelope",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "semitones", type = kt5),
                    KlangParam(name = "configure", type = kt75, isOptional = true, defaultDoc = """null""", description = """receives the [PitchEnvelopeBuilder] (knob: `adsr`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies a pitch envelope (pitch sweep over time). [semitones] is the shift at the envelope
 peak; the stages are ONE `adsr` call on the [PitchEnvelopeBuilder], the chain `adsr`'s
 pattern: `pitchEnvelope(24, x => x.adsr(0.001, 0.05, 0, 0))` sweeps a kick from two octaves
 up down to the note. That `adsr` takes its own lambda to shape the stages with `curves`
 (`x => x.adsr(0.001, 0.05, 0, 0, e => e.curves("lin", "exp", "exp"))`); unshaped stages are
 exponential. Without the lambda the stages are `adsr(0.01, 0.1, 0, 0)`. The release returns the
 pitch to the note from the gate's end and does not extend the voice's life.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pitchMod" to KlangSymbol(
        name = "pitchMod",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pitchMod",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "mod", type = kt5),
                ),
                returnType = kt2,
                description = """Pitch modulation by any signal, the LINEAR law: the frequency is multiplied by `1 + mod`, per sample. [mod] is
 a deviation, unitless: 0 is no change, 1.0 an octave up, -0.5 an octave down, -1.0 stops the oscillator. FM's
 law: `Ignitor.sine().pitchMod(Ignitor.sine(5).mul(0.01))` swings the pitch 1 % either way. In semitones:
 `pitchModSemitones`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pitchModSemitones" to KlangSymbol(
        name = "pitchModSemitones",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pitchModSemitones",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "mod", type = kt5),
                ),
                returnType = kt2,
                description = """Pitch modulation by any signal, in SEMITONES: the frequency is multiplied by `2^(mod / 12)`, per sample. 12 is
 an octave up, 7 a fifth, -12 an octave down, 0 the note. `Ignitor.saw().pitchModSemitones(Ignitor.sine(5).mul(0.5))`
 is a vibrato half a semitone deep; `pitchModSemitones(7)` plays a fifth up. The pitch law of `vibrato`,
 `accelerate` and `pitchEnvelope`, for any signal. The linear law (`1 + mod`, FM's): `pitchMod`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pluck" to KlangSymbol(
        name = "pluck",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pluck",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt76, isOptional = true, defaultDoc = """null""", description = """receives the [OscPluckBuilder] (knobs: `feedback`, `brightness`, `pickPosition`, `stiffness`, `analog`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a Karplus-Strong plucked string model.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.pluck(x => x.feedback(0.99).brightness(0.45).pickPosition(0.5))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "plus" to KlangSymbol(
        name = "plus",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("add"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "plus",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Adds two ignitor signals together (summing).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "plus",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Adds [other] to every sample of the bus. A constant is a DC offset: before a `distort` it clips the two halves of
 the wave differently. The output's DC blocker removes what reaches it, but an orbit whose mix never falls silent
 never switches off, so an offset keeps its orbit running.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "plus",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob plus [other]: an offset. The Ignitor's `plus` law, unclamped.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Katalyst(k => k.reverb(0.3, Kat.param("room", 4).plus(2)))   // the room is 2 larger than the slot says""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "pow" to KlangSymbol(
        name = "pow",
        category = "math",
        tags = listOf("arithmetic", "exponent"),
        aliases = listOf("power"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pow",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "base", type = kt1, description = """The base number"""),
                    KlangParam(name = "exp", type = kt1, description = """The exponent"""),
                ),
                returnType = kt1,
                description = """Returns base raised to the power of exp.""",
                returnDoc = """base raised to exp""",
                samples = listOf(
                    KlangCodeSample(code = """Math.pow(2, 10)  // 1024.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "exp", type = kt5),
                ),
                returnType = kt2,
                description = """Raises this signal to the power of [exp] (per-sample).
 Signed-magnitude: negative bases produce `-(|base|^exp)` to avoid `NaN`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "exp", type = kt1, description = """The exponent"""),
                ),
                returnType = kt1,
                description = """Raises the number to the power of exp.

 The reason this exists: `^` is bitwise XOR, not exponentiation, so `2^(7/12)` is 2 and not a
 perfect fifth. Write `2.pow(7/12)` (or `2 ** (7/12)`) instead.""",
                returnDoc = """self raised to exp""",
                samples = listOf(
                    KlangCodeSample(code = """2.pow(7/12)  // 1.4983, a perfect fifth""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "exp", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Raises every sample of the bus to the power of [exp], keeping its sign (a negative sample gives `-(|x|^exp)`), as
 the Ignitor's `pow`. Above 1 the quiet parts sink, below 1 they rise. A negative [exp] turns every silent sample
 into the clamp's ceiling (1e15, the house limiter's business), so it belongs after something that never rests at
 zero, and it keeps its orbit running.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "pow",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "exp", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob to the power of [exp], keeping its sign (a negative base gives `-(|base|^exp)`). The Ignitor's `pow` law,
 clamped to `±1e15`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "power" to KlangSymbol(
        name = "power",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("pow"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "power",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "exp", type = kt5),
                ),
                returnType = kt2,
                description = """Raises this signal to the power of [exp]. Alias for [pow].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "power",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "exp", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Raises every sample of the bus to the power of [exp]. Alias for [pow].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "power",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "exp", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob to the power of [exp]. Alias for [pow].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "pregain" to KlangSymbol(
        name = "pregain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pregain",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Places the `pregain` slot here: how hard the pattern plays INTO whatever follows.

 Exactly `mul(Ignitor.slot.pregain)`, and written as a call to [mul] so the two spellings cannot
 drift into two operand orders: one tree, one content id. It takes no argument on purpose:
 the slot IS the parameter, and the pattern moves it with `pregain(x)`.

 Put it in front of the nonlinearity it should drive, once. It changes TIMBRE only because
 of what follows it; with nothing nonlinear after it, it is a plain level, and `gain` is
 the tone-neutral level word.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().pregain().distort(0.5)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk14() = mapOf(

    "pulze" to KlangSymbol(
        name = "pulze",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "pulze",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt77, isOptional = true, defaultDoc = """null""", description = """receives the [OscPulzeBuilder] (knobs: `duty`, `analog`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a raw pulse ("pulze"): a naive, aliased pulse with variable duty cycle (the raw counterpart of [square]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.pulze(x => x.duty(0.3))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "ramp" to KlangSymbol(
        name = "ramp",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "ramp",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt78, isOptional = true, defaultDoc = """null""", description = """receives the [OscRampBuilder] (knobs: `analog`, `resetSamples`, `shapeMax`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a ramp (reverse sawtooth) wave oscillator.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.ramp(x => x.resetSamples(4.0).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "ramp",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "freq", type = kt5, description = """the rate in Hz, required: a number, a `Kat.param` or a Kat expression."""),
                    KlangParam(name = "configure", type = kt79, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystRampBuilder] (knob: `phase`) and returns it."""),
                ),
                returnType = kt4,
                description = """A ramp (falling sawtooth) LFO for a chain knob: falls from 1 to -1 over each cycle at [freq] Hz.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the room shrinks from size 8 to 2 every four seconds
Katalyst(k => k.reverb(0.3, Kat.ramp(0.25).range(2, 8)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "range" to KlangSymbol(
        name = "range",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "range",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "from", type = kt5),
                    KlangParam(name = "to", type = kt5),
                ),
                returnType = kt2,
                description = """Lets this signal swing between [from] and [to], per sample. The standard LFO scaler.

 The oscillators swing between `-1` and `1`; `range` maps `-1` to [from] and `1` to [to], linearly. Where the
 swing sits is up to the two values:

 | Call              | The signal moves                                      |
 |-------------------|-------------------------------------------------------|
 | `range(0, 1)`     | only upward, between 0 and 1                          |
 | `range(-1, 0)`    | only downward, between -1 and 0                       |
 | `range(-1, 1)`    | both ways, centred on 0 (the oscillator as it is)     |
 | `range(-0.5, 1)`  | mostly upward, dipping a little below 0               |
 | `range(1, 0)`     | the same swing turned upside down                     |

 Sprudel's signals swing between `0` and `1` instead, and their `range(from, to)` gives the same result:
 `x.range(200, 400)` swings between 200 and 400 in both DSLs. To get from `0..1` to `-1..1` without a range,
 `x.mul(2).minus(1)`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().lowpass(Ignitor.sine(0.5).range(400, 2000))   // the cutoff sweeps 400 to 2000 Hz
Ignitor.sine().mul(Ignitor.sine(5).range(0.6, 1))            // a tremolo that only ever dips""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "range",
                receiver = kt80,
                params = listOf(
                    KlangParam(name = "from", type = kt5),
                    KlangParam(name = "to", type = kt5),
                ),
                returnType = kt80,
                description = """Where the tremolo's swing sits, in the -1..1 language of the Ignitor `range`: the LFO's low point maps to [from],
 its high point to [to], and the gain is `1 + depth * that`, so the depth on the door stays the musical knob.
 The default `range(-1, 0)` is the tremolo as it always was, the level dipping from 1 to `1 - depth`. `range(0, 1)`
 swells upward from 1 to `1 + depth` (louder, so mind the headroom), `range(-1, 1)` swings both ways, `range(0, 2)`
 twice the depth upward. Raw, no clamp. Both values are signals, read like the depth.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().tremolo(4, 0.3, x => x.range(-1, 1))   // the level swings from 0.7 to 1.3""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "range",
                receiver = kt68,
                params = listOf(
                    KlangParam(name = "from", type = kt5),
                    KlangParam(name = "to", type = kt5),
                ),
                returnType = kt68,
                description = """Where the vibrato's swing sits, in the -1..1 language of the Ignitor `range`: the LFO's -1 maps to [from], its +1
 to [to], and the depth on the door (in semitones) scales that, so it stays the musical knob. The default
 `range(-1, 1)` swings both ways around the note, the vibrato as it always was. `range(0, 1)` swings only upward, as a
 guitarist bends a fretted string; `range(-1, 0)` only downward; `range(1, -1)` turns the LFO upside down. Raw, no
 clamp. Both values are signals, read like the depth. The LFO starts in the middle of the swing (`phase` 0), so an
 upward-only vibrato starts on the note with `phase(0.75)`, a downward-only one with `phase(0.25)`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().vibrato(5, 0.5, v => v.range(0, 1).phase(0.75))   // from the note up to half a semitone, never below""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "range",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "from", type = kt5, description = """the value at -1, a number, a `Kat.param` or a Kat expression."""),
                    KlangParam(name = "to", type = kt5, description = """the value at 1, a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """Maps this knob from `-1..1` onto [from]..[to], linearly and unclamped: `from + (x + 1) * 0.5 * (to - from)`, the
 Ignitor's `range` law. A value outside `-1..1` lands outside the bounds.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// one slot from -1 to 1 sweeps the phaser's center from 400 to 1600 Hz
Katalyst(k => k.phaser(wet = 0.5, center = Kat.param("sweep", 0).range(400, 1600)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "rangex" to KlangSymbol(
        name = "rangex",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "rangex",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "from", type = kt5),
                    KlangParam(name = "to", type = kt5),
                ),
                returnType = kt2,
                description = """Lets this signal swing between [from] and [to] exponentially, per sample: the exponential twin of [range],
 perceptually even for frequencies.

 `range` takes equal steps of the signal to equal DIFFERENCES, `rangex` to equal RATIOS:
 `from · (to / from)^((x + 1) / 2)`. So in a sweep from 200 to 3200 Hz each octave takes the same share of the
 swing (with a saw or a triangle, the same time), which is what the ear hears as even; with `range` the low
 octaves would rush by. A sine dwells at its ends, so it lingers in the lowest and the highest octave.

 | The oscillator is | `rangex(200, 3200)` gives                  |
 |-------------------|--------------------------------------------|
 | `-1`              | 200, [from]                                |
 | `0`               | 800, the geometric mean `√(from · to)`     |
 | `1`               | 3200, [to]                                 |

 `rangex(3200, 200)` turns the swing upside down. Both values are frequencies or other positive amounts: a
 value at or below 0 (or not a number) is coerced to 0.0001, so nothing breaks, but that end of the sweep sits
 at almost nothing.
 Sprudel's `rangex(from, to)` is the same mapping on its `0..1` signals.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw().lowpass(Ignitor.sine(0.2).rangex(200, 3200))   // the cutoff sweeps four octaves, evenly""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "recip" to KlangSymbol(
        name = "recip",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("reciprocal"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "recip",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample reciprocal: `1 / x`. Zero inputs substituted with `1e-30` to avoid `NaN`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "reciprocal" to KlangSymbol(
        name = "reciprocal",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("recip"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "reciprocal",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample reciprocal: `1 / x`. Alias for [recip].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "rem" to KlangSymbol(
        name = "rem",
        category = "number",
        tags = listOf("arithmetic", "remainder"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "rem",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Per-sample modulo. Alias for [mod] (matches Kotlin's `rem`): on a signal the two are the same
 operation, unlike `mod` and `rem` on a number.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "rem",
                receiver = kt1,
                params = listOf(
                    KlangParam(name = "n", type = kt1, description = """The divisor"""),
                ),
                returnType = kt1,
                description = """Returns the remainder of the division by n, with the sign of the dividend.

 This is the method form of `%`. Its twin is `mod`, which takes the sign of the divisor:
 `-1.rem(12)` is -1 while `-1.mod(12)` is 11.""",
                returnDoc = """The remainder, with the sign of self""",
                samples = listOf(
                    KlangCodeSample(code = """(-1).rem(12)  // -1""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "removeAt" to KlangSymbol(
        name = "removeAt",
        category = "array",
        tags = listOf("mutating"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "removeAt",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "index", type = kt1, description = """The index to remove"""),
                ),
                returnType = kt50,
                description = """Removes the element at the given index. Returns the removed element or null.""",
                returnDoc = """The removed element or null if out of bounds""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk15() = mapOf(

    "removeFirst" to KlangSymbol(
        name = "removeFirst",
        category = "array",
        tags = listOf("mutating"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "removeFirst",
                receiver = kt6,
                params = emptyList(),
                returnType = kt50,
                description = """Removes and returns the first element, or null if empty.""",
                returnDoc = """The removed element or null""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "removeLast" to KlangSymbol(
        name = "removeLast",
        category = "array",
        tags = listOf("mutating"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "removeLast",
                receiver = kt6,
                params = emptyList(),
                returnType = kt50,
                description = """Removes and returns the last element, or null if empty.""",
                returnDoc = """The removed element or null""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "repeat" to KlangSymbol(
        name = "repeat",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "repeat",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "count", type = kt1, description = """Number of repetitions"""),
                ),
                returnType = kt51,
                description = """Repeats the string a given number of times.""",
                returnDoc = """The repeated string""",
                samples = listOf(
                    KlangCodeSample(code = """"ha".repeat(3)  // "hahaha"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "replace" to KlangSymbol(
        name = "replace",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "replace",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "search", type = kt49, description = """The string to find"""),
                    KlangParam(name = "replacement", type = kt49, description = """The replacement string"""),
                ),
                returnType = kt51,
                description = """Replaces all occurrences of a search string with a replacement.""",
                returnDoc = """The new string with replacements""",
                samples = listOf(
                    KlangCodeSample(code = """"hello world".replace("world", "klang")  // "hello klang"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "resetSamples" to KlangSymbol(
        name = "resetSamples",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "resetSamples",
                receiver = kt23,
                params = listOf(
                    KlangParam(name = "resetSamples", type = kt1),
                ),
                returnType = kt23,
                description = """Analog flyback time in samples: lower = brighter, sharper reset; higher = softer (default 1.0).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "resetSamples",
                receiver = kt24,
                params = listOf(
                    KlangParam(name = "resetSamples", type = kt1),
                ),
                returnType = kt24,
                description = """Analog flyback time in samples: lower = brighter, sharper reset; higher = softer (default 1.0).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "reverb" to KlangSymbol(
        name = "reverb",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "reverb",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt43, isOptional = true, defaultDoc = """null""", description = """how much of the orbit goes into the reverb (default 0.25; 0.0 = off). Orbit twin: `reverb(wet = ...)`."""),
                    KlangParam(name = "size", type = kt43, isOptional = true, defaultDoc = """null""", description = """tail length, on the SAME scale as sprudel `reverb(size = ...)`: typical 1 to 10, default 5. 3 is about a 1 s tail, 5 about 1.4 s, 10 about 12.5 s; the shortest reachable is about 0.7 s, and above 10 is bounded at 10. Orbit twin: `reverb(size = ...)`."""),
                    KlangParam(name = "lowpass", type = kt43, isOptional = true, defaultDoc = """null""", description = """high-frequency damping of the tail as a lowpass cutoff in Hz: lower is darker. Omitted, the engine's fixed default damping applies. Orbit twin: `reverb(lowpass = ...)`."""),
                ),
                returnType = kt3,
                description = """Appends an orbit reverb (the shared Freeverb). Flat: every knob is a musical input.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "reversed" to KlangSymbol(
        name = "reversed",
        category = "array",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "reversed",
                receiver = kt6,
                params = emptyList(),
                returnType = kt55,
                description = """Returns a new array with elements in reverse order.""",
                returnDoc = """A new reversed array""",
                samples = listOf(
                    KlangCodeSample(code = """[1, 2, 3].reversed().joinToString(", ")  // "3, 2, 1"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "riseFlank" to KlangSymbol(
        name = "riseFlank",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "riseFlank",
                receiver = kt22,
                params = listOf(
                    KlangParam(name = "riseFlank", type = kt1),
                ),
                returnType = kt22,
                description = """Rising-edge flank fraction of the plateau: 0 = sharpest (the floor), 1 = full ramp (default 0.0).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk16() = mapOf(

    "round" to KlangSymbol(
        name = "round",
        category = "math",
        tags = listOf("rounding"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "round",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The number to round"""),
                ),
                returnType = kt1,
                description = """Rounds a number to the nearest integer.""",
                returnDoc = """The rounded value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.round(3.5)  // 4.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "round",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample round to nearest integer.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "round",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Rounds the number to the nearest integer, ties to the even neighbour.

 `Math.round` uses the same rule, so `2.5.round()` is 2 while `3.5.round()` is 4.""",
                returnDoc = """The rounded value""",
                samples = listOf(
                    KlangCodeSample(code = """1.7.round()  // 2""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "saw" to KlangSymbol(
        name = "saw",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "saw",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt81, isOptional = true, defaultDoc = """null""", description = """receives the [OscSawBuilder] (knobs: `analog`, `resetSamples`, `shapeMax`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a sawtooth wave oscillator (analog flyback shape, no PolyBLEP, softens with pitch).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.saw(x => x.resetSamples(4.0).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "saw",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "freq", type = kt5, description = """the rate in Hz, required: a number, a `Kat.param` or a Kat expression."""),
                    KlangParam(name = "configure", type = kt82, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystSawBuilder] (knob: `phase`) and returns it."""),
                ),
                returnType = kt4,
                description = """A sawtooth LFO for a chain knob: rises from -1 to 1 over each cycle at [freq] Hz, then falls back over the
 Ignitor saw's short flyback.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the fader climbs from 0.2 to 1 once every two seconds
Katalyst(k => k.gain(Kat.saw(0.5).range(0.2, 1)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "select" to KlangSymbol(
        name = "select",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "select",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "whenTrue", type = kt5),
                    KlangParam(name = "whenFalse", type = kt5),
                ),
                returnType = kt2,
                description = """Per-sample conditional: when this signal `> 0` use [whenTrue], else [whenFalse].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "semitones" to KlangSymbol(
        name = "semitones",
        category = "number",
        tags = listOf("music", "pitch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "semitones",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the number as semitones and returns the frequency ratio: 2^(self / 12).

 Use it wherever a detune or a transposition is a ratio, so the interval stays readable.
 The inverse is `toSemitones`, and `"P5".toRatio()` says the same thing by name.""",
                returnDoc = """The frequency ratio""",
                samples = listOf(
                    KlangCodeSample(code = """7.semitones()  // 1.4983, a perfect fifth""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "serial" to KlangSymbol(
        name = "serial",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "serial",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "stages", type = kt33, isVararg = true, description = """functions from a signal to a signal, applied first to last."""),
                ),
                returnType = kt2,
                description = """Runs this signal through the stages in series, in the order written: `x.serial(a, b, c)` is `c(b(a(x)))`.
 A stage is any function from a signal to a signal, so a signal chain is written as the list it is,
 with any number of stages; a rig is a stage too. With no stage, `serial()` returns the signal as it is.


 One stage into the next. Not sprudel's `apply(f, g)`, which stacks the results side by side.
 It builds what the Kotlin `IgnitorDsl.serial(...)` builds, and checks every stage on the way: a stage that is
 null, returns nothing or returns something other than a signal is a script error naming the stage; a stage that is
 not a function at all is refused at the call ("expected a function, got a number").""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """let pedal = x => x.distort(0.4, "soft")
let cab   = x => x.highpass(100).lowpass(5000)
let rig   = x => x.serial(pedal, cab)
let guitar = Ignitor.saw().serial(rig).adsr(0.005, 0.8, 0.0, 0.05).classic()""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "serial",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "stages", type = kt35, isVararg = true, description = """functions from a builder to a builder, applied first to last."""),
                ),
                returnType = kt3,
                description = """Runs the chain through [stages] in series, in the order written: `k.serial(a, b, c)` is `c(b(a(k)))`, the same
 chain as the nested calls. A stage is any function from a builder to a builder, so a group of stages
 (a room, a bus, a mastering block) becomes a value and a chain is written as the list it is.
 With no stage, `serial()` returns the chain as it is.


 One stage into the next, as `Ignitor`'s `serial`. Not sprudel's `apply(f, g)`, which stacks the
 results side by side. Every stage is checked on the way: a stage that is null, returns nothing or returns
 something other than the builder is a script error naming the stage; a stage that is not a function at all is
 refused at the call ("expected a function, got a number").""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """let hall    = k => k.reverb(0.25, 7, 4500)
let ceiling = k => k.gain(1.4).limiter(threshold = -3.0, lookahead = 0.005)
Katalyst(k => k.serial(hall, ceiling))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "shape" to KlangSymbol(
        name = "shape",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "shape",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "shape", type = kt5, isOptional = true, defaultDoc = """"soft"""", description = """a shape NAME, converted to its index in `DistortionShapes` (an unknown name is "soft"); or the index itself as a number; or a slot carrying it (`Ignitor.param("drive-shape", 10)`), the door being the only way to write one. Read once per note. It shapes at the rate it is in. For less aliasing, write it inside a region: `x.oversampleAtLeast(4, y => y.shape("tube"))`."""),
                ),
                returnType = kt2,
                description = """Pure waveshaping without drive. Applies a nonlinear transfer function per sample.

 Shapes:
  - **Symmetric soft:** "soft" (tanh), "gentle", "softsat", "cubic", "exp", "sineshaper".
  - **Symmetric hard / wavefolding:** "hard", "zerosquare", "chebyshev", "fold", "linearfold".
  - **Asymmetric (even harmonics):** "diode", "tube", "asym", "stompbox", "rectify".""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "shape",
                receiver = kt80,
                params = listOf(
                    KlangParam(name = "name", type = kt5),
                ),
                returnType = kt80,
                description = """The LFO's waveform: `"sine"` (default), `"triangle"`, `"square"`, `"sawtooth"` or `"ramp"`, with the
 oscillator aliases (`"tri"`, `"sqr"`, `"pulse"`, `"saw"`, `"sin"`); an unknown name is sine. [name]
 may also be the index in that list as a number, or a slot carrying it, and the door is the only
 way to write one. Chosen once per note, so give it a name, a number or a slot: a moving signal
 has no value to choose by and reads as sine. The shape IS the oscillator of that name; the square,
 sawtooth and ramp get a 16 ms soft edge, so they pulse without clicking. A `square` at full depth
 is silence for about half of every cycle, which is the point.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "shapeMax" to KlangSymbol(
        name = "shapeMax",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "shapeMax",
                receiver = kt23,
                params = listOf(
                    KlangParam(name = "shapeMax", type = kt1),
                ),
                returnType = kt23,
                description = """Max flyback fraction of a cycle: 0.5 = symmetric-triangle limit; keeps high notes sane (default 0.5).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "shapeMax",
                receiver = kt24,
                params = listOf(
                    KlangParam(name = "shapeMax", type = kt1),
                ),
                returnType = kt24,
                description = """Max flyback fraction of a cycle: 0.5 = symmetric-triangle limit; keeps high notes sane (default 0.5).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "shimmer" to KlangSymbol(
        name = "shimmer",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "shimmer",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "wet", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """Wet/dry balance, 0..1. Default 0.5. 0 is a bit-exact bypass."""),
                    KlangParam(name = "feedback", type = kt5, isOptional = true, defaultDoc = """0.5""", description = """Cascade feedback (0..0.95). Default 0.5."""),
                    KlangParam(name = "tone", type = kt5, isOptional = true, defaultDoc = """4000.0""", description = """Feedback-path LPF cutoff in Hz. Default 4000."""),
                    KlangParam(name = "pitches", type = kt83, isOptional = true, defaultDoc = """null""", description = """Array of semitone transpositions. Default [0, 7, 12]. Example: [0, 4, 7, 11] for maj7. An empty list spawns no grains: only the dry plays, at its wet/dry level (silent at wet 1). An entry that is not a number is a type error."""),
                    KlangParam(name = "configure", type = kt84, isOptional = true, defaultDoc = """null""", description = """receives the [ShimmerBuilder] (knob: `floor`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies a granular shimmer cloud with configurable pitch transpositions and feedback. [wet]
 comes FIRST, as on every door that has one; the dry floor is a knob on the [ShimmerBuilder]:
 `.shimmer(0.4, 0.5, 4000, [0, 7, 12], x => x.floor(0.2))`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk17() = mapOf(

    "sideAtten" to KlangSymbol(
        name = "sideAtten",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sideAtten",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "sideAtten", type = kt1),
                ),
                returnType = kt25,
                description = """Center-dominant gain falloff: 0 = all voices equal, 1 = only the center voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sideAtten",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "sideAtten", type = kt1),
                ),
                returnType = kt26,
                description = """Center-dominant gain falloff: 0 = all voices equal, 1 = only the center voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sideAtten",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "sideAtten", type = kt1),
                ),
                returnType = kt27,
                description = """Center-dominant gain falloff: 0 = all voices equal, 1 = only the center voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sideAtten",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "sideAtten", type = kt1),
                ),
                returnType = kt28,
                description = """Center-dominant gain falloff: 0 = all voices equal, 1 = only the center voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sideAtten",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "sideAtten", type = kt1),
                ),
                returnType = kt29,
                description = """Center-dominant gain falloff: 0 = all voices equal, 1 = only the center voice.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "sign" to KlangSymbol(
        name = "sign",
        category = "number",
        tags = listOf("arithmetic"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sign",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Sign of this signal: `-1`, `0`, or `+1`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sign",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the sign of the number: -1 below zero, 0 at zero, 1 above zero.""",
                returnDoc = """The sign""",
                samples = listOf(
                    KlangCodeSample(code = """(-3).sign()  // -1""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "silence" to KlangSymbol(
        name = "silence",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "silence",
                receiver = kt41,
                params = emptyList(),
                returnType = kt2,
                description = """Creates a silent ignitor (zero output).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "sin" to KlangSymbol(
        name = "sin",
        category = "math",
        tags = listOf("trigonometry"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sin",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The angle in radians"""),
                ),
                returnType = kt1,
                description = """Returns the sine of an angle in radians.""",
                returnDoc = """The sine value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.sin(0)  // 0.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "sine" to KlangSymbol(
        name = "sine",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sine",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency (e.g. 5 for a 5 Hz LFO)."""),
                    KlangParam(name = "configure", type = kt85, isOptional = true, defaultDoc = """null""", description = """receives the [OscSineBuilder] (knobs: `analog`, `fundamental`, `harmonics`, `octaves`, `suboctaves`, `partial`, `analogSpread`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a sine wave oscillator. The builder can add banks of sine PARTIALS at multiples of the sine's own
 frequency, rendered in one pass: `harmonics(count, rolloff)` at `2f, 3f, 4f ...`, `octaves(count, rolloff)` at
 `2f, 4f, 8f ...`, `suboctaves(count, rolloff)` at `f/2, f/4 ...`, and `partial(ratio, gain, phase)` adds one
 partial at any ratio per call (an inharmonic cluster); `fundamental(gain)` levels the sine itself and
 `analogSpread(0..1)` sets whether the partials drift as one oscillator or on their own. Everything sums raw.
 With no bank knob set this is the plain sine it always was. The multiples follow the door's `freq`, so
 `Ignitor.sine(Ignitor.freq().mul(2), x => x.harmonics(3))` is the even series `2f, 4f, 6f, 8f`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.analog(3)).lowpass(2000)
Ignitor.sine(x => x.harmonics(7))                  // a bass the ear rebuilds on small speakers: f plus 2f .. 8f
Ignitor.sine(x => x.suboctaves(1, 0))              // the classic sub oscillator, f and f/2 at equal level
Ignitor.sine(x => x.fundamental(0).partial(0.66, 0.5).partial(0.87, 0.65, 0.5).partial(1.25, 1))   // an inharmonic cluster""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sine",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "freq", type = kt5, description = """the rate in Hz, required: a number, a `Kat.param` or a Kat expression (a pattern that wants tempo sync writes it through a `Kat.param`)."""),
                    KlangParam(name = "configure", type = kt86, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystSineBuilder] (knob: `phase`) and returns it."""),
                ),
                returnType = kt4,
                description = """A sine LFO for a chain knob: `-1..1`, starting at 0 going up, at [freq] Hz. Map it onto the knob's range with
 `range(from, to)`.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the phaser's center sweeps 400 to 1600 Hz every ten seconds
Katalyst(k => k.phaser(wet = 0.6, center = Kat.sine(0.1).range(400, 1600)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "size" to KlangSymbol(
        name = "size",
        category = "array",
        tags = listOf("property"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "size",
                receiver = kt6,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the number of elements in the array.""",
                returnDoc = """The size""",
                samples = listOf(
                    KlangCodeSample(code = """[1, 2, 3].size()""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "slice" to KlangSymbol(
        name = "slice",
        category = "string",
        tags = listOf("slicing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "slice",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "start", type = kt1, description = """Start index (inclusive)"""),
                    KlangParam(name = "end", type = kt1, description = """End index (exclusive)"""),
                ),
                returnType = kt51,
                description = """Returns a substring between start (inclusive) and end (exclusive). Same as substring.""",
                returnDoc = """The sliced string""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "split" to KlangSymbol(
        name = "split",
        category = "string",
        tags = listOf("splitting"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "split",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "separator", type = kt49, description = """The separator to split on"""),
                ),
                returnType = kt55,
                description = """Splits the string by a separator and returns an array of substrings.""",
                returnDoc = """Array of substrings""",
                samples = listOf(
                    KlangCodeSample(code = """"a,b,c".split(",").joinToString(" ")  // "a b c"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk18() = mapOf(

    "spread" to KlangSymbol(
        name = "spread",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "spread",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt25,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spread",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt26,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spread",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt27,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spread",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt28,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spread",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt29,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spread",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "spread", type = kt5),
                ),
                returnType = kt31,
                description = """Unison frequency spread between the voices (default 0.2). Same knob as the pattern-level `.spread()`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "spreadPower" to KlangSymbol(
        name = "spreadPower",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "spreadPower",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "spreadPower", type = kt1),
                ),
                returnType = kt25,
                description = """Detune spacing shape: 1 = even, above 1 concentrates toward the center, below 1 spreads outward.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spreadPower",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "spreadPower", type = kt1),
                ),
                returnType = kt26,
                description = """Detune spacing shape: 1 = even, above 1 concentrates toward the center, below 1 spreads outward.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spreadPower",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "spreadPower", type = kt1),
                ),
                returnType = kt27,
                description = """Detune spacing shape: 1 = even, above 1 concentrates toward the center, below 1 spreads outward.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spreadPower",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "spreadPower", type = kt1),
                ),
                returnType = kt28,
                description = """Detune spacing shape: 1 = even, above 1 concentrates toward the center, below 1 spreads outward.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "spreadPower",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "spreadPower", type = kt1),
                ),
                returnType = kt29,
                description = """Detune spacing shape: 1 = even, above 1 concentrates toward the center, below 1 spreads outward.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "sq" to KlangSymbol(
        name = "sq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sq",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Per-sample square: `x · x`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "sqrt" to KlangSymbol(
        name = "sqrt",
        category = "math",
        tags = listOf("arithmetic", "calculation"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sqrt",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The number to compute the square root of"""),
                ),
                returnType = kt1,
                description = """Returns the square root of a number.""",
                returnDoc = """The square root""",
                samples = listOf(
                    KlangCodeSample(code = """Math.sqrt(16)  // 4.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sqrt",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """Square root per sample. Signed-magnitude (no `NaN` for negatives).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sqrt",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Returns the square root of the number.""",
                returnDoc = """The square root""",
                samples = listOf(
                    KlangCodeSample(code = """16.sqrt()  // 4""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "square" to KlangSymbol(
        name = "square",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "square",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt87, isOptional = true, defaultDoc = """null""", description = """receives the [OscSquareBuilder] (knobs: `duty`, `analog`, `flankSamples`, `riseFlank`, `fallFlank`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a square wave oscillator: a variable-duty pulse whose `duty` defaults to 50%.
 `square`, `pulse` and `pulze` are one pulse oscillator; this door builds the flank-shaped [IgnitorDsl.Pulze],
 [pulze] the raw, aliased one.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.square(x => x.duty(0.3).flankSamples(4.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "square",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "freq", type = kt5, description = """the rate in Hz, required: a number, a `Kat.param` or a Kat expression."""),
                    KlangParam(name = "configure", type = kt88, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystSquareBuilder] (knobs: `duty`, `phase`) and returns it."""),
                ),
                returnType = kt4,
                description = """A square LFO for a chain knob: -1 or 1, switching over the Ignitor pulse's short flanks, at [freq] Hz; its
 `duty` (on the builder, default 0.5) is the share of each cycle spent high.


 Read once per block, an edge lands on a block boundary and the stage ramps it across that block (about 2.7 ms
 at 48 kHz), so a square here is a soft gate, never a click-sharp one.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the fader gates between 0.3 and 1 twice a second
Katalyst(k => k.gain(Kat.square(2).range(0.3, 1)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "startsWith" to KlangSymbol(
        name = "startsWith",
        category = "string",
        tags = listOf("search"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "startsWith",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "prefix", type = kt49, description = """The prefix to check"""),
                ),
                returnType = kt53,
                description = """Returns true if the string starts with the given prefix.""",
                returnDoc = """True if the string starts with the prefix""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "stiffness" to KlangSymbol(
        name = "stiffness",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "stiffness",
                receiver = kt30,
                params = listOf(
                    KlangParam(name = "stiffness", type = kt5),
                ),
                returnType = kt30,
                description = """String stiffness (default 0.0). Higher = more inharmonic, bell-like.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "stiffness",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "stiffness", type = kt5),
                ),
                returnType = kt31,
                description = """String stiffness (default 0.0). Higher = more inharmonic, bell-like.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "sub" to KlangSymbol(
        name = "sub",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("minus"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "sub",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Subtracts another signal from this one. Alias for [minus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sub",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Subtracts [other] from every sample of the bus. Alias for [minus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "sub",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob minus [other]. Alias for [minus].""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk19() = mapOf(

    "subList" to KlangSymbol(
        name = "subList",
        category = "array",
        tags = listOf("slicing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "subList",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "start", type = kt1, description = """Start index (inclusive)"""),
                    KlangParam(name = "end", type = kt1, description = """End index (exclusive)"""),
                ),
                returnType = kt55,
                description = """Returns a sub-array from start (inclusive) to end (exclusive).""",
                returnDoc = """A new sub-array""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "suboctaves" to KlangSymbol(
        name = "suboctaves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "suboctaves",
                receiver = kt16,
                params = listOf(
                    KlangParam(name = "count", type = kt5),
                    KlangParam(name = "rolloff", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt16,
                description = """Adds `count` sine partials at `f/2, f/4, f/8 ...` below THIS sine, the sub oscillator every mono synth has. The
 partial at `f/m` has gain `m ^ -rolloff` (default 1: the sub at half gain, `count` at most 64); `suboctaves(1, 0)` is the classic
 equal-level sub. A sub at a comparable level MOVES THE PERCEIVED PITCH down an octave (the ear takes `f/2` as the
 fundamental), which is the point. No lower limit: two sub-octaves on a low E are 10 Hz, headroom for nothing
 audible; the highpass is yours. Signals read once per block.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.sine(x => x.suboctaves(1, 0))    // f and f/2 at equal level""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "substring" to KlangSymbol(
        name = "substring",
        category = "string",
        tags = listOf("slicing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "substring",
                receiver = kt49,
                params = listOf(
                    KlangParam(name = "start", type = kt1, description = """Start index (inclusive)"""),
                    KlangParam(name = "end", type = kt1, description = """End index (exclusive)"""),
                ),
                returnType = kt51,
                description = """Returns a substring between start (inclusive) and end (exclusive).""",
                returnDoc = """The substring""",
                samples = listOf(
                    KlangCodeSample(code = """"hello world".substring(0, 5)  // "hello"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "superpluck" to KlangSymbol(
        name = "superpluck",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "superpluck",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt89, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperPluckBuilder] (knobs: `voices`, `spread`, `feedback`, `brightness`, `pickPosition`, `stiffness`, `analog`, `analogSpread`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a unison Karplus-Strong plucked string model.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.superpluck(x => x.voices(6).spread(0.15).feedback(0.995))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "superramp" to KlangSymbol(
        name = "superramp",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "superramp",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt90, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperRampBuilder] (knobs: `voices`, `spread`, `analog`, `analogSpread`, `spreadPower`, `sideAtten`, `gainJitter`, `centerJitter`, `phasePool`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a superramp (multiple detuned ramp oscillators, the mirror of [supersaw]).
 Unison and character knobs live on the builder; the combined `phasePool(...)` call takes optional literals, so named
 subsets work: `x.phasePool()`, `x.phasePool(kMin = 0.2)`. Base wrappers (`.lowpass()`, `.adsr()`, ...) go outside the lambda.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.superramp(x => x.voices(9).spread(0.1).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "supersaw" to KlangSymbol(
        name = "supersaw",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "supersaw",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt91, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperSawBuilder] (knobs: `voices`, `spread`, `analog`, `analogSpread`, `spreadPower`, `sideAtten`, `gainJitter`, `centerJitter`, `phasePool`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a supersaw (multiple detuned sawtooth voices).
 Unison and character knobs live on the builder; the combined `phasePool(...)` call takes optional literals, so named
 subsets work: `x.phasePool()`, `x.phasePool(kMin = 0.2)`. Base wrappers (`.lowpass()`, `.adsr()`, ...) go outside the lambda.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersaw(x => x.voices(9).spread(0.1).spreadPower(1.5).analog(5.0)).lowpass(800)""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "supersine" to KlangSymbol(
        name = "supersine",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "supersine",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt92, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperSineBuilder] (knobs: `voices`, `spread`, `analog`, `analogSpread`, `spreadPower`, `sideAtten`, `gainJitter`, `centerJitter`, `phasePool`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a supersine (multiple detuned sine oscillators).
 Unison and character knobs live on the builder; the combined `phasePool(...)` call takes optional literals, so named
 subsets work: `x.phasePool()`, `x.phasePool(kMin = 0.2)`. Base wrappers (`.lowpass()`, `.adsr()`, ...) go outside the lambda.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersine(x => x.voices(9).spread(0.1).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "supersquare" to KlangSymbol(
        name = "supersquare",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "supersquare",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt93, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperSquareBuilder] (knobs: `voices`, `spread`, `analog`, `analogSpread`, `spreadPower`, `sideAtten`, `gainJitter`, `centerJitter`, `phasePool`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a supersquare (multiple detuned square oscillators).
 Unison and character knobs live on the builder; the combined `phasePool(...)` call takes optional literals, so named
 subsets work: `x.phasePool()`, `x.phasePool(kMin = 0.2)`. Base wrappers (`.lowpass()`, `.adsr()`, ...) go outside the lambda.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supersquare(x => x.voices(9).spread(0.1).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk20() = mapOf(

    "supertri" to KlangSymbol(
        name = "supertri",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "supertri",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt94, isOptional = true, defaultDoc = """null""", description = """receives the [OscSuperTriBuilder] (knobs: `voices`, `spread`, `analog`, `analogSpread`, `spreadPower`, `sideAtten`, `gainJitter`, `centerJitter`, `phasePool`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a supertri (multiple detuned triangle oscillators).
 Unison and character knobs live on the builder; the combined `phasePool(...)` call takes optional literals, so named
 subsets work: `x.phasePool()`, `x.phasePool(kMin = 0.2)`. Base wrappers (`.lowpass()`, `.adsr()`, ...) go outside the lambda.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.supertri(x => x.voices(9).spread(0.1).analog(5.0))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "take" to KlangSymbol(
        name = "take",
        category = "array",
        tags = listOf("slicing"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "take",
                receiver = kt6,
                params = listOf(
                    KlangParam(name = "n", type = kt1, description = """Number of elements to take"""),
                ),
                returnType = kt55,
                description = """Returns a new array with only the first n elements.""",
                returnDoc = """A new array with the first n elements""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "tan" to KlangSymbol(
        name = "tan",
        category = "math",
        tags = listOf("trigonometry"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "tan",
                receiver = kt0,
                params = listOf(
                    KlangParam(name = "x", type = kt1, description = """The angle in radians"""),
                ),
                returnType = kt1,
                description = """Returns the tangent of an angle in radians.""",
                returnDoc = """The tangent value""",
                samples = listOf(
                    KlangCodeSample(code = """Math.tan(0)  // 0.0""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "tanh" to KlangSymbol(
        name = "tanh",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "tanh",
                receiver = kt2,
                params = emptyList(),
                returnType = kt2,
                description = """`tanh(x)` per sample (smooth saturation curve).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "tap" to KlangSymbol(
        name = "tap",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "tap",
                receiver = kt36,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "gain", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt36,
                description = """Adds a parallel resonant boost: takes the sound going INTO the equalizer, keeps only the band
 around [freq], scales it by [gain] and mixes it back in. The short way to write
 `signal.add(signal.bandpass(freq, q).mul(gain))`, in one pass.

 [gain] is a plain multiplier, not decibels: 1.0 mixes the band back in at full strength, 0 is
 silent. [q] is the ordinary bandpass width, the same number `.bandpass()` takes. Taps mix with
 the original sound rather than stacking on each other, so several taps stay predictable where
 several [band] calls would compound. The engine bandpass is UNITY-peak at [freq], so [q] is a
 pure WIDTH control: the boost at [freq] is `1 + gain` for ANY q. The default `tap(freq)` is
 NOT silent: `1 + 1 = 2`, a lift of about 6 dB, where the default `band(freq)` is transparent.

 Give [gain] a number or a slot, not a moving signal: on a voice eq an Ignitor slot (`Ignitor.param`,
 `Ignitor.slot.*`), on a chain eq a Katalyst param (`Katalyst.param`, `Katalyst.slot.*`). It is re-read only once
 per block, so a swept tap gain steps instead of gliding. For that, use the chained
 `signal.add(signal.bandpass(...).mul(lfo))` form, which is smooth.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "tap",
                receiver = kt37,
                params = listOf(
                    KlangParam(name = "freq", type = kt5),
                    KlangParam(name = "q", type = kt5, isOptional = true, defaultDoc = """0.707"""),
                    KlangParam(name = "gain", type = kt5, isOptional = true, defaultDoc = """1.0"""),
                ),
                returnType = kt37,
                description = """Adds a parallel resonant boost to the chain's equalizer: the voice eq's `tap`, the same section and the same
 defaults (the band around [freq] of the sound going INTO the equalizer, [q] its width, scaled by [gain], a plain
 multiplier, and mixed back in; the default `tap(freq)` lifts about 6 dB). Each value is a number or a Katalyst param,
 which listens to `katp`; a Katalyst expression is a script error, as on `band`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "times" to KlangSymbol(
        name = "times",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf("mul"),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "times",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "other", type = kt5),
                ),
                returnType = kt2,
                description = """Multiplies two ignitor signals (ring modulation / amplitude modulation).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "times",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt3,
                description = """Multiplies every sample of the bus by [other], exactly as the Ignitor's `times`. For a level, `gain` is the word:
 the fader glides the same way but does not clamp and skips unity; this is the arithmetic.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "times",
                receiver = kt4,
                params = listOf(
                    KlangParam(name = "other", type = kt5, description = """a number, a `Kat.param` or a Kat expression."""),
                ),
                returnType = kt4,
                description = """This knob times [other]: a scale. The Ignitor's `times` law: the product is clamped to `±1e15` and a product that is
 not a number reads as 0.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// one slot drives the fader at half its value
Katalyst(k => k.gain(Kat.param("fader", 1).times(0.5)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "toDb" to KlangSymbol(
        name = "toDb",
        category = "number",
        tags = listOf("music", "gain"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toDb",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the number as a linear gain and returns the level in decibels: 20 * log10(self).

 The inverse of `db`. A gain of 0 gives -Infinity (silence) and a negative gain gives NaN,
 exactly as the underlying logarithm does.""",
                returnDoc = """The level in decibels""",
                samples = listOf(
                    KlangCodeSample(code = """0.5.toDb()  // -6.0206""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "toLowerCase" to KlangSymbol(
        name = "toLowerCase",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toLowerCase",
                receiver = kt49,
                params = emptyList(),
                returnType = kt51,
                description = """Converts the string to lowercase.""",
                returnDoc = """The lowercase string""",
                samples = listOf(
                    KlangCodeSample(code = """"HELLO".toLowerCase()  // "hello"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk21() = mapOf(

    "toRatio" to KlangSymbol(
        name = "toRatio",
        category = "string",
        tags = listOf("music", "pitch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toRatio",
                receiver = kt49,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the string as an interval name and returns its frequency ratio: 2^(semitones / 12).

 The name says what the number means, so a call site reads as intent:
 `.ignp("hptrack", "M3".toRatio())` is a major third above the fundamental.
 A name is a quality and a number, `P5`, `M3`, `m7`. A descending interval carries the minus in
 front of the number, so a fifth down is `-5P` (or `P-5`), not `-P5`.
 On a bare number the unit goes in the method name instead, see `semitones` and `cents`.""",
                returnDoc = """The frequency ratio of the interval""",
                samples = listOf(
                    KlangCodeSample(code = """"P5".toRatio()   // 1.4983, a perfect fifth
"M3".toRatio()   // 1.2599, a major third
"-5P".toRatio()  // 0.6674, a fifth down""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "toSemitones" to KlangSymbol(
        name = "toSemitones",
        category = "number",
        tags = listOf("music", "pitch"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toSemitones",
                receiver = kt1,
                params = emptyList(),
                returnType = kt1,
                description = """Reads the number as a frequency ratio and returns its size in semitones: 12 * log2(self).

 The inverse of `semitones`. A ratio of 0 gives -Infinity and a negative ratio gives NaN,
 exactly as the underlying logarithm does.""",
                returnDoc = """The size in semitones""",
                samples = listOf(
                    KlangCodeSample(code = """1.5.toSemitones()  // 7.0196, a perfect fifth is a hair wider than 7 equal semitones""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "toString" to KlangSymbol(
        name = "toString",
        category = "boolean",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toString",
                receiver = kt95,
                params = emptyList(),
                returnType = kt51,
                description = """Returns the string representation of the boolean.""",
                returnDoc = """"true" or "false"""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "toString",
                receiver = kt1,
                params = emptyList(),
                returnType = kt51,
                description = """Returns the string representation of the number.""",
                returnDoc = """The string representation""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "toString",
                receiver = kt49,
                params = emptyList(),
                returnType = kt51,
                description = """Returns the string representation.""",
                returnDoc = """The string itself""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "toUpperCase" to KlangSymbol(
        name = "toUpperCase",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "toUpperCase",
                receiver = kt49,
                params = emptyList(),
                returnType = kt51,
                description = """Converts the string to uppercase.""",
                returnDoc = """The uppercase string""",
                samples = listOf(
                    KlangCodeSample(code = """"hello".toUpperCase()  // "HELLO"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "tremolo" to KlangSymbol(
        name = "tremolo",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "tremolo",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "rate", type = kt5),
                    KlangParam(name = "depth", type = kt5),
                    KlangParam(name = "configure", type = kt96, isOptional = true, defaultDoc = """null""", description = """receives the [TremoloBuilder] (knobs: `shape`, `range`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies amplitude tremolo: an oscillator at [rate] Hz pulls the level down by up to [depth]
 (0 to 1) by default; the builder's `range` moves the swing (a swell upward, or both ways). The LFO's shape and where its swing sits are knobs on the [TremoloBuilder]:
 `.tremolo(4, 0.8, x => x.shape("square"))`, `.tremolo(4, 0.3, x => x.range(0, 1))` (a swell upward instead of
 the classic dip). Rate first, like every Ignitor LFO door; the pattern door is `tremolo(depth, rate, shape)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "tri" to KlangSymbol(
        name = "tri",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "tri",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt97, isOptional = true, defaultDoc = """null""", description = """receives the [OscTriBuilder] (knobs: `analog`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a triangle wave oscillator. Its flanks are fixed fully open; `analog` and `phase` are its knobs.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.tri(x => x.analog(3))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            ),
            KlangCallable(
                name = "tri",
                receiver = kt42,
                params = listOf(
                    KlangParam(name = "freq", type = kt5, description = """the rate in Hz, required: a number, a `Kat.param` or a Kat expression."""),
                    KlangParam(name = "configure", type = kt98, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystTriBuilder] (knob: `phase`) and returns it."""),
                ),
                returnType = kt4,
                description = """A triangle LFO for a chain knob: from -1 up to 1 and back over each cycle at [freq] Hz.""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """// the delay's feedback swells between 0.2 and 0.6 every eight seconds
Katalyst(k => k.delay(0.3, 0.375, Kat.tri(0.125).range(0.2, 0.6)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "trim" to KlangSymbol(
        name = "trim",
        category = "string",
        tags = listOf("transform"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "trim",
                receiver = kt49,
                params = emptyList(),
                returnType = kt51,
                description = """Removes leading and trailing whitespace.""",
                returnDoc = """The trimmed string""",
                samples = listOf(
                    KlangCodeSample(code = """"  hello  ".trim()  // "hello"""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "values" to KlangSymbol(
        name = "values",
        category = "object",
        tags = listOf("properties"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "values",
                receiver = kt57,
                params = emptyList(),
                returnType = kt50,
                description = """Returns an array of the object's own property values.""",
                returnDoc = """An array of property values""",
                samples = listOf(
                    KlangCodeSample(code = """let obj = { a: 1, b: 2, c: 3 }
Object.values(obj).joinToString(", ")""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsChunk22() = mapOf(

    "variants" to KlangSymbol(
        name = "variants",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "variants",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "children", type = kt5, isVararg = true, description = """candidate sounds or numbers, indexed from 0"""),
                ),
                returnType = kt2,
                description = """Creates a variants ignitor — selects one of [children] per note based on the
 voice's `soundIndex`. Lets a single sound expose multiple flavours,
 addressable via the `name:n` mini-notation or `.n(...)` pattern.

 Index wraps with floor-mod semantics: with N children, index `k` selects
 `children[k.mod(N)]`, so negative indices wrap from the end and overflow
 wraps to zero. Notes with no `:n` default to the first variant. With no children,
 `Ignitor.variants()` plays silence.

 Same selection mechanism used by sample banks (`bd:0`, `bd:1`, …). Nested
 `variants(...)` all dispatch on the same `soundIndex`, so a single switching
 axis can drive correlated changes throughout the tree.

 A child is a sound or a plain number; a number is a [IgnitorDsl.Constant], converted here at the door like
 every knob that takes a value, so `Ignitor.variants(400, 1200)` picks a value per note. Anything else is a
 script type error at the call.

 ```
 let combined = Ignitor.variants(Ignitor.sine(), Ignitor.saw()).classic()
 note("a b c:1 d:1").sound(combined)   // a/b → sine, c:1/d:1 → saw
 note("a a:1").sound(Ignitor.sine(Ignitor.variants(400, 1200)))   // 400 Hz, then 1200 Hz
 ```""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "vibrato" to KlangSymbol(
        name = "vibrato",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "vibrato",
                receiver = kt2,
                params = listOf(
                    KlangParam(name = "rate", type = kt5),
                    KlangParam(name = "semitones", type = kt5),
                    KlangParam(name = "configure", type = kt99, isOptional = true, defaultDoc = """null""", description = """receives the [VibratoBuilder] (knobs: `range`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Applies pitch vibrato: [rate] Hz LFO, [semitones] deep. A signal depth is followed sample by sample
 (`Ignitor.saw().vibrato(5, Ignitor.sine(0.5).mul(0.3).plus(0.3))` swells and fades); a depth at or below 0
 is no vibrato. Where the swing sits and where the LFO starts are knobs on the [VibratoBuilder]:
 `.vibrato(5, 0.5, v => v.range(0, 1).phase(0.75))` swings only upward from the note (a guitar's vibrato; phase 0
 is the middle of the swing), `.vibrato(5, 0.5, v => v.phase(0.25))` starts every note at the top of the wobble. The pattern door is `vib(rate, semitones, rangeFrom, rangeTo, phase)`.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "voices" to KlangSymbol(
        name = "voices",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "voices",
                receiver = kt25,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt25,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "voices",
                receiver = kt26,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt26,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "voices",
                receiver = kt27,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt27,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "voices",
                receiver = kt28,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt28,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "voices",
                receiver = kt29,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt29,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            ),
            KlangCallable(
                name = "voices",
                receiver = kt31,
                params = listOf(
                    KlangParam(name = "voices", type = kt5),
                ),
                returnType = kt31,
                description = """Number of detuned voices in the stack (default 8). Accepts a number or an `Ignitor.*` graph (read once per block).""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "vowel" to KlangSymbol(
        name = "vowel",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "vowel",
                receiver = kt3,
                params = listOf(
                    KlangParam(name = "wet", type = kt43, isOptional = true, defaultDoc = """null""", description = """how much of the orbit runs through the formant bank, 0 to 1 (default 0.5). Orbit twin: `vowel(wet = ...)`."""),
                    KlangParam(name = "vowel", type = kt43, isOptional = true, defaultDoc = """null""", description = """a vowel name, optionally `voice:vowel` (`"a"`, `"soprano:o"`), an index into the catalogue, or a `Katalyst.param` slot carrying one; omitted leaves the stage off. Orbit twin: `vowel(vowel = "a")`, or `katp("vowel.vowel", n)` for the number."""),
                    KlangParam(name = "configure", type = kt100, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystVowelBuilder] (knob: `floor`) and returns it."""),
                ),
                returnType = kt3,
                description = """Appends a formant bank: the vowel a sound sings.

 A vowel NAME is converted to the stage's `vowel` INDEX here, through the one shared
 `VowelBands.indexOf`, so a bare `"a"` is the soprano register on this door exactly as it is on
 the pattern one. An unknown name is `none`, and so is no vowel at all.

 **Why [vowel] takes more than a name.** The vowel is an index slot, as the body's material is
 (see [body]): `k.vowel(vowel = Katalyst.param("vw", 1))` listens to `katp("vw", n)`, and a plain
 number picks a fixed vowel by its index.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "whitenoise" to KlangSymbol(
        name = "whitenoise",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "whitenoise",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "color", type = kt5, isOptional = true, defaultDoc = """0.0""", description = """spectral tilt: 0 = flat white (default), <0 darkens toward pink/brown, >0 brightens (−1..1)."""),
                ),
                returnType = kt2,
                description = """Creates a white noise source. Each call yields a fresh DSL instance.""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "zamp" to KlangSymbol(
        name = "zamp",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "zamp",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt101, isOptional = true, defaultDoc = """null""", description = """receives the [OscZampBuilder] (knobs: `analog`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a raw ramp ("zamp"): a naive reverse sawtooth without anti-aliasing (the raw [ramp]).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.zamp(x => x.analog(3))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    ),

    "zawtooth" to KlangSymbol(
        name = "zawtooth",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangCallable(
                name = "zawtooth",
                receiver = kt41,
                params = listOf(
                    KlangParam(name = "freq", type = kt43, isOptional = true, defaultDoc = """null""", description = """frequency, omit for the playing note's pitch, or pass Hz for a fixed frequency."""),
                    KlangParam(name = "configure", type = kt102, isOptional = true, defaultDoc = """null""", description = """receives the [OscZawtoothBuilder] (knobs: `analog`, `phase`) and returns it."""),
                ),
                returnType = kt2,
                description = """Creates a naive sawtooth without anti-aliasing (brighter, harsher).""",
                returnDoc = """""",
                samples = listOf(
                    KlangCodeSample(code = """Ignitor.zawtooth(x => x.analog(3))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib"
            )
        )
    )
)

private fun generatedStdlibDocsObjects() = mapOf(

    "Ignitor" to KlangSymbol(
        name = "Ignitor",
        category = "object",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Ignitor",
                type = kt41,
                description = """`Ignitor` for KlangScript (short name `Ign`): builds IgnitorDsl signal graphs, the per-voice instrument.

 Provides factory methods for all oscillator primitives, noise sources, and super oscillators.
 Returns [IgnitorDsl] instances that can be composed via extension methods (lowpass, adsr, mul, etc.)
 and passed directly to `.sound()`:

 ```
 let pad = Ignitor.supersaw().lowpass(2000).adsr(0.01, 0.2, 0.5, 0.5).classic()
 note("c3 e3 g3").sound(pad).adsrOff()
 ```

 The playback denormalizes inline ignitor references at the wire boundary via the
 player's ignitor registry — no explicit registration step is needed.""",
                samples = emptyList(),
                library = "stdlib",
            )
        )
    ),

    "Katalyst" to KlangSymbol(
        name = "Katalyst",
        category = "object",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Katalyst",
                type = kt42,
                description = """`Katalyst` for KlangScript: builds [KatalystDsl] chains, for an orbit or for the output.

 A Katalyst is the instrument an orbit plays through: the effects its summed voices run, in the
 order written, before the playback's master bus. The master bus runs one too: hand the same kind
 of chain to `master(...)` and everything the playback plays runs through it last (phase 3 step 12:
 one chain type, two positions). Author one by CALLING `Katalyst` with a configure lambda and hand
 it to the `katalyst(...)` or `master(...)` pattern door; the lambda receives a [KatalystBuilder]
 whose knobs append stages in written order:

 ```
 let guitarBus = Katalyst(k => k
   .eq(e => e.band(freq = 300, q = 0.8, db = 2.0))
   .reverb(0.15, 3)
   .compressor(threshold = -21, ratio = 3)
 )
 stack(guitar1, guitar2, guitar3).katalyst(guitarBus)

 master(Katalyst(k => k.reverb(0.05, 9).gain(2.5).limiter()))
 ```

 `Katalyst()` with no lambda is the empty chain; `Katalyst(k => ...)` is the same as [build]. The
 method forms exist so the callable form can be tested against them. `master(Katalyst())` switches
 a master back off: a master reference means "change to this", so deleting a `master(...)` line
 while live coding leaves the last chain in place.

 Sibling of `Ignitor` (the per-voice instrument): same shape, different host.

 **The chain is the instrument.** A stage the chain does not declare does not run, however loudly
 a voice asks for it, so `Katalyst(k => k.eq(...))` is honestly "an EQ and nothing else". Start
 from the familiar orbit with [classic], which brings the historical stages plus the group fader
 at unity, as named slots the bus doors and `katp` can drive.""",
                samples = emptyList(),
                library = "stdlib",
            ),
            KlangCallable(
                name = "Katalyst",
                params = listOf(
                    KlangParam(name = "configure", type = kt46, isOptional = true, defaultDoc = """null""", description = """receives the [KatalystBuilder] and returns it."""),
                ),
                returnType = kt47,
                description = """`Katalyst(k => ...)`: the callable form of [build]. `Katalyst()` is the empty chain.

 ```
 katalyst(Katalyst(k => k.reverb(0.2, 4).compressor(threshold = -18)))
 ```""",
                returnDoc = """""",
                samples = emptyList(),
                library = "stdlib"
            )
        )
    ),

    "Math" to KlangSymbol(
        name = "Math",
        category = "object",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Math",
                type = kt0,
                description = """Math object for KlangScript — provides standard math operations.

 Exposed as `Math` in KlangScript, similar to JavaScript's Math object.""",
                samples = emptyList(),
                library = "stdlib",
            )
        )
    ),

    "Object" to KlangSymbol(
        name = "Object",
        category = "object",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Object",
                type = kt57,
                description = """Object utility for KlangScript -- provides static methods on the Object type.

 Exposed as `Object` in KlangScript, matching the JavaScript Object API.

 Methods use the raw-args pattern (List<RuntimeValue>) because they operate
 on RuntimeValue objects directly rather than unwrapped Kotlin types.""",
                samples = emptyList(),
                library = "stdlib",
            )
        )
    )
)

private fun generatedStdlibDocsProperties() = mapOf(

    "PI" to KlangSymbol(
        name = "PI",
        category = "math",
        tags = listOf("constant", "math", "pi"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "PI",
                type = kt1,
                description = """The mathematical constant π (pi), the ratio of a circle's circumference to its diameter.

 Equivalent to `Math.PI`. Provided as a top-level constant for convenience.""",
                samples = listOf(
                    KlangCodeSample(code = """PI  // 3.141592653589793""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib",
            )
        )
    ),

    "E" to KlangSymbol(
        name = "E",
        category = "math",
        tags = listOf("constant", "math", "euler"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "E",
                type = kt1,
                description = """Euler's number e, the base of the natural logarithm.

 Equivalent to `Math.E`. Provided as a top-level constant for convenience.""",
                samples = listOf(
                    KlangCodeSample(code = """E  // 2.718281828459045""", type = KlangCodeSampleType.EXECUTABLE)
                ),
                library = "stdlib",
            )
        )
    ),

    "Ign" to KlangSymbol(
        name = "Ign",
        category = "object",
        tags = listOf("ignitor", "ign", "alias", "instrument"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Ign",
                type = kt41,
                description = """The short name of [KlangScriptIgnitor]: the same object under a second name, so `Ign.sine()` is
 `Ignitor.sine()` and `Ign.slot.lpf.freq` is `Ignitor.slot.lpf.freq`, for every member. Songs use it;
 the docs spell `Ignitor` out.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").sound(Ign.supersaw(x => x.voices(9)).lowpass(1200).classic())""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib",
            )
        )
    ),

    "Kat" to KlangSymbol(
        name = "Kat",
        category = "object",
        tags = listOf("katalyst", "kat", "alias", "chain"),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "Kat",
                type = kt42,
                description = """The short name of [KlangScriptKatalyst]: the same object under a second name, so `Kat(k => ...)` is
 `Katalyst(k => ...)` and `Kat.classic()` is `Katalyst.classic()`, for every member: the short form for songs
 and live coding, while the docs spell `Katalyst` out.""",
                samples = listOf(
                    KlangCodeSample(code = """note("c3 e3 g3").s("supersaw").katalyst(Kat(k => k.reverb(0.2, 4).gain(1.2)))""", type = KlangCodeSampleType.PLAYABLE)
                ),
                library = "stdlib",
            )
        )
    )
)

private fun generatedStdlibDocsMemberProperties() = mapOf(

    "accelerate" to KlangSymbol(
        name = "accelerate",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "accelerate",
                owner = kt103,
                type = kt2,
                description = """The accelerate stage's slot (default 0, off): the glide in semitones from the onset to the gate close, held
 through the release, that the pattern's `accelerate(semitones)` writes. A pitch stage of `classic()`, between the
 pitch envelope and the vibrato; flat, like `onepole`: the door has one knob.
 Place it yourself with `accelerate(Ignitor.slot.accelerate)`. Mirrors sprudel's `accelerate`.""",
                library = "stdlib",
            )
        )
    ),

    "adsr" to KlangSymbol(
        name = "adsr",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "adsr",
                owner = kt103,
                type = kt104,
                description = """The amplitude envelope's slots: `attack`, `decay`, `sustain`, `release`, `on`.""",
                library = "stdlib",
            )
        )
    ),

    "adsrCurves" to KlangSymbol(
        name = "adsrCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "adsrCurves",
                owner = kt103,
                type = kt105,
                description = """The amplitude envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "amount" to KlangSymbol(
        name = "amount",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "amount",
                owner = kt106,
                type = kt2,
                description = """Drive amount, default 0 (off). Mirrors sprudel's `distort.amount`.""",
                library = "stdlib",
            )
        )
    ),

    "analog" to KlangSymbol(
        name = "analog",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "analog",
                owner = kt103,
                type = kt2,
                description = """Open `analog` slot (default 0.0). Mirrors sprudel `.analog(x)`.""",
                library = "stdlib",
            )
        )
    ),

    "attack" to KlangSymbol(
        name = "attack",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "attack",
                owner = kt107,
                type = kt2,
                description = """The depth envelope's attack in seconds, default 0. Mirrors sprudel's `fm.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt108,
                type = kt2,
                description = """Attack in seconds, default 0.01. Mirrors sprudel's `penv.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt109,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `penvCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt110,
                type = kt2,
                description = """Cutoff-envelope attack in seconds. Mirrors sprudel's `hpf.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt111,
                type = kt2,
                description = """Cutoff-envelope attack in seconds. Mirrors sprudel's `bpf.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt112,
                type = kt2,
                description = """Cutoff-envelope attack in seconds. Mirrors sprudel's `notch.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt113,
                type = kt2,
                description = """Cutoff-envelope attack in seconds. Mirrors sprudel's `lpf.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt104,
                type = kt2,
                description = """Attack in seconds, default 0.01. Mirrors sprudel's `adsr.attack`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt105,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `adsrCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt114,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `hpfCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt115,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `bpfCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt116,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `notchCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt117,
                type = kt2,
                description = """The attack's curve as its index in the curve list, default `exp`. Mirrors sprudel's `lpfCurves(attack = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt118,
                type = kt4,
                description = """`compressor.attack`. How fast the gain closes, in seconds.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "attack",
                owner = kt119,
                type = kt4,
                description = """`duck.attack`. How fast the duck closes, in seconds.""",
                library = "stdlib",
            )
        )
    ),

    "bipolar" to KlangSymbol(
        name = "bipolar",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "bipolar",
                owner = kt103,
                type = kt2,
                description = """Open `bipolar` slot (default 0.0): above 0.5 every pop takes a random sign. Used by dust.""",
                library = "stdlib",
            )
        )
    ),

    "bits" to KlangSymbol(
        name = "bits",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "bits",
                owner = kt120,
                type = kt2,
                description = """Bit depth, default 0 (off; below 1 the stage passes through). Mirrors sprudel's `crush.bits`.""",
                library = "stdlib",
            )
        )
    ),

    "body" to KlangSymbol(
        name = "body",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "body",
                owner = kt121,
                type = kt122,
                description = """The body stage's knobs: `material`, `wet`, `floor`.""",
                library = "stdlib",
            )
        )
    ),

    "bpf" to KlangSymbol(
        name = "bpf",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "bpf",
                owner = kt103,
                type = kt111,
                description = """The bandpass stage's slots: `freq`, `q`, `env`, `attack`, `decay`, `sustain`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "bpfCurves" to KlangSymbol(
        name = "bpfCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "bpfCurves",
                owner = kt103,
                type = kt115,
                description = """The bandpass envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "brightness" to KlangSymbol(
        name = "brightness",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "brightness",
                owner = kt103,
                type = kt2,
                description = """Open `brightness` slot (default 0.5). Used by pluck.""",
                library = "stdlib",
            )
        )
    ),

    "cap" to KlangSymbol(
        name = "cap",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "cap",
                owner = kt123,
                type = kt4,
                description = """`delay.cap`. The soft cap of the recirculating line.""",
                library = "stdlib",
            )
        )
    ),

    "center" to KlangSymbol(
        name = "center",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "center",
                owner = kt124,
                type = kt4,
                description = """`phaser.center`. Center frequency of the sweep in Hz.""",
                library = "stdlib",
            )
        )
    ),

    "chaos" to KlangSymbol(
        name = "chaos",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "chaos",
                owner = kt103,
                type = kt2,
                description = """Open `chaos` slot (default 1.5): the crackle map's drive, about 1 sparse to 2 dense. Used by crackle; sprudel's `sndCrackle(chaos)` writes it.""",
                library = "stdlib",
            )
        )
    ),

    "coarse" to KlangSymbol(
        name = "coarse",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "coarse",
                owner = kt103,
                type = kt125,
                description = """The coarse stage's slot: `Ignitor.slot.coarse.factor`.""",
                library = "stdlib",
            )
        )
    ),

    "color" to KlangSymbol(
        name = "color",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "color",
                owner = kt103,
                type = kt2,
                description = """Open `color` slot (default 0.0): the spectral tilt, -1 to 1, 0 flat. Used by whitenoise; sprudel's `sndNoise(color)` writes it.""",
                library = "stdlib",
            )
        )
    ),

    "compressor" to KlangSymbol(
        name = "compressor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "compressor",
                owner = kt121,
                type = kt118,
                description = """The compressor stage's knobs: `threshold`, `ratio`, `knee`, `attack`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "crush" to KlangSymbol(
        name = "crush",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "crush",
                owner = kt103,
                type = kt120,
                description = """The crush stage's slot: `Ignitor.slot.crush.bits`.""",
                library = "stdlib",
            )
        )
    ),

    "decay" to KlangSymbol(
        name = "decay",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "decay",
                owner = kt107,
                type = kt2,
                description = """The depth envelope's decay in seconds, default 0. Mirrors sprudel's `fm.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt108,
                type = kt2,
                description = """Decay in seconds, default 0.1. Mirrors sprudel's `penv.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt109,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `penvCurves(decay = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt110,
                type = kt2,
                description = """Cutoff-envelope decay in seconds. Mirrors sprudel's `hpf.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt111,
                type = kt2,
                description = """Cutoff-envelope decay in seconds. Mirrors sprudel's `bpf.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt112,
                type = kt2,
                description = """Cutoff-envelope decay in seconds. Mirrors sprudel's `notch.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt113,
                type = kt2,
                description = """Cutoff-envelope decay in seconds. Mirrors sprudel's `lpf.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt104,
                type = kt2,
                description = """Decay in seconds, default 0.1. Mirrors sprudel's `adsr.decay`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt105,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `adsrCurves(decay = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt114,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `hpfCurves(decay = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt115,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `bpfCurves(decay = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt116,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `notchCurves(decay = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "decay",
                owner = kt117,
                type = kt2,
                description = """The decay's curve, default `exp`. Mirrors sprudel's `lpfCurves(decay = ...)`.""",
                library = "stdlib",
            )
        )
    ),

    "declick" to KlangSymbol(
        name = "declick",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "declick",
                owner = kt103,
                type = kt2,
                description = """Open `declick` slot (default 0.0, off): the envelope's de-click one-pole, in seconds. Every authored
 `adsr` reads it unless its builder sets `declick(...)`; no sprudel door writes it (`classic()`'s envelope
 de-clicks with a constant instead).""",
                library = "stdlib",
            )
        )
    ),

    "delay" to KlangSymbol(
        name = "delay",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "delay",
                owner = kt121,
                type = kt123,
                description = """The delay stage's knobs: `wet`, `time`, `feedback`, `cap`.""",
                library = "stdlib",
            )
        )
    ),

    "density" to KlangSymbol(
        name = "density",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "density",
                owner = kt103,
                type = kt2,
                description = """Open `density` slot (default 0.2). Used by dust / crackle.""",
                library = "stdlib",
            )
        )
    ),

    "depth" to KlangSymbol(
        name = "depth",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "depth",
                owner = kt107,
                type = kt2,
                description = """The peak modulation in Hz, default 0 (off: no FM). Mirrors sprudel's `fm.depth`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "depth",
                owner = kt126,
                type = kt2,
                description = """Depth, default 0 (off). Mirrors sprudel's `tremolo.depth`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "depth",
                owner = kt119,
                type = kt4,
                description = """`duck.depth`. How far this orbit is pulled down, default 0.""",
                library = "stdlib",
            )
        )
    ),

    "distort" to KlangSymbol(
        name = "distort",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "distort",
                owner = kt103,
                type = kt106,
                description = """The distort stage's slots: `amount` and `shape`.""",
                library = "stdlib",
            )
        )
    ),

    "duck" to KlangSymbol(
        name = "duck",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "duck",
                owner = kt121,
                type = kt119,
                description = """The duck stage's knobs: `orbit`, `depth`, `attack`.""",
                library = "stdlib",
            )
        )
    ),

    "duty" to KlangSymbol(
        name = "duty",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "duty",
                owner = kt103,
                type = kt2,
                description = """Open `duty` slot (default 0.5). Used by pulze.""",
                library = "stdlib",
            )
        )
    ),

    "env" to KlangSymbol(
        name = "env",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "env",
                owner = kt110,
                type = kt2,
                description = """Cutoff-envelope depth in semitones, default unset. Mirrors sprudel's `hpf.env`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "env",
                owner = kt111,
                type = kt2,
                description = """Cutoff-envelope depth in semitones, default unset. Mirrors sprudel's `bpf.env`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "env",
                owner = kt112,
                type = kt2,
                description = """Cutoff-envelope depth in semitones, default unset. Mirrors sprudel's `notch.env`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "env",
                owner = kt113,
                type = kt2,
                description = """Cutoff-envelope depth in semitones, default unset. Mirrors sprudel's `lpf.env`.""",
                library = "stdlib",
            )
        )
    ),

    "factor" to KlangSymbol(
        name = "factor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "factor",
                owner = kt125,
                type = kt2,
                description = """Sample-hold factor, default 0 (off; at 1 or less nothing is held). Mirrors sprudel's `coarse.factor`.""",
                library = "stdlib",
            )
        )
    ),

    "feedback" to KlangSymbol(
        name = "feedback",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "feedback",
                owner = kt103,
                type = kt2,
                description = """Open `feedback` slot (default 0.996): the loop feedback per pass, 0.9 to 0.999. Used by pluck.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "feedback",
                owner = kt123,
                type = kt4,
                description = """`delay.feedback`. Feedback amount, default 0.""",
                library = "stdlib",
            )
        )
    ),

    "floor" to KlangSymbol(
        name = "floor",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "floor",
                owner = kt122,
                type = kt4,
                description = """`body.floor`. The broadband floor under the modes.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "floor",
                owner = kt127,
                type = kt4,
                description = """`vowel.floor`. The dry floor of the formant bank.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "floor",
                owner = kt124,
                type = kt4,
                description = """`phaser.floor`. Minimum dry share.""",
                library = "stdlib",
            )
        )
    ),

    "fm" to KlangSymbol(
        name = "fm",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "fm",
                owner = kt103,
                type = kt107,
                description = """The FM stage's slots: `ratio`, `depth` (the switch), `attack`, `decay`, `sustain`, `release`. A pitch stage of
 `classic()`, the innermost, so the other pitch stages move carrier and modulator together. Place it yourself with
 `fm(Ignitor.sine(x => x.analog(0)), Ignitor.slot.fm.ratio, Ignitor.slot.fm.depth, x => x.adsr(Ignitor.slot.fm.attack,
 Ignitor.slot.fm.decay, Ignitor.slot.fm.sustain, Ignitor.slot.fm.release))`.""",
                library = "stdlib",
            )
        )
    ),

    "freq" to KlangSymbol(
        name = "freq",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "freq",
                owner = kt110,
                type = kt2,
                description = """Cutoff in Hz, default unset (no filter). Mirrors sprudel's `hpf.freq`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "freq",
                owner = kt111,
                type = kt2,
                description = """Center in Hz, default unset (no filter). Mirrors sprudel's `bpf.freq`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "freq",
                owner = kt112,
                type = kt2,
                description = """Center in Hz, default unset (no filter). Mirrors sprudel's `notch.freq`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "freq",
                owner = kt113,
                type = kt2,
                description = """Cutoff in Hz, default unset (no filter). Mirrors sprudel's `lpf.freq`.""",
                library = "stdlib",
            )
        )
    ),

    "gain" to KlangSymbol(
        name = "gain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "gain",
                owner = kt121,
                type = kt128,
                description = """The gain stage's knobs: `gain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "gain",
                owner = kt128,
                type = kt4,
                description = """`gain.gain`. The orbit's group fader, default 1 (unity). The stage `gain`, its knob `gain`: `Katalyst.slot.gain.gain` reads oddly and is right.""",
                library = "stdlib",
            )
        )
    ),

    "hpf" to KlangSymbol(
        name = "hpf",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "hpf",
                owner = kt103,
                type = kt110,
                description = """The highpass stage's slots: `freq`, `q`, `passes`, `env`, `attack`, `decay`, `sustain`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "hpfCurves" to KlangSymbol(
        name = "hpfCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "hpfCurves",
                owner = kt103,
                type = kt114,
                description = """The highpass envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "knee" to KlangSymbol(
        name = "knee",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "knee",
                owner = kt118,
                type = kt4,
                description = """`compressor.knee`. Soft-knee width in dB.""",
                library = "stdlib",
            )
        )
    ),

    "leak" to KlangSymbol(
        name = "leak",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "leak",
                owner = kt103,
                type = kt2,
                description = """Open `leak` slot (default 0.02): the per-sample white leak, lower is deeper. Used by brownnoise; sprudel's `sndBrown(leak)` writes it.""",
                library = "stdlib",
            )
        )
    ),

    "lowpass" to KlangSymbol(
        name = "lowpass",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "lowpass",
                owner = kt129,
                type = kt4,
                description = """`reverb.lowpass`. Damping of the tail as a lowpass cutoff in Hz, default unset (undamped).""",
                library = "stdlib",
            )
        )
    ),

    "lpf" to KlangSymbol(
        name = "lpf",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "lpf",
                owner = kt103,
                type = kt113,
                description = """The lowpass stage's slots: `freq`, `q`, `passes`, `env`, `attack`, `decay`, `sustain`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "lpfCurves" to KlangSymbol(
        name = "lpfCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "lpfCurves",
                owner = kt103,
                type = kt117,
                description = """The lowpass envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "material" to KlangSymbol(
        name = "material",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "material",
                owner = kt122,
                type = kt4,
                description = """`body.material`. The material as its INDEX in the catalogue, default unset (no body). What `body(material = ...)` writes.""",
                library = "stdlib",
            )
        )
    ),

    "notch" to KlangSymbol(
        name = "notch",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "notch",
                owner = kt103,
                type = kt112,
                description = """The notch stage's slots: `freq`, `q`, `env`, `attack`, `decay`, `sustain`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "notchCurves" to KlangSymbol(
        name = "notchCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "notchCurves",
                owner = kt103,
                type = kt116,
                description = """The notch envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "octaves" to KlangSymbol(
        name = "octaves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "octaves",
                owner = kt103,
                type = kt2,
                description = """Open `octaves` slot (default 1.0): the fBm octaves, 1 plain, the engine caps at 8. Used by perlin / berlin noise.""",
                library = "stdlib",
            )
        )
    ),

    "on" to KlangSymbol(
        name = "on",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "on",
                owner = kt104,
                type = kt2,
                description = """The envelope's switch, default 1 (on); 0 is off. What sprudel's `adsrOn()` / `adsrOff()` write.""",
                library = "stdlib",
            )
        )
    ),

    "onepole" to KlangSymbol(
        name = "onepole",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "onepole",
                owner = kt103,
                type = kt2,
                description = """The one-pole lowpass stage's slot (default 0.0, off): the cutoff in Hz that the pattern's `onepole(hz)`
 writes. `classic()`'s first amplitude stage, behind the pitch stages.""",
                library = "stdlib",
            )
        )
    ),

    "orbit" to KlangSymbol(
        name = "orbit",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "orbit",
                owner = kt119,
                type = kt4,
                description = """`duck.orbit`. The orbit to listen to, default unset (no ducking).""",
                library = "stdlib",
            )
        )
    ),

    "passes" to KlangSymbol(
        name = "passes",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "passes",
                owner = kt110,
                type = kt2,
                description = """Cascade count, default 1. Mirrors sprudel's `hpf.passes`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "passes",
                owner = kt113,
                type = kt2,
                description = """Cascade count, default 1. Mirrors sprudel's `lpf.passes`.""",
                library = "stdlib",
            )
        )
    ),

    "penv" to KlangSymbol(
        name = "penv",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "penv",
                owner = kt103,
                type = kt108,
                description = """The pitch envelope stage's slots: `semitones` (the switch), `attack`, `decay`, `sustain`, `release`. Around the FM stage.""",
                library = "stdlib",
            )
        )
    ),

    "penvCurves" to KlangSymbol(
        name = "penvCurves",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "penvCurves",
                owner = kt103,
                type = kt109,
                description = """The pitch envelope's curve slots: `attack`, `decay`, `release`.""",
                library = "stdlib",
            )
        )
    ),

    "persistence" to KlangSymbol(
        name = "persistence",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "persistence",
                owner = kt103,
                type = kt2,
                description = """Open `persistence` slot (default 0.5): the fBm amplitude falloff per octave, 0 to 1. Used by perlin / berlin noise.""",
                library = "stdlib",
            )
        )
    ),

    "phase" to KlangSymbol(
        name = "phase",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "phase",
                owner = kt130,
                type = kt2,
                description = """The LFO's phase as a fraction of one cycle, default 0. Mirrors sprudel's `vibrato.phase`.""",
                library = "stdlib",
            )
        )
    ),

    "phaser" to KlangSymbol(
        name = "phaser",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "phaser",
                owner = kt121,
                type = kt124,
                description = """The phaser stage's knobs: `rate`, `wet`, `center`, `sweep`, `floor`.""",
                library = "stdlib",
            )
        )
    ),

    "pickPosition" to KlangSymbol(
        name = "pickPosition",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "pickPosition",
                owner = kt103,
                type = kt2,
                description = """Open `pickPosition` slot (default 0.5). Used by pluck.""",
                library = "stdlib",
            )
        )
    ),

    "pregain" to KlangSymbol(
        name = "pregain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "pregain",
                owner = kt103,
                type = kt2,
                description = """Open `pregain` slot (default 1.0): how hard the pattern plays INTO the instrument, the
 level at which the signal meets the instrument's first nonlinearity. Mirrors sprudel
 `.pregain(x)`.

 An ordinary slot, so it does what the tree wires it to and nothing otherwise: an instrument
 that never places it ignores `pregain(x)` bit for bit. `.pregain()` is the short spelling
 of `.mul(Ignitor.slot.pregain)`, and the place to put it is in front of the nonlinearity it
 should drive:

 ```
 Ignitor.saw().pregain().distort(0.5)   // play harder, get dirtier
 ```

 It changes TIMBRE only where something nonlinear follows it AND that nonlinearity still has
 somewhere to go. With nothing nonlinear after it, it is just a level; on a CLIPPING shape
 already in hard saturation it is neither, because a clipper holds the tone and the level
 alike. The tone-neutral level word is `gain`, the channel fader after the whole instrument.

 The wavefolders (`fold`, `linearfold`, `sineshaper`) never saturate, so there this slot is
 the fold depth and the strongest tone knob at any drive, and turning it down can make the
 sound louder rather than quieter.""",
                library = "stdlib",
            )
        )
    ),

    "q" to KlangSymbol(
        name = "q",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "q",
                owner = kt110,
                type = kt2,
                description = """Resonance, default 0.707. Mirrors sprudel's `hpf.q`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "q",
                owner = kt111,
                type = kt2,
                description = """Resonance, default 0.707. Mirrors sprudel's `bpf.q`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "q",
                owner = kt112,
                type = kt2,
                description = """Resonance, default 0.707. Mirrors sprudel's `notch.q`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "q",
                owner = kt113,
                type = kt2,
                description = """Resonance, default 0.707. Mirrors sprudel's `lpf.q`.""",
                library = "stdlib",
            )
        )
    ),

    "rangeFrom" to KlangSymbol(
        name = "rangeFrom",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "rangeFrom",
                owner = kt130,
                type = kt2,
                description = """Where the LFO's low point lands, default -1 (both ways with `rangeTo` 1). Mirrors sprudel's `vibrato.rangeFrom`.""",
                library = "stdlib",
            )
        )
    ),

    "rangeTo" to KlangSymbol(
        name = "rangeTo",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "rangeTo",
                owner = kt130,
                type = kt2,
                description = """Where the LFO's high point lands, default 1. Mirrors sprudel's `vibrato.rangeTo`.""",
                library = "stdlib",
            )
        )
    ),

    "rate" to KlangSymbol(
        name = "rate",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "rate",
                owner = kt130,
                type = kt2,
                description = """The LFO rate in Hz, default 5. Mirrors sprudel's `vibrato.rate`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "rate",
                owner = kt126,
                type = kt2,
                description = """The LFO rate in Hz, default 0. Mirrors sprudel's `tremolo.rate`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "rate",
                owner = kt103,
                type = kt2,
                description = """Open `rate` slot (default 1.0). Used by perlin / berlin noise.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "rate",
                owner = kt124,
                type = kt4,
                description = """`phaser.rate`. Sweep rate in Hz.""",
                library = "stdlib",
            )
        )
    ),

    "ratio" to KlangSymbol(
        name = "ratio",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "ratio",
                owner = kt107,
                type = kt2,
                description = """The modulator's frequency as a multiple of the note, default 1. Mirrors sprudel's `fm.ratio`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "ratio",
                owner = kt118,
                type = kt4,
                description = """`compressor.ratio`. Compression ratio above the threshold.""",
                library = "stdlib",
            )
        )
    ),

    "release" to KlangSymbol(
        name = "release",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "release",
                owner = kt107,
                type = kt2,
                description = """The depth envelope's release in seconds, after the gate, default 0. Mirrors sprudel's `fm.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt108,
                type = kt2,
                description = """Release in seconds from the gate, default 0. Mirrors sprudel's `penv.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt109,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `penvCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt110,
                type = kt2,
                description = """Cutoff-envelope release in seconds. Mirrors sprudel's `hpf.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt111,
                type = kt2,
                description = """Cutoff-envelope release in seconds. Mirrors sprudel's `bpf.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt112,
                type = kt2,
                description = """Cutoff-envelope release in seconds. Mirrors sprudel's `notch.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt113,
                type = kt2,
                description = """Cutoff-envelope release in seconds. Mirrors sprudel's `lpf.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt104,
                type = kt2,
                description = """Release in seconds, default 0.05. Mirrors sprudel's `adsr.release`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt105,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `adsrCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt114,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `hpfCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt115,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `bpfCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt116,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `notchCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt117,
                type = kt2,
                description = """The release's curve, default `exp`. Mirrors sprudel's `lpfCurves(release = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "release",
                owner = kt118,
                type = kt4,
                description = """`compressor.release`. How fast the gain opens again, in seconds.""",
                library = "stdlib",
            )
        )
    ),

    "reverb" to KlangSymbol(
        name = "reverb",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "reverb",
                owner = kt121,
                type = kt129,
                description = """The reverb stage's knobs: `wet`, `size`, `lowpass`.""",
                library = "stdlib",
            )
        )
    ),

    "semitones" to KlangSymbol(
        name = "semitones",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "semitones",
                owner = kt130,
                type = kt2,
                description = """The depth in semitones, default 0 (off: no vibrato). Mirrors sprudel's `vibrato.semitones`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "semitones",
                owner = kt108,
                type = kt2,
                description = """The pitch at the envelope's peak in semitones, default 0 (off: no envelope). Mirrors sprudel's `penv.semitones`.""",
                library = "stdlib",
            )
        )
    ),

    "shape" to KlangSymbol(
        name = "shape",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "shape",
                owner = kt106,
                type = kt2,
                description = """The waveshaper as its index in the shape list, default `soft`. Mirrors sprudel's `distort(shape = ...)`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "shape",
                owner = kt126,
                type = kt2,
                description = """The LFO shape as its index in the shape list, default `sine`. Mirrors sprudel's `tremolo(shape = ...)`.""",
                library = "stdlib",
            )
        )
    ),

    "size" to KlangSymbol(
        name = "size",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "size",
                owner = kt129,
                type = kt4,
                description = """`reverb.size`. Tail length, default 0 (off: the reverb engages on its size).""",
                library = "stdlib",
            )
        )
    ),

    "slot" to KlangSymbol(
        name = "slot",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "slot",
                owner = kt41,
                type = kt103,
                description = """The canonical open slots of a custom sound: `Ignitor.slot.analog`, `Ignitor.slot.voices`,
 `Ignitor.slot.lpf.freq` and the rest. Each is the same `IgnitorDsl.Param(name, default)` the built-in sounds
 use, so a custom sound that hands one to a knob opts in to sprudel's modulation of it (the `analog`, `voices`,
 `spread`, ... knobs on the oscillator builders). Without opting in, a custom sound ignores it. For
 example, `Ignitor.sine(x => x.analog(Ignitor.slot.analog))` is a sine whose drift follows sprudel's
 `analog`. `Ign.slot` is the same.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "slot",
                owner = kt42,
                type = kt121,
                description = """The knobs of the classic chain, one group per stage: `Katalyst.slot.reverb.wet`, `Katalyst.slot.gain.gain` and
 the rest, each the Katalyst param named `<stage>.<knob>` that `classic()` places. Hand one to `katp` instead of
 typing its name. `Kat.slot` is the same; the Kotlin door is `KatalystDsl.Slots`, the same objects.

 ```
 note("c3 e3 g3").s("supersaw").reverb(wet = 0.4).katp(Katalyst.slot.reverb.size, "<2 8>")
 ```""",
                library = "stdlib",
            )
        )
    ),

    "spread" to KlangSymbol(
        name = "spread",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "spread",
                owner = kt103,
                type = kt2,
                description = """Open `spread` slot (default 0.2). Used by super-oscillators.""",
                library = "stdlib",
            )
        )
    ),

    "stiffness" to KlangSymbol(
        name = "stiffness",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "stiffness",
                owner = kt103,
                type = kt2,
                description = """Open `stiffness` slot (default 0.0). Used by pluck.""",
                library = "stdlib",
            )
        )
    ),

    "sustain" to KlangSymbol(
        name = "sustain",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "sustain",
                owner = kt107,
                type = kt2,
                description = """The depth envelope's held share of `depth`, default 1. Mirrors sprudel's `fm.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt108,
                type = kt2,
                description = """The held share of `semitones`, default 0 (back on the note). Mirrors sprudel's `penv.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt110,
                type = kt2,
                description = """Cutoff-envelope sustain share. Mirrors sprudel's `hpf.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt111,
                type = kt2,
                description = """Cutoff-envelope sustain share. Mirrors sprudel's `bpf.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt112,
                type = kt2,
                description = """Cutoff-envelope sustain share. Mirrors sprudel's `notch.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt113,
                type = kt2,
                description = """Cutoff-envelope sustain share. Mirrors sprudel's `lpf.sustain`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "sustain",
                owner = kt104,
                type = kt2,
                description = """Sustain level, default 1.0. Mirrors sprudel's `adsr.sustain`.""",
                library = "stdlib",
            )
        )
    ),

    "sweep" to KlangSymbol(
        name = "sweep",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "sweep",
                owner = kt124,
                type = kt4,
                description = """`phaser.sweep`. Width of the sweep in Hz.""",
                library = "stdlib",
            )
        )
    ),

    "tail" to KlangSymbol(
        name = "tail",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "tail",
                owner = kt103,
                type = kt2,
                description = """Open `tail` slot (default 1.0): the amplitude exponent, above 1 mostly tiny pops and rare loud ones. Used by dust; sprudel's `sndDust` writes it.""",
                library = "stdlib",
            )
        )
    ),

    "threshold" to KlangSymbol(
        name = "threshold",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "threshold",
                owner = kt118,
                type = kt4,
                description = """`compressor.threshold`. Ceiling in dBFS where gain reduction starts.""",
                library = "stdlib",
            )
        )
    ),

    "time" to KlangSymbol(
        name = "time",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "time",
                owner = kt123,
                type = kt4,
                description = """`delay.time`. Delay time in seconds, default 0 (off: the delay engages on its time).""",
                library = "stdlib",
            )
        )
    ),

    "tremolo" to KlangSymbol(
        name = "tremolo",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "tremolo",
                owner = kt103,
                type = kt126,
                description = """The tremolo stage's slots: `depth`, `rate`, `shape`.""",
                library = "stdlib",
            )
        )
    ),

    "vibrato" to KlangSymbol(
        name = "vibrato",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "vibrato",
                owner = kt103,
                type = kt130,
                description = """The vibrato stage's slots: `rate`, `semitones` (the switch), `rangeFrom`, `rangeTo`, `phase`. A pitch stage of
 `classic()`, outside the accelerate.""",
                library = "stdlib",
            )
        )
    ),

    "voices" to KlangSymbol(
        name = "voices",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "voices",
                owner = kt103,
                type = kt2,
                description = """Open `voices` slot (default 8.0). Used by super-oscillators.""",
                library = "stdlib",
            )
        )
    ),

    "vowel" to KlangSymbol(
        name = "vowel",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "vowel",
                owner = kt121,
                type = kt127,
                description = """The vowel stage's knobs: `vowel`, `wet`, `floor`.""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "vowel",
                owner = kt127,
                type = kt4,
                description = """`vowel.vowel`. The vowel as its INDEX in the catalogue, default unset (no vowel). What `vowel(vowel = ...)` writes.""",
                library = "stdlib",
            )
        )
    ),

    "wet" to KlangSymbol(
        name = "wet",
        category = "uncategorized",
        tags = listOf(),
        aliases = listOf(),
        origin = KlangSymbol.Origin.Library("stdlib"),
        variants = listOf(
            KlangProperty(
                name = "wet",
                owner = kt122,
                type = kt4,
                description = """`body.wet`. How much of the orbit runs through the body, default unset (the engine's `BODY_WET` once a material is set).""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "wet",
                owner = kt127,
                type = kt4,
                description = """`vowel.wet`. How much of the orbit runs through the formant bank, default unset (the engine's `VOWEL_WET` once a vowel is set).""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "wet",
                owner = kt123,
                type = kt4,
                description = """`delay.wet`. How much of the orbit goes into the delay, default 0 (off).""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "wet",
                owner = kt129,
                type = kt4,
                description = """`reverb.wet`. How much of the orbit goes into the reverb, default 0 (off).""",
                library = "stdlib",
            ),
            KlangProperty(
                name = "wet",
                owner = kt124,
                type = kt4,
                description = """`phaser.wet`. Wet amount, default 0 (off).""",
                library = "stdlib",
            )
        )
    )
)

/** Generated documentation for the 'stdlib' library. */
val generatedStdlibDocs: Map<String, KlangSymbol> = buildMap {
    // Use putOrMerge so chunked emissions (e.g. a member-property variant and a
    // same-name extension method) merge their variants instead of overwriting.
    generatedStdlibDocsObjects().values.forEach(::putOrMerge)
    generatedStdlibDocsProperties().values.forEach(::putOrMerge)
    generatedStdlibDocsMemberProperties().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk0().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk1().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk2().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk3().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk4().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk5().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk6().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk7().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk8().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk9().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk10().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk11().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk12().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk13().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk14().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk15().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk16().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk17().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk18().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk19().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk20().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk21().values.forEach(::putOrMerge)
    generatedStdlibDocsChunk22().values.forEach(::putOrMerge)
}
